{
  "__schema": {
    "queryType": {
      "name": "Query",
      "kind": "OBJECT"
    },
    "mutationType": {
      "name": "Mutation",
      "kind": "OBJECT"
    },
    "subscriptionType": {
      "name": "Subscription",
      "kind": "OBJECT"
    },
    "types": [
      {
        "kind": "INPUT_OBJECT",
        "name": "AIGenInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "data",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AcceptQuoteInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "fileIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": "[]",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ActAsUser",
        "description": "displayName=ActAsUser\ndefaultQuery=actAsUsers\naggregateQuery=actAsUsersAggregate\ngrouping=true\nqueryPermission=Act_As_User\nconditionalPolicyPermissions=Admin_Act_As_User",
        "isOneOf": null,
        "fields": [
          {
            "name": "allPermissions",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "AssignedPermissionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AssignedPermission",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "allScreens",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Screen",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedRoles",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RoleUserFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "RoleUser",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "authProvider",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "authProviderUid",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branch",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Branch",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "email",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "firebaseAuthId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "fullName",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "hasPin",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "identities",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "UserIdentityFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UserIdentity",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "inheritedPermissions",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "AssignedPermissionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AssignedPermission",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "inheritedScreens",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Screen",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "initials",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isActive",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ownPermissions",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "AssignedPermissionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AssignedPermission",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ownScreens",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Screen",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roles",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Role",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "timers",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTimerFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProcessTimer",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "username",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ActAsUserAggregate",
        "description": "",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ActAsUserFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ActAsUserFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedRoles",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RoleUserFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "authProvider",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "authProviderUid",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branch",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BranchFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "email",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "fullName",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "hasPersonIdentity",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "hasPin",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "identities",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserIdentityFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeSystem",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isActive",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isCurrent",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "oldRoles",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserRoleFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ActAsUserFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reviewedSuppliers",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SupplierFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "timers",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessTimerFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "username",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AmendPurchaseOrderInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "PurchaseOrderLineInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrderId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Asset",
        "description": "description=An asset, such as a machine, that can be assigned to a manufacturing process.\ndisplayName=Asset\nmodule=Manufacturing\ndefaultQuery=assets\niconName=cog\ncolour=#A96500\naggregateQuery=assetsAggregate\ngrouping=true\nqueryPermission=Query_Assets",
        "isOneOf": null,
        "fields": [
          {
            "name": "assetType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "AssetAggregate",
        "description": "description=An asset, such as a machine, that can be assigned to a manufacturing process.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AssetFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "AssetFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assetType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "AssetFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AssignBusinessRolesToBatchScheduleInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "batchScheduleId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "personBusinessRoleIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AssignBusinessRolesToPersonInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "businessRoleIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "personId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AssignInheritanceToRoleInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "parentRoleIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AssignLeadsToSalespersonInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "leadIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salespersonId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AssignPermissionsToRoleInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "permissions",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "PermissionInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AssignPermissionsToUserInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "permissions",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "PermissionInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AssignRolesToUserInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "roleIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AssignScreensToRoleInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "roleId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screenIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AssignScreensToUserInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "screenIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AssignUsersToRoleInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "roleId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "AssignedPermission",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "conditions",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "originalId",
            "description": "Useful for getting the underlying UserPermission or RolePermission ID,\neg when wanting to unassign it.",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "permission",
            "description": "sortable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Permission",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "policy",
            "description": "sortable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "Policy",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "role",
            "description": "TODO: Use batching",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Role",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "subjectId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "subjectName",
            "description": "sortable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AssignedPermissionFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "role",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RoleFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "AsyncTask",
        "description": "description=The status and result of a background task.\ndisplayName=Async Task\nmodule=Admin\ndefaultQuery=asyncTasks\niconName=time\ncolour=#5D35A6\naggregateQuery=asyncTasksAggregate\ngrouping=true\nqueryPermission=Query_Async_Tasks",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "payload",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "AsyncTaskAggregate",
        "description": "description=The status and result of a background task.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AsyncTaskFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "AsyncTaskFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "AsyncTaskFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "payload",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "AttachmentTemplate",
        "description": "description=An attachment configuration belonging to a subscription notification template.\ndisplayName=Attachment Template\nmodule=Admin\ndefaultQuery=attachmentTemplates\niconName=paperclip\ncolour=#5D35A6\naggregateQuery=attachmentTemplatesAggregate\ngrouping=true\nqueryPermission=Query_Attachment_Templates",
        "isOneOf": null,
        "fields": [
          {
            "name": "bodyTemplateId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "fileName",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notificationTemplate",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "NotificationTemplate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "AttachmentTemplateAggregate",
        "description": "description=An attachment configuration belonging to a subscription notification template.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AttachmentTemplateFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "AttachmentTemplateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "bodyTemplateId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "fileName",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notificationTemplate",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NotificationTemplateFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "AttachmentTemplateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "AuditLog",
        "description": "description=A recorded domain event linked to the user and record that triggered it.\ndisplayName=Audit Log\nmodule=Admin\ndefaultQuery=auditLogs\niconName=history\ncolour=#5D35A6\naggregateQuery=auditLogsAggregate\ngrouping=true\nqueryPermission=Query_Audit_Logs",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "event",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AuditLogFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "AuditLogFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "event",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "AuditLogFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userIdentity",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserIdentityFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "AuthProviderType",
        "description": null,
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "emailPassword",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "legacy",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "microsoft",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Batch",
        "description": "description=A manufacturing batch grouping work to be scheduled and produced together.\ndisplayName=Batch\nmodule=Manufacturing\ndefaultQuery=batches\niconName=layers\ncolour=#A96500\naggregateQuery=batchesAggregate\ngrouping=true\nqueryPermission=Query_Batches",
        "isOneOf": null,
        "fields": [
          {
            "name": "batchNumber",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "benchtopSupplier",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branch",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Branch",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "cubicMetres",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "installationHours",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Job",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemAggregate",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LineItemFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "LineItemAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItems",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LineItemFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "LineItem",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "schedules",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "BatchScheduleFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "BatchSchedule",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sheets",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BatchAggregate",
        "description": "description=A manufacturing batch grouping work to be scheduled and produced together.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sheetCount",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BatchCreatedEvent",
        "description": "Batch",
        "isOneOf": null,
        "fields": [
          {
            "name": "batchId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "batchName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BatchDeletedEvent",
        "description": "Batch",
        "isOneOf": null,
        "fields": [
          {
            "name": "batchId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "batchName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "BatchFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "BatchFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "batchNumber",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "benchtopSupplier",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branch",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BranchFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "cubicMetres",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "installationHours",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItems",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LineItemFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "BatchFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "schedules",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BatchScheduleFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sheets",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BatchRecalculateDueDateEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "batchId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BatchReportDimensionValue",
        "description": "A Batch identity or a typed nested report dimension.",
        "isOneOf": null,
        "fields": [
          {
            "name": "branch",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "BranchReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "JobReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "key",
            "description": "Stable machine-readable Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "Display label for the Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "BatchReportGroupByInput",
        "description": "Select exactly one typed Batch report dimension.",
        "isOneOf": true,
        "fields": null,
        "inputFields": [
          {
            "name": "branch",
            "description": "Group by Branch or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BranchReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": "Group by Job or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "BatchReportRelationDimensionInput",
        "description": "Groups by Batch identity, or traverses to one of its typed dimensions.",
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "filter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BatchFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groupBy",
            "description": "Traverse through this relation and group by a field or relation on the related Resource.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BatchReportGroupByInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeEmpty",
            "description": "Include filtered related records that have no contributing resource rows.",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BatchSchedule",
        "description": "description=A scheduled manufacturing batch for a specific process type.\ndisplayName=Batch Schedule\nmodule=Manufacturing\ndefaultQuery=batchSchedules\niconName=calendar-days\ncolour=#A96500\naggregateQuery=batchSchedulesAggregate\nreportQuery=batchScheduleReport\ngrouping=true\nqueryPermission=Query_Batch_Schedules",
        "isOneOf": null,
        "fields": [
          {
            "name": "batch",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Batch",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "dueDate",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processInstances",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessInstanceFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProcessInstance",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processType",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessType",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "scheduled",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BatchScheduleAggregate",
        "description": "description=A scheduled manufacturing batch for a specific process type.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sheetCount",
            "description": "description=Total batch sheets across matching schedules. Filter by process type to count that process workload.\nsortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "totalConfirmedSale",
            "description": "description=Confirmed line-item sale value across matching schedules, grouped by schedule date rather than confirmation date. Each process schedule contributes its batch value.\npermission=Report_Confirmed_Sales\nsortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "BatchScheduleFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "BatchScheduleFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "batch",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BatchFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "dueDate",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "BatchScheduleFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessTypeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "scheduled",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BatchScheduleReportDimensions",
        "description": "Typed Batch Schedule report dimension values.",
        "isOneOf": null,
        "fields": [
          {
            "name": "batch",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "BatchReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "dueDate",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processType",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessTypeReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "scheduled",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "BatchScheduleReportGroupByInput",
        "description": "Select exactly one typed Batch Schedule report dimension.",
        "isOneOf": true,
        "fields": null,
        "inputFields": [
          {
            "name": "batch",
            "description": "Group by Batch or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BatchReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "dueDate",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeReportDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processType",
            "description": "Group by Process Type or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessTypeReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "scheduled",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeReportDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BatchScheduleReportRow",
        "description": "One grouped Batch Schedule report row.",
        "isOneOf": null,
        "fields": [
          {
            "name": "aggregate",
            "description": "The generated BatchSchedule aggregate, constrained to this dimension row.",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "BatchScheduleFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "BatchScheduleAggregate",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "dimensions",
            "description": "Typed values for every selected report dimension.",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "BatchScheduleReportDimensions",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "key",
            "description": "The first dimension key, retained for single-dimension report compatibility.",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "The first dimension label, retained for single-dimension report compatibility.",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BatchStatusCheckEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "batchId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BatchUpdatedEvent",
        "description": "Batch",
        "isOneOf": null,
        "fields": [
          {
            "name": "batchId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "batchName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BillOfMaterialsImport",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "externalStorageConnection",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ExternalStorageConnection",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "matchedItems",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "BillOfMaterialsLine",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "rawItems",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BillOfMaterialsLine",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "description",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "group",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "price",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "product",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Product",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "room",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "SCALAR",
        "name": "Boolean",
        "description": "The `Boolean` scalar type represents `true` or `false`.",
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "BooleanFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "eq",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Branch",
        "description": "description=A company branch or location used to organise jobs, users, and operations.\ndisplayName=Branch\nmodule=Admin\ndefaultQuery=branches\niconName=office\ncolour=#5D35A6\naggregateQuery=branchesAggregate\ngrouping=true\nqueryPermission=Query_Branches",
        "isOneOf": null,
        "fields": [
          {
            "name": "code",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "colour",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "darkColour",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobAggregate",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "JobFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "JobAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "personAggregate",
            "description": "description=The number of people assigned to this branch.\nsortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PersonFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PersonAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "users",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "UserFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "User",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BranchAggregate",
        "description": "description=A company branch or location used to organise jobs, users, and operations.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BranchCreatedEvent",
        "description": "Branch",
        "isOneOf": null,
        "fields": [
          {
            "name": "branchId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branchName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BranchDeletedEvent",
        "description": "Branch",
        "isOneOf": null,
        "fields": [
          {
            "name": "branchId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branchName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "BranchFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "BranchFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "colour",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "darkColour",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "BranchFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "users",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BranchReportDimensionValue",
        "description": "A Branch identity or a typed nested report dimension.",
        "isOneOf": null,
        "fields": [
          {
            "name": "key",
            "description": "Stable machine-readable Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "Display label for the Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "BranchReportRelationDimensionInput",
        "description": "Groups by Branch identity, or traverses to one of its typed dimensions.",
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "filter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BranchFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeEmpty",
            "description": "Include filtered related records that have no contributing resource rows.",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BranchRestoredEvent",
        "description": "Branch",
        "isOneOf": null,
        "fields": [
          {
            "name": "branchId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branchName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BranchUpdatedEvent",
        "description": "Branch",
        "isOneOf": null,
        "fields": [
          {
            "name": "branchId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branchName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BuildType",
        "description": "description=A sales classification describing the type of build for a job.\ndisplayName=Build Type\nmodule=Sales\ndefaultQuery=buildTypes\ncolour=#A91F54\naggregateQuery=buildTypesAggregate\ngrouping=true\nqueryPermission=Query_Build_Types",
        "isOneOf": null,
        "fields": [
          {
            "name": "code",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BuildTypeAggregate",
        "description": "description=A sales classification describing the type of build for a job.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "BuildTypeFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "BuildTypeFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "BuildTypeFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BuildTypeReportDimensionValue",
        "description": "A Build Type identity or a typed nested report dimension.",
        "isOneOf": null,
        "fields": [
          {
            "name": "key",
            "description": "Stable machine-readable Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "Display label for the Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "BuildTypeReportRelationDimensionInput",
        "description": "Groups by Build Type identity, or traverses to one of its typed dimensions.",
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "filter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BuildTypeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeEmpty",
            "description": "Include filtered related records that have no contributing resource rows.",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Builder",
        "description": "description=A building company or builder associated with sales jobs.\ndisplayName=Builder\nmodule=Sales\ndefaultQuery=builders\niconName=inbox\ncolour=#A91F54\naggregateQuery=buildersAggregate\ngrouping=true\nqueryPermission=Query_Builders",
        "isOneOf": null,
        "fields": [
          {
            "name": "address",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BuilderAggregate",
        "description": "description=A building company or builder associated with sales jobs.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "BuilderFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "address",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "BuilderFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "BuilderFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BuilderReportDimensionValue",
        "description": "A Builder identity or a typed nested report dimension.",
        "isOneOf": null,
        "fields": [
          {
            "name": "key",
            "description": "Stable machine-readable Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "Display label for the Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "BuilderReportRelationDimensionInput",
        "description": "Groups by Builder identity, or traverses to one of its typed dimensions.",
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "filter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BuilderFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeEmpty",
            "description": "Include filtered related records that have no contributing resource rows.",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BusinessRole",
        "description": "description=A business role that describes how a person can be assigned to work.\ndisplayName=Business Role\nmodule=Admin\ndefaultQuery=businessRoles\niconName=briefcase\ncolour=#5D35A6\naggregateQuery=businessRolesAggregate\ngrouping=true\nqueryPermission=Query_Business_Roles",
        "isOneOf": null,
        "fields": [
          {
            "name": "activePersonBusinessRoleCount",
            "description": "description=The number of active people assigned this business role.\nsortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "personBusinessRoleAggregate",
            "description": "description=The number of current and historical assignments for this business role.\nsortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PersonBusinessRoleFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PersonBusinessRoleAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "personBusinessRoles",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PersonBusinessRoleFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "PersonBusinessRole",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BusinessRoleAggregate",
        "description": "description=A business role that describes how a person can be assigned to work.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "BusinessRoleFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "BusinessRoleFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "BusinessRoleFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "personBusinessRoles",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PersonBusinessRoleFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "BusinessRoleReportDimensionValue",
        "description": "A Business Role identity or a typed nested report dimension.",
        "isOneOf": null,
        "fields": [
          {
            "name": "key",
            "description": "Stable machine-readable Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "Display label for the Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "BusinessRoleReportRelationDimensionInput",
        "description": "Groups by Business Role identity, or traverses to one of its typed dimensions.",
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "filter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BusinessRoleFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeEmpty",
            "description": "Include filtered related records that have no contributing resource rows.",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CalculateQuoteInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "expressions",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ExpressionInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": "[]",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineTemplates",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "QuoteLineTemplateInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "QuoteLineInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CancelPurchaseOrdersInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "purchaseOrderIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CancelSalesOrderInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "salesOrderId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CancelSupplierQuoteRequestInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "supplierQuoteRequestId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Candidate",
        "description": "description=An AI-generated draft record awaiting review and approval.\ndisplayName=Candidate\nmodule=Sales\ndefaultQuery=candidates\ncolour=#A91F54\naggregateQuery=candidatesAggregate\ngrouping=true\nqueryPermission=Query_Candidates",
        "isOneOf": null,
        "fields": [
          {
            "name": "candidateTypeName",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "conversionErrors",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "generatedData",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "shortSummary",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "source",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "targetRecordId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "targetRecordType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "CandidateAggregate",
        "description": "description=An AI-generated draft record awaiting review and approval.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "CandidateCreatedEvent",
        "description": "Candidate",
        "isOneOf": null,
        "fields": [
          {
            "name": "candidateId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "shortSummary",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CandidateFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CandidateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "conversionErrors",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "generatedData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CandidateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "shortSummary",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "source",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "targetRecordId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "targetRecordType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "CandidateIngestionMode",
        "description": null,
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "autoConvert",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "disabled",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "manualReview",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "CandidateIngestionPolicy",
        "description": "description=Controls whether messages from an identified sender can create or automatically convert Candidates.\ndisplayName=CandidateIngestionPolicy\nmodule=Admin\ndefaultQuery=candidateIngestionPolicies\ncolour=#5D35A6\naggregateQuery=candidateIngestionPoliciesAggregate\ngrouping=true\nqueryPermission=Query_Candidate_Ingestion_Policies",
        "isOneOf": null,
        "fields": [
          {
            "name": "candidateType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "emailAddresses",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "mode",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "senderRecordId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "senderRecordType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "CandidateIngestionPolicyAggregate",
        "description": "description=Controls whether messages from an identified sender can create or automatically convert Candidates.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CandidateIngestionPolicyFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CandidateIngestionPolicyFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "candidateType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "mode",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CandidateIngestionPolicyFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "senderRecordId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "senderRecordType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Client",
        "description": "description=A customer or household contact associated with sales work.\ndisplayName=Client\nmodule=Sales\ndefaultQuery=clients\niconName=people\ncolour=#A91F54\naggregateQuery=clientsAggregate\ngrouping=true\nqueryPermission=Query_Clients",
        "isOneOf": null,
        "fields": [
          {
            "name": "address",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "email",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "faxHome",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "faxWork",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "firstName",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "fullName",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobs",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "JobFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Job",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lastName",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notes",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "phoneCell",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "phoneHome",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "phoneWork",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ClientAggregate",
        "description": "description=A customer or household contact associated with sales work.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ClientFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "address",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ClientFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "email",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "faxHome",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "faxWork",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "firstName",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "fullName",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobs",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lastName",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notes",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ClientFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "phoneCell",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "phoneHome",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "phoneWork",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ClientReportDimensionValue",
        "description": "A Client identity or a typed nested report dimension.",
        "isOneOf": null,
        "fields": [
          {
            "name": "key",
            "description": "Stable machine-readable Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "Display label for the Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ClientReportRelationDimensionInput",
        "description": "Groups by Client identity, or traverses to one of its typed dimensions.",
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "filter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ClientFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeEmpty",
            "description": "Include filtered related records that have no contributing resource rows.",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CommitPendingFilesInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "defaultFolderId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "files",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "FileInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "folderId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "uploadToken",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ComponentAction",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "action",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "colour",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "icon",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "index",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ComponentGridColumn",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "field",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "index",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sort",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ConfiguredLinkedAction",
        "description": "displayName=Shortcut\nmodule=Admin\ndefaultQuery=configuredLinkedActions\ncolour=#5D35A6\naggregateQuery=configuredLinkedActionsAggregate\ngrouping=true\nqueryPermission=Query_Configured_Linked_Actions",
        "isOneOf": null,
        "fields": [
          {
            "name": "actionId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "bindings",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "displayOrder",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "enabled",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isGlobal",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordPath",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleIds",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "seedRoleIds",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "seedUserIds",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "source",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userIds",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ConfiguredLinkedActionAggregate",
        "description": "",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ConfiguredLinkedActionFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "actionId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ConfiguredLinkedActionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "bindings",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "displayOrder",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "enabled",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isGlobal",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ConfiguredLinkedActionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordPath",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ConfirmSalesOrderInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "salesOrderId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ConvertLeadToJobInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "jobId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Correspondence",
        "description": "description=A note, email, phone call, or other correspondence item linked to a record.\ndisplayName=Correspondence\nmodule=Sales\ndefaultQuery=correspondence\niconName=comment\ncolour=#A91F54\naggregateQuery=correspondenceAggregate\ngrouping=true\nqueryPermission=Query_Correspondence",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createdBy",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "date",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "text",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "CorrespondenceAggregate",
        "description": "description=A note, email, phone call, or other correspondence item linked to a record.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CorrespondenceFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CorrespondenceFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createdBy",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "date",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CorrespondenceFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "text",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Costing",
        "description": "displayName=Costing\ndefaultQuery=costings\naggregateQuery=costingsAggregate\ngrouping=true\nqueryPermission=Query_Costings",
        "isOneOf": null,
        "fields": [
          {
            "name": "costTotal",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingTemplateRevision",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "CostingTemplateRevision",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currentRevision",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "CostingRevision",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Job",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobComponent",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "JobComponent",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "CostingLine",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "marginPercent",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupTotal",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "revisions",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingRevisionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "CostingRevision",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sellTotal",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "CostingAggregate",
        "description": "",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CostingFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costTotal",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingTemplateRevision",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CostingTemplateRevisionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currentRevision",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CostingRevisionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobComponent",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobComponentFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CostingLineFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "marginPercent",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupTotal",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "revisions",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CostingRevisionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sellTotal",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "CostingLine",
        "description": "displayName=CostingLine\ndefaultQuery=costingLines\naggregateQuery=costingLinesAggregate\ngrouping=true\nqueryPermission=Query_Costing_Lines",
        "isOneOf": null,
        "fields": [
          {
            "name": "code",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costing",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Costing",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingRevision",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "CostingRevision",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingTemplateRevision",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "CostingTemplateRevision",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "line",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineTemplateId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "CostingLine",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupAmount",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupExpression",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "parentLine",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "CostingLine",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "product",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Product",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "productId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuote",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "SupplierQuote",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuoteId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "total",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitCostPrice",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitSellPrice",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "CostingLineAggregate",
        "description": "",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CostingLineFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingLineFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costing",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CostingFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingRevision",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CostingRevisionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingTemplateRevision",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CostingTemplateRevisionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "line",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineTemplateId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CostingLineFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupAmount",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupExpression",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingLineFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "parentLine",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CostingLineFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "product",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProductFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "productId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuote",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SupplierQuoteFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuoteId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "total",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitCostPrice",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitSellPrice",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CostingLineInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "costPrice",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costing",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineTemplateId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingLineInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupExpression",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "product",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuoteId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "CostingLineType",
                "ofType": null
              }
            },
            "defaultValue": "NORMAL",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "CostingLineTemplate",
        "description": "displayName=CostingLineTemplate\ndefaultQuery=costingLineTemplates\naggregateQuery=costingLineTemplatesAggregate\ngrouping=true\nqueryPermission=Query_Costing_Line_Templates",
        "isOneOf": null,
        "fields": [
          {
            "name": "category",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingTemplateRevision",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "CostingTemplateRevision",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "descriptionEditable",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupEditable",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupExpression",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantityEditable",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitCostPrice",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitCostPriceEditable",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "CostingLineTemplateAggregate",
        "description": "",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CostingLineTemplateFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingLineTemplateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "category",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingTemplateRevision",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CostingTemplateRevisionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "descriptionEditable",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupEditable",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupExpression",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingLineTemplateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantityEditable",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitCostPrice",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitCostPriceEditable",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CostingLineTemplateInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "category",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": "\"\"",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costPriceEditable",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "descriptionEditable",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupEditable",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupExpression",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": "\"\"",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantityEditable",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "CostingLineType",
                "ofType": null
              }
            },
            "defaultValue": "NORMAL",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitCostPrice",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": "\"0\"",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitCostPriceEditable",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "CostingLineType",
        "description": null,
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "COMPOSITE",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "NORMAL",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "CostingRevision",
        "description": "displayName=CostingRevision\ndefaultQuery=costingRevisions\naggregateQuery=costingRevisionsAggregate\ngrouping=true\nqueryPermission=Query_Costing_Revisions",
        "isOneOf": null,
        "fields": [
          {
            "name": "costTotal",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costing",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Costing",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingTemplateRevision",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "CostingTemplateRevision",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "CostingLine",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "marginPercent",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupTotal",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sellTotal",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "version",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "CostingRevisionAggregate",
        "description": "",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CostingRevisionFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingRevisionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costTotal",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costing",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CostingFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingTemplateRevision",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CostingTemplateRevisionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CostingLineFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "marginPercent",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupTotal",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingRevisionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sellTotal",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "version",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "CostingTemplate",
        "description": "displayName=CostingTemplate\ndefaultQuery=costingTemplates\naggregateQuery=costingTemplatesAggregate\ngrouping=true\nqueryPermission=Query_Costing_Templates",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currentRevision",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "CostingTemplateRevision",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "draftRevision",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "CostingTemplateRevision",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isDefault",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "version",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "CostingTemplateAggregate",
        "description": "",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "CostingTemplateExpression",
        "description": "displayName=CostingTemplateExpression\ndefaultQuery=costingTemplateExpressions\naggregateQuery=costingTemplateExpressionsAggregate\ngrouping=true\nqueryPermission=Query_Costing_Template_Expressions",
        "isOneOf": null,
        "fields": [
          {
            "name": "costingTemplateRevision",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "CostingTemplateRevision",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingTemplateRevisionId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "value",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "CostingTemplateExpressionAggregate",
        "description": "",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CostingTemplateExpressionFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingTemplateExpressionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingTemplateRevision",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CostingTemplateRevisionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingTemplateRevisionId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingTemplateExpressionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "value",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CostingTemplateFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingTemplateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currentRevision",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CostingTemplateRevisionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isDefault",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingTemplateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "version",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "CostingTemplateRevision",
        "description": "displayName=CostingTemplateRevision\ndefaultQuery=costingTemplateRevisions\naggregateQuery=costingTemplateRevisionsAggregate\ngrouping=true\nqueryPermission=Query_Costing_Template_Revisions",
        "isOneOf": null,
        "fields": [
          {
            "name": "costingTemplate",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CostingTemplate",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "defaultLines",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "CostingLine",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "expressions",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingTemplateExpressionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "CostingTemplateExpression",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineTemplates",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingLineTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "CostingLineTemplate",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "CostingTemplateRevisionStatus",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "version",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "CostingTemplateRevisionAggregate",
        "description": "",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CostingTemplateRevisionFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingTemplateRevisionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingTemplate",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CostingTemplateFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "expressions",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CostingTemplateExpressionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineTemplates",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CostingLineTemplateFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingTemplateRevisionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "version",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "CostingTemplateRevisionStatus",
        "description": "Costing template revision status.",
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "DRAFT",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PUBLISHED",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateBatchInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "jobId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateBranchInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "colour",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "darkColour",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateBuilderInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "address",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateBusinessRoleInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateCandidateInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "files",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": "[]",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "source",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateClientInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "address",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "email",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "faxHome",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "faxWork",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "firstName",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lastName",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notes",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "phoneCell",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "phoneHome",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "phoneWork",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "title",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateCorrespondenceInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "date",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "details",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateCostingInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "costingTemplateRevisionId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobComponentId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CostingLineInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": "[]",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateCostingTemplateInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "isDefault",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateCostingTemplateRevisionInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "costingTemplateId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingTemplateRevisionId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "defaultLines",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CostingLineInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "expressions",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ExpressionInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineTemplates",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CostingLineTemplateInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "publish",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateDocumentTemplateInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateFileInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "hash",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "metadata",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "mimeType",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "persistenceType",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resourceId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resourceType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "size",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "tags",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "url",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateFolderInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "parentFolderId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateHousingCompanyImageInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "hash",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "housingCompanyId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "mimeType",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "size",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "url",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateHousingCompanyInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateIssueInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "completed",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "files",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "requiredDate",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateJobComponentInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "partTypeId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateJobEmailInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "body",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "subject",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "to",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateJobInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "address",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "benchtopOnly",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branch",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "buildType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "builder",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "builderPhone",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "client",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "designer",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "difficultAccess",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "estimatedDueDate",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "hcJobNumber",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "hcPmPhone",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "hcProjectManager",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "housingCompany",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobName",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobQuantity",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notes",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "project",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "projectManager",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "region",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "saleType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "showHome",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "siteNotes",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sssp",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "tristoneJoin",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "tristoneSpecified",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unit",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateLeadInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "address",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedTo",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branchId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "builderName",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "builderType",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "city",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "client",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "email",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "joineryTypes",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notes",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "phone",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "priceRangeBottom",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "priceRangeTop",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "priority",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "defaultValue": "0",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "projectType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "requiredBy",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "source",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "suburb",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateLineItemInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "batchId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "partTypeId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateLostReasonInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreatePanelInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "config",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreatePartTypeInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "colour",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreatePersonInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "branchId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "businessRoleIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": "[]",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isActive",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "true",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateProcessTimerInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "processInstanceIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateProcessTypeInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateProcessTypeNoteInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "assignedProcessIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "date",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "note",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateProcessTypeRoleInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "processTypeId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateProductCategoryInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "group",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "parentId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateProductInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "category",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "indent",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadTime",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "qtyReviewThreshold",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "safetyStockDays",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "starred",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stockItem",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplier",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "tags",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "template",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitOfMeasure",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "url",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateProductPriceInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "effectiveDate",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "productId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitPrice",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateProjectInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreatePurchaseOrderFromSupplierQuoteInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "supplierQuoteId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreatePurchaseOrderInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "category",
            "description": null,
            "type": {
              "kind": "ENUM",
              "name": "OrderCategory",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deliveryAddress",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deliveryAddressId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "internalComment",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderLineInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notifySupplierWhenPlaced",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "required",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "shippingMethod",
            "description": null,
            "type": {
              "kind": "ENUM",
              "name": "OrderShippingMethods",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "shippingTerms",
            "description": null,
            "type": {
              "kind": "ENUM",
              "name": "OrderShippingTerms",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "siteVisitRequired",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "statusWhenPlaced",
            "description": null,
            "type": {
              "kind": "ENUM",
              "name": "OrderStatus",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierComment",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "templateId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "urgent",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouseId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreatePurchaseOrderReceiptInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "notes",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderLines",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "PurchaseOrderReceiptLineInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrderId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouseId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateQuoteApprovalRequestInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "quoteId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateQuoteInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "clientAddress",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "clientName",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "contactName",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customer",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "files",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "QuoteLineInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteRequestId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplateRevisionId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateQuoteTemplateInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "isDefault",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateQuoteTemplateRevisionInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "defaultLines",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "QuoteLineInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "expressions",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ExpressionInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineTemplates",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "QuoteLineTemplateInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "publish",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplateId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplateRevisionId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateRecordFileInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "entity",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "fileId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "metadata",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateRoleInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "inheritFrom",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": "[]",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateSalesOrderInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "clientAddress",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "clientId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "clientName",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "contactName",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currency",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": "\"NZD\"",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SalesOrderLineInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateSchemaInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateScreenInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "group",
            "description": null,
            "type": {
              "kind": "ENUM",
              "name": "ScreenGroup",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "icon",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screenCfg",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateSignedUploadUrlInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "filename",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "mimeType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateStorageConnectionInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deviceAccessEnabled",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "dropboxAuthToken",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "dropboxNamespaceId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "enabled",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "localRoot",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "root",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateStorageResourceMappingInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "enabled",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "externalStorageConnectionId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "path",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resourceFilter",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resourceType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateSubscriptionInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "enabled",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "true",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "event",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "maxRecipients",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notifications",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "NotificationInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": "[]",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sourceFilter",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "targetFilter",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateSupplierImageInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "hash",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "mimeType",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "size",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "url",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateSupplierInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "address",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "categoryId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "cell",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currency",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "email",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderEmails",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteEmails",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "url",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateSupplierQuoteInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "files",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": "[]",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SupplierQuoteLineInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": "[]",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteRequestId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesTax",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": "\"\"",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "saveAsDraft",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuoteNumber",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateSupplierQuoteRequestInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "files",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": "[]",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SupplierQuoteRequestLineInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "noteForSupplier",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "place",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateTagInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "colour",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "context",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateUserIdentityInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "entity",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateUserInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "authProvider",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "AuthProviderType",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branchId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "fullName",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "password",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "personId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roles",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "defaultValue": "[]",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "username",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateWarehouseInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "address",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "color",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateWebhookInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "authType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": "\"none\"",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "enabled",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "event",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sourceFilter",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "url",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateWorkflowTypeInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "master",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "CustomData",
        "description": "description=Custom form data associated with a record and schema version.\ndisplayName=Custom Data\nmodule=Admin\ndefaultQuery=customData\niconName=form\ncolour=#5D35A6\naggregateQuery=customDataAggregate\ngrouping=true\nqueryPermission=Query_Custom_Data",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "data",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "schema",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Schema",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "schemaId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "schemaVersion",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "SchemaVersion",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "CustomDataAggregate",
        "description": "description=Custom form data associated with a record and schema version.",
        "isOneOf": null,
        "fields": [
          {
            "name": "average",
            "description": "sortable=true\ngroupable=false",
            "args": [
              {
                "name": "path",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "max",
            "description": "sortable=true\ngroupable=false",
            "args": [
              {
                "name": "path",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "min",
            "description": "sortable=true\ngroupable=false",
            "args": [
              {
                "name": "path",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sum",
            "description": "sortable=true\ngroupable=false",
            "args": [
              {
                "name": "path",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CustomDataFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "data",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JsonFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "schema",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SchemaFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "schemaId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "schemaVersion",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SchemaVersionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "CustomDataSetEvent",
        "description": "CustomData",
        "isOneOf": null,
        "fields": [
          {
            "name": "customDataId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "data",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "schemaId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "schemaVersionId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "CustomTemplate",
        "description": "description=A reusable custom template for generating application content.\ndisplayName=Custom Template\nmodule=Admin\ndefaultQuery=customTemplates\niconName=document\ncolour=#5D35A6\naggregateQuery=customTemplatesAggregate\ngrouping=true\nqueryPermission=Query_Custom_Templates",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "default",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "entity",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "query",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sampleDataOverride",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "source",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "template",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "CustomTemplateAggregate",
        "description": "description=A reusable custom template for generating application content.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CustomTemplateFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomTemplateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "default",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "entity",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomTemplateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "query",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sampleDataOverride",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "source",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "template",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "DataStore",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "DataStoreRecord",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "data",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "SCALAR",
        "name": "DateTime",
        "description": "The `DateTime` scalar type represents time data, represented as an ISO-8601 encoded UTC date string.",
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DateTimeFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "eq",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "gte",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "like",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lte",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DateTimeReportDimensionInput",
        "description": "Groups a DateTime field into calendar intervals within a typed date filter.",
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "filter",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "DateTimeFilterInput",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeEmpty",
            "description": "Include interval values for which the aggregate is zero.",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "true",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "interval",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "ReportDateInterval",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "withinEachInterval",
            "description": "Restrict contributing values to the same relative date range within every interval.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Day",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "createdLeadAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LeadFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "LeadAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createdPurchaseOrderAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createdPurchaseOrderLineAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderLineAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "date",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeactivatePersonInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "personId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "DefaultFolder",
        "description": "description=A default native folder shown for every record of its configured type.\ndisplayName=Default Folder\ndefaultQuery=defaultFolders\niconName=folder-close\naggregateQuery=defaultFoldersAggregate\ngrouping=true\nqueryPermission=Query_Default_Folders",
        "isOneOf": null,
        "fields": [
          {
            "name": "allowedMimeTypes",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "enabled",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "DefaultFolderAggregate",
        "description": "description=A default native folder shown for every record of its configured type.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DefaultFolderFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "DefaultFolderFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "enabled",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "DefaultFolderFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteBatchesInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "batchIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteBranchesInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "branchIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteBuildersInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "builderIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteClientsInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "clientIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteConfiguredLinkedActionsInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "ids",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteCorrespondenceInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "correspondenceId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteCostingInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "costingId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteDraftPurchaseOrdersInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "purchaseOrderIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteExternalStorageItemsInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "paths",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteHousingCompaniesInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "housingCompanyIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteHousingCompanyImageInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "housingCompanyId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteJobComponentInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "jobComponentId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteLeadsInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "leadIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteLineItemsInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "lineItemIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteLostReasonsInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "lostReasonIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeletePanelsInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "panelIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeletePartTypesInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "partTypeIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteProcessTypeNoteInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "processTypeNoteId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteProcessTypeRolesInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "processTypeRoleIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteProcessTypesInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "processTypeIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteProductCategoriesInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "cascade",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "productCategoryIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteProductPricesInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "productPriceIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteRecordFilesInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "ids",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteSalesOrderInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "salesOrderId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteScreensInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "screenIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteSupplierImageInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "supplierId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteSupplierQuoteInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "supplierQuoteId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteSupplierQuoteRequestInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "supplierQuoteRequestId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteSuppliersInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "supplierIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteUserIdentitiesInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "userIdentityIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteWebhooksInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "webhookIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteWorkflowTypesInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "workflowTypeIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "DeliveryAddress",
        "description": "description=A reusable delivery address for purchase orders.\ndisplayName=Delivery Address\nmodule=Inventory\ndefaultQuery=deliveryAddresses\niconName=map-marker\ncolour=#596600\naggregateQuery=deliveryAddressesAggregate\ngrouping=true\nqueryPermission=Query_Delivery_Addresses",
        "isOneOf": null,
        "fields": [
          {
            "name": "address",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "color",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "DeliveryAddressAggregate",
        "description": "description=A reusable delivery address for purchase orders.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeliveryAddressFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "address",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "DeliveryAddressFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "color",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "DeliveryAddressFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Document",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "html",
            "description": "TODO: Rename as might output formats other than HTML, eg plaintext, images etc",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "pdfBase64",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "template",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "DocumentTemplate",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "DocumentPreview",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "html",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "pdfBase64",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "DocumentTemplate",
        "description": "description=A document template with its rendering query and default selection.\ndisplayName=Document Template\nmodule=Admin\ndefaultQuery=documentTemplates\niconName=document\ncolour=#5D35A6\naggregateQuery=documentTemplatesAggregate\ngrouping=true\nqueryPermission=Query_Document_Templates",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "default",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "entity",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "html",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "query",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sampleDataOverride",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "source",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "template",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "DocumentTemplateAggregate",
        "description": "description=A document template with its rendering query and default selection.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DocumentTemplateFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "DocumentTemplateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "default",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "entity",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "DocumentTemplateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "query",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sampleDataOverride",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "source",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "template",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "DomainEventType",
        "description": "All discovered domain event GraphQL type names.",
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "BatchCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "BatchDeletedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "BatchRecalculateDueDateEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "BatchStatusCheckEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "BatchUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "BranchCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "BranchDeletedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "BranchRestoredEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "BranchUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "CandidateCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "CustomDataSetEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "EmailCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "EmailStatusChangedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "FileUploadedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "InternalCommentUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "InvalidateCacheEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "InvoiceCheckedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "InvoiceUncheckedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "IssueCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "IssueUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "JobBuilderUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "JobClientUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "JobCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "JobDetailsUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "JobPartBatchChangedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "JobPartConfirmedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "JobPartCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "JobPartDeletedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "JobPartUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "JobSiteUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "JobStatusChangedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "LeadAssignedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "LeadBranchChangedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "LeadConvertedToJobEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "LeadCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "LeadDetailsUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "LeadOverrideStatusEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "LeadStatusChangedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "LineItemMasterWorkflowCompletedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "OrderEmailStatusUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "OrderOverrideStatusEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "OrderReceiptCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "OrderRevisionCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PartTypeCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PartTypeDeletedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PartTypeRestoredEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PartTypeUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ProcessTypeCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ProcessTypeDeletedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ProcessTypeRestoredEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ProcessTypeUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ProductCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ProductDetailsUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ProductPriceCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ProductPriceDeletedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PurchaseOrderAmendedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PurchaseOrderApprovedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PurchaseOrderCancelledEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PurchaseOrderIncompleteEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PurchaseOrderPendingReviewEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PurchaseOrderPlacedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PurchaseOrderReceivedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PurchaseOrderRejectedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PurchaseOrderReleasedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PurchaseOrderSupplierNotificationManuallySentEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PurchaseOrderSupplierNotificationSentEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "QuoteApprovalRequestedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "QuoteRequestAcceptedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "QuoteRequestPlacedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "QuoteRequestQuotedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "RecordFileDeletedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "RecordFilesUploadedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "RoleCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "RoleDeletedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "RoleDetailsUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "RoleInheritanceAssignmentUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "RolePermissionsAssignmentUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "RoleScreensAssignmentUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "RoleUsersAssignmentUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SchemaCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SchemaDeletedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SchemaUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SchemaVersionActiveEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SchemaVersionCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SchemaVersionDeletedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SchemaVersionUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ScreenCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ScreenDeletedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ScreenUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "StatusChangedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "StatusUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "StockTakeCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "StockTransactionCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SupplierCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SupplierDeletedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SupplierDetailsUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SupplierReviewersUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SupplierStatusUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "TemplateCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "TemplateDeletedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "TemplateUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "UserCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "UserDeletedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "UserDisabledEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "UserEnabledEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "UserPermissionsUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "UserRestoredEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "UserRolesUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "UserScreensUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "UserUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "WarehouseCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "WarehouseDeletedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "WarehouseStockReceivedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "WarehouseStockTakeEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "WarehouseStockTransferReceivedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "WarehouseStockTransferWithdrawnEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "WarehouseStockWithdrawnEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "WarehouseUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "WebhookCallFailedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "WebhookCalledEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "WebhookCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "WebhookDeletedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "WebhookUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "WorkflowTypeCreatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "WorkflowTypeDeletedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "WorkflowTypeRestoredEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "WorkflowTypeUpdatedEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "EffectivePermission",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "assigned",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "conditions",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "permission",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Permission",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "policy",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "Policy",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Email",
        "description": "description=A persisted transactional email and its delivery status.\ndisplayName=Transactional Email\nmodule=Admin\ndefaultQuery=emails\niconName=envelope\ncolour=#5D35A6\naggregateQuery=emailsAggregate\ngrouping=true\nqueryPermission=Query_Transactional_Emails",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "messageId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrder",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrder",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recipient",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sender",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sentAt",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "ENUM",
              "name": "EmailDeliveryStatus",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "subject",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "typeDisplayName",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updatedAt",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "EmailAggregate",
        "description": "description=A persisted transactional email and its delivery status.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "EmailCreatedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "entity",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "EmailDeliveryStatus",
        "description": "Transactional email delivery status.",
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "DELIVERED",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "FAILED",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "NOT_SENT",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PENDING",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "EmailDeliveryStatusFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "eq",
            "description": null,
            "type": {
              "kind": "ENUM",
              "name": "EmailDeliveryStatus",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "in",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "ENUM",
                  "name": "EmailDeliveryStatus",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "EmailFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "EmailFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "messageId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "EmailFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrder",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PurchaseOrderFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recipient",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sender",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sentAt",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "EmailDeliveryStatusFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "subject",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "typeDisplayName",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updatedAt",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "EmailStatusChangedEvent",
        "description": "Email",
        "isOneOf": null,
        "fields": [
          {
            "name": "description",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "emailId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "previousStatus",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recipient",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "subject",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ExpressionInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "value",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ExternalStorageConnection",
        "description": "description=A configured storage provider and its remote and device access settings.\ndisplayName=External Storage Connection\nmodule=Admin\ndefaultQuery=externalStorageConnections\niconName=cloud\ncolour=#5D35A6\naggregateQuery=externalStorageConnectionsAggregate\ngrouping=true\nqueryPermission=Query_Storage_Connections",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deviceAccessEnabled",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "dropboxAuthToken",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "dropboxNamespaceId",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "enabled",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "item",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "path",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": "\"\"",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ExternalStorageItem",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "items",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "path",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": "\"\"",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "pathPrefix",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": "\"\"",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ExternalStorageItem",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "localPathSeparator",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "localRoot",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "root",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "storageMappings",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ExternalStorageResourceMappingFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ExternalStorageResourceMapping",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ExternalStorageConnectionAggregate",
        "description": "description=A configured storage provider and its remote and device access settings.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ExternalStorageConnectionFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ExternalStorageConnectionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "localRoot",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ExternalStorageConnectionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "root",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "storageMappings",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ExternalStorageResourceMappingFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ExternalStorageItem",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "canOpen",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "fileId",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "folderBadgeIconColour",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "folderBadgeIconName",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isFolder",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "largeThumbnailUrl",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "localPath",
            "description": "Returns the \"local\" path (if it exists) for this item\nEg you may have dropbox mounted locally on your PC,\nthis will let you access that file directly.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "localUrl",
            "description": "Signed local-device URL consumed by the Windows jmfile protocol handler.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "mediumThumbnailUrl",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "metadata",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "mimeType",
            "description": "groupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": "groupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "path",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "previewUrl",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordFileId",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "size",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "smallThumbnailUrl",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "temporaryUrl",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": "groupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "uploadMimeTypes",
            "description": null,
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ExternalStorageItemFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isFolder",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "mimeType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "path",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordFile",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RecordFileFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ExternalStorageResourceMapping",
        "description": "description=A storage connection path made available to records matching a resource filter.\ndisplayName=External Storage Resource Mapping\nmodule=Admin\ndefaultQuery=externalStorageResourceMappings\niconName=folder-open\ncolour=#5D35A6\naggregateQuery=externalStorageResourceMappingsAggregate\ngrouping=true\nqueryPermission=Query_Storage_Resource_Mappings",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "enabled",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "externalStorageConnection",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ExternalStorageConnection",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "path",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resourceFilter",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resourceType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ExternalStorageResourceMappingAggregate",
        "description": "description=A storage connection path made available to records matching a resource filter.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ExternalStorageResourceMappingFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ExternalStorageResourceMappingFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "enabled",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "externalStorageConnection",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ExternalStorageConnectionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ExternalStorageResourceMappingFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "path",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resourceFilter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resourceType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "storageConnection",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ExternalStorageConnectionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "File",
        "description": "description=An uploaded file and its stored metadata and preview URLs.\ndisplayName=File\nmodule=Admin\ndefaultQuery=files\niconName=document\ncolour=#5D35A6\naggregateQuery=fileAggregates\ngrouping=true\nqueryPermission=Query_Files",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "hash",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "largeThumbnailUrl",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "mediumThumbnailUrl",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "mimeType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sizeBytes",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "smallThumbnailUrl",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "temporaryUrl",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "FileAggregate",
        "description": "description=An uploaded file and its stored metadata and preview URLs.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "FileFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "FileFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "hash",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "mimeType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "FileFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "size",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sizeBytes",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserIdentityFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "FileInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "fileId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "metadata",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "primaryImage",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "FileReportDimensionValue",
        "description": "A File identity or a typed nested report dimension.",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "key",
            "description": "Stable machine-readable Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "Display label for the Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "UserReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "FileReportGroupByInput",
        "description": "Select exactly one typed File report dimension.",
        "isOneOf": true,
        "fields": null,
        "inputFields": [
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeReportDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeReportDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": "Group by User or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "FileReportRelationDimensionInput",
        "description": "Groups by File identity, or traverses to one of its typed dimensions.",
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "filter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "FileFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groupBy",
            "description": "Traverse through this relation and group by a field or relation on the related Resource.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "FileReportGroupByInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeEmpty",
            "description": "Include filtered related records that have no contributing resource rows.",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "FileUploadedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "file",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "SCALAR",
        "name": "Float",
        "description": "The `Float` scalar type represents signed double-precision fractional values as specified by [IEEE 754](https://en.wikipedia.org/wiki/IEEE_floating_point).",
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetDocumentPreviewInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "data",
            "description": "Dummy data returned from query",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "query",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "template",
            "description": "Eith pass id (above) or template (below)",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "variables",
            "description": "Dummy variables for either record or event",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "GroupInstance",
        "description": "description=A group within a running line-item manufacturing workflow.\ndisplayName=Group Instance\nmodule=Manufacturing\niconName=data-lineage\ncolour=#A96500\ngrouping=true\nqueryPermission=Query_Line_Item_Master_Workflows",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemMasterWorkflow",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "LineItemMasterWorkflow",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflow",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Workflow",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GroupInstanceFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "GroupInstanceFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemMasterWorkflow",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LineItemMasterWorkflowFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "GroupInstanceFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflow",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "WorkflowFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "GroupTemplate",
        "description": "description=A reusable grouped workflow step inside a workflow template.\ndisplayName=Group Template\nmodule=Manufacturing\ndefaultQuery=groupTemplates\niconName=data-lineage\ncolour=#A96500\naggregateQuery=groupTemplatesAggregate\ngrouping=true\nqueryPermission=Query_Group_Templates",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "placeHolder",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowTemplate",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "WorkflowTemplate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "GroupTemplateAggregate",
        "description": "description=A reusable grouped workflow step inside a workflow template.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GroupTemplateFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "GroupTemplateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "GroupTemplateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "placeHolder",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowTemplate",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "WorkflowTemplateFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "HousingCompany",
        "description": "description=A housing company associated with sales jobs.\ndisplayName=Housing Company\nmodule=Sales\ndefaultQuery=housingCompanies\niconName=office\ncolour=#A91F54\naggregateQuery=housingCompaniesAggregate\ngrouping=true\nqueryPermission=Query_Housing_Companies",
        "isOneOf": null,
        "fields": [
          {
            "name": "code",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "confirmedSalesYtdChange",
            "description": "description=Completed-month YTD confirmed sales minus the equivalent period in the previous year.\npermission=Report_Confirmed_Sales\nsortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "image",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "File",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobAggregate",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "JobFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "JobAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobs",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "JobFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Job",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "HousingCompanyAggregate",
        "description": "description=A housing company associated with sales jobs.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "HousingCompanyFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "HousingCompanyFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "confirmedSalesYtdChange",
            "description": "Completed-month YTD confirmed sales minus the equivalent period in the previous year.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "image",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "FileFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobs",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "HousingCompanyFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "HousingCompanyReportDimensionValue",
        "description": "A Housing Company identity or a typed nested report dimension.",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "image",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "FileReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "key",
            "description": "Stable machine-readable Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "Display label for the Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "HousingCompanyReportGroupByInput",
        "description": "Select exactly one typed Housing Company report dimension.",
        "isOneOf": true,
        "fields": null,
        "inputFields": [
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeReportDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "image",
            "description": "Group by File or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "FileReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeReportDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "HousingCompanyReportRelationDimensionInput",
        "description": "Groups by Housing Company identity, or traverses to one of its typed dimensions.",
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "filter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "HousingCompanyFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groupBy",
            "description": "Traverse through this relation and group by a field or relation on the related Resource.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "HousingCompanyReportGroupByInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeEmpty",
            "description": "Include filtered related records that have no contributing resource rows.",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "SCALAR",
        "name": "ID",
        "description": "The `ID` scalar type represents a unique identifier, often used to refetch an object or as key for a cache. The ID type appears in a JSON response as a String; however, it is not intended to be human-readable. When expected as an input type, any string (such as `\"4\"`) or integer (such as `4`) input value will be accepted as an ID.",
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "IDFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "eq",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "in",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notEq",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notIn",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "SCALAR",
        "name": "Int",
        "description": "The `Int` scalar type represents non-fractional signed whole numeric values. Int can represent values between -(2^31) and 2^31 - 1.",
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "InternalCommentUpdatedEvent",
        "description": "PurchaseOrder",
        "isOneOf": null,
        "fields": [
          {
            "name": "orderId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "InvalidateCacheEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "shutdown",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "InvoiceCheckedEvent",
        "description": "PurchaseOrder",
        "isOneOf": null,
        "fields": [
          {
            "name": "orderId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "InvoiceUncheckedEvent",
        "description": "PurchaseOrder",
        "isOneOf": null,
        "fields": [
          {
            "name": "orderId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Issue",
        "description": "description=A maintenance issue tracked against a record.\ndisplayName=Issue\nmodule=Sales\ndefaultQuery=issues\niconName=issue\ncolour=#A91F54\naggregateQuery=issuesAggregate\ngrouping=true\nqueryPermission=Query_Issues",
        "isOneOf": null,
        "fields": [
          {
            "name": "completed",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createdAt",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "files",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RecordFileFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "RecordFile",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Job",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modifiedAt",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notes",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordJob",
            "description": "description=The Job linked through the issue record reference.\nsortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Job",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reportedBy",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "requiredDate",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "scheduledDate",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "IssueAggregate",
        "description": "description=A maintenance issue tracked against a record.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "IssueCompletionStatus",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "completed",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "issueAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "IssueFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "IssueAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "IssueCreatedEvent",
        "description": "Issue",
        "isOneOf": null,
        "fields": [
          {
            "name": "description",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "issueId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "IssueFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "IssueFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "completed",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createdAt",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "files",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RecordFileFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modifiedAt",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notes",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "IssueFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordJob",
            "description": "The Job linked through the issue record reference.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reportedBy",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "requiredDate",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "scheduledDate",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "IssueQuoteInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "quoteId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "IssueUpdatedEvent",
        "description": "Issue",
        "isOneOf": null,
        "fields": [
          {
            "name": "description",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "issueId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Job",
        "description": "description=A customer job tracking sales, production, purchasing, and delivery work.\ndisplayName=Job\nmodule=Sales\ndefaultQuery=jobs\niconName=briefcase\ncolour=#A91F54\naggregateQuery=jobsAggregate\nreportQuery=jobReport\ngrouping=true\nqueryPermission=Query_Jobs",
        "isOneOf": null,
        "fields": [
          {
            "name": "batches",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "BatchFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Batch",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "benchtopOnly",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branch",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Branch",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "buildType",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "BuildType",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "buildTypeId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "builder",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Builder",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "builderId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "builderPhone",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "client",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Client",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costings",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Costing",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createdDate",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "designer",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "PersonBusinessRole",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "designerId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "difficultAccess",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "dueDate",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "externalStorageConnection",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ExternalStorageConnection",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "externalStorageItems",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "path",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ExternalStorageItem",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "externalStoragePath",
            "description": "description=We won't store this in the database, but will use centralised tenant-specific logic to map a job to the right external path\nsortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "hcJobNumber",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "hcPmPhone",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "hcProjectManager",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "housingCompany",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "HousingCompany",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "issues",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "IssueFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Issue",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobComponents",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "JobComponentFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "JobComponent",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobFolderLink",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobName",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobNumber",
            "description": "description=A unique number for this job\nsortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lead",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Lead",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemAggregate",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LineItemFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "LineItemAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItems",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LineItemFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "LineItem",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lostReason",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "LostReason",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lostReasonNotes",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "note",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "projectManager",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "PersonBusinessRole",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "projectManagerId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrderAggregate",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrders",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "PurchaseOrder",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quotes",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Quote",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "region",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Region",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "regionId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "saleType",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "SaleType",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "saleTypeId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesOrders",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SalesOrderFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SalesOrder",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "showHome",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "siteAddress",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "siteNotes",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sssp",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuoteRequests",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierQuoteRequestFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SupplierQuoteRequest",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuotes",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierQuoteFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SupplierQuote",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "tristoneJoin",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "tristoneSpecified",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unit",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "JobAggregate",
        "description": "description=A customer job tracking sales, production, purchasing, and delivery work.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "estimatedSheets",
            "description": "description=Estimated line-item sheets for matching jobs, grouped by job date.\nsortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "totalConfirmedSale",
            "description": "description=Total confirmed line-item sales for matching jobs.\npermission=Report_Confirmed_Sales\nsortable=true\ngroupable=false",
            "args": [
              {
                "name": "confirmedDate",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "DateTimeFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "JobBuilderUpdatedEvent",
        "description": "Job",
        "isOneOf": null,
        "fields": [
          {
            "name": "jobId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "JobClientUpdatedEvent",
        "description": "Job",
        "isOneOf": null,
        "fields": [
          {
            "name": "clientName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "JobComponent",
        "description": "description=A stable unit of scope within a job.\ndisplayName=Job Component\nmodule=Sales\ndefaultQuery=jobComponents\niconName=cube\ncolour=#A91F54\naggregateQuery=jobComponentsAggregate\ngrouping=true\nqueryPermission=Query_Job_Components",
        "isOneOf": null,
        "fields": [
          {
            "name": "code",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costings",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Costing",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "estimatingSellTotal",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Job",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "partType",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "PartType",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteLines",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "QuoteLine",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesOrderLines",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SalesOrderLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SalesOrderLine",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "JobComponentAggregate",
        "description": "description=A stable unit of scope within a job.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "JobComponentFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "JobComponentFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costings",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CostingFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "estimatingSellTotal",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "JobComponentFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "partType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PartTypeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteLines",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "QuoteLineFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesOrderLines",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SalesOrderLineFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "JobCreatedEvent",
        "description": "Job",
        "isOneOf": null,
        "fields": [
          {
            "name": "jobId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadId",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "JobDetailsUpdatedEvent",
        "description": "Job",
        "isOneOf": null,
        "fields": [
          {
            "name": "jobId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "JobFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "JobFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "batches",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BatchFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "benchtopOnly",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branch",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BranchFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "buildType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BuildTypeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "buildTypeId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "builder",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BuilderFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "builderId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "builderPhone",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "client",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ClientFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costings",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CostingFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createdDate",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "designer",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PersonBusinessRoleFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "designerId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "difficultAccess",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "dueDate",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "hasAssociatedLead",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "hcJobNumber",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "hcPmPhone",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "hcProjectManager",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "housingCompany",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "HousingCompanyFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "issues",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IssueFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobComponents",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobComponentFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobName",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobNumber",
            "description": "A unique number for this job",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobString",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lead",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LeadFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItems",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LineItemFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lostReason",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LostReasonFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lostReasonNotes",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "JobFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "projectManager",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PersonBusinessRoleFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "projectManagerId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrders",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PurchaseOrderFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quotes",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "QuoteFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "region",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RegionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "regionId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "saleType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SaleTypeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "saleTypeId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesOrders",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SalesOrderFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "showHome",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "siteAddress",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "siteNotes",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sssp",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobStatusFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuoteRequests",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SupplierQuoteRequestFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuotes",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SupplierQuoteFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "tristoneJoin",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "tristoneSpecified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unit",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "JobPartBatchChangedEvent",
        "description": "LineItem",
        "isOneOf": null,
        "fields": [
          {
            "name": "lineItemId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "newBatchId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "newBatchName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "oldBatchId",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "JobPartConfirmedEvent",
        "description": "LineItem",
        "isOneOf": null,
        "fields": [
          {
            "name": "lineItemId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "JobPartCreatedEvent",
        "description": "LineItem",
        "isOneOf": null,
        "fields": [
          {
            "name": "jobNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "JobPartDeletedEvent",
        "description": "LineItem",
        "isOneOf": null,
        "fields": [
          {
            "name": "batchId",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "JobPartUpdatedEvent",
        "description": "LineItem",
        "isOneOf": null,
        "fields": [
          {
            "name": "lineItemId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "JobReportDimensionValue",
        "description": "A Job identity or a typed nested report dimension.",
        "isOneOf": null,
        "fields": [
          {
            "name": "branch",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "BranchReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "buildType",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "BuildTypeReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "builder",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "BuilderReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "client",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ClientReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createdDate",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "designer",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "PersonBusinessRoleReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "dueDate",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "housingCompany",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "HousingCompanyReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "key",
            "description": "Stable machine-readable Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "Display label for the Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lead",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "LeadReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lostReason",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "LostReasonReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "projectManager",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "PersonBusinessRoleReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "region",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "RegionReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "saleType",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "SaleTypeReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "JobReportDimensions",
        "description": "Typed Job report dimension values.",
        "isOneOf": null,
        "fields": [
          {
            "name": "branch",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "BranchReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "buildType",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "BuildTypeReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "builder",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "BuilderReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "client",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ClientReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createdDate",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "designer",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "PersonBusinessRoleReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "dueDate",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "housingCompany",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "HousingCompanyReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lead",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "LeadReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lostReason",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "LostReasonReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "projectManager",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "PersonBusinessRoleReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "region",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "RegionReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "saleType",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "SaleTypeReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "JobReportGroupByInput",
        "description": "Select exactly one typed Job report dimension.",
        "isOneOf": true,
        "fields": null,
        "inputFields": [
          {
            "name": "branch",
            "description": "Group by Branch or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BranchReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "buildType",
            "description": "Group by Build Type or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BuildTypeReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "builder",
            "description": "Group by Builder or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BuilderReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "client",
            "description": "Group by Client or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ClientReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createdDate",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeReportDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "designer",
            "description": "Group by Person Business Role or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PersonBusinessRoleReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "dueDate",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeReportDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "housingCompany",
            "description": "Group by Housing Company or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "HousingCompanyReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lead",
            "description": "Group by Lead or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LeadReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lostReason",
            "description": "Group by Lost Reason or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LostReasonReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "projectManager",
            "description": "Group by Person Business Role or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PersonBusinessRoleReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "region",
            "description": "Group by Region or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RegionReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "saleType",
            "description": "Group by Sale Type or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SaleTypeReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "JobReportRelationDimensionInput",
        "description": "Groups by Job identity, or traverses to one of its typed dimensions.",
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "filter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groupBy",
            "description": "Traverse through this relation and group by a field or relation on the related Resource.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobReportGroupByInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeEmpty",
            "description": "Include filtered related records that have no contributing resource rows.",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "JobReportRow",
        "description": "One grouped Job report row.",
        "isOneOf": null,
        "fields": [
          {
            "name": "aggregate",
            "description": "The generated Job aggregate, constrained to this dimension row.",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "JobFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "JobAggregate",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "dimensions",
            "description": "Typed values for every selected report dimension.",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "JobReportDimensions",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "key",
            "description": "The first dimension key, retained for single-dimension report compatibility.",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "The first dimension label, retained for single-dimension report compatibility.",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "JobSiteUpdatedEvent",
        "description": "Job",
        "isOneOf": null,
        "fields": [
          {
            "name": "jobId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "JobStatus",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "intent",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "JobFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "JobAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "JobStatusChangedEvent",
        "description": "Job",
        "isOneOf": null,
        "fields": [
          {
            "name": "jobId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "newStatus",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "oldStatus",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "JobStatusFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "JsonFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "eq",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "field",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "in",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "like",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "neq",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notIn",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Lead",
        "description": "description=A sales enquiry or prospect before it is converted into a job.\ndisplayName=Lead\nmodule=Sales\ndefaultQuery=leads\niconName=filter-list\ncolour=#A91F54\naggregateQuery=leadsAggregate\nreportQuery=leadReport\ngrouping=true\nqueryPermission=Query_Leads",
        "isOneOf": null,
        "fields": [
          {
            "name": "address",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedDate",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedTo",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "PersonBusinessRole",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branch",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Branch",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "builderName",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "builderType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "city",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "client",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "correspondence",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CorrespondenceFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Correspondence",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createdAt",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "email",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Job",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "joineryTypes",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "latestCorrespondence",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Correspondence",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lostReason",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "LostReason",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lostReasonNotes",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notes",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "phone",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "priceRangeBottom",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "priceRangeTop",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "priority",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "projectType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "requiredBy",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "source",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "LeadStatus",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "suburb",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LeadAggregate",
        "description": "description=A sales enquiry or prospect before it is converted into a job.",
        "isOneOf": null,
        "fields": [
          {
            "name": "avgAssignTimeDays",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ids",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "newStatusCount",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LeadAssignedEvent",
        "description": "Lead",
        "isOneOf": null,
        "fields": [
          {
            "name": "assignedToId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedToName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "clientName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LeadBranchChangedEvent",
        "description": "Lead",
        "isOneOf": null,
        "fields": [
          {
            "name": "clientName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "newBranchId",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "newBranchName",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "oldBranchId",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "oldBranchName",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LeadConvertedToJobEvent",
        "description": "Lead",
        "isOneOf": null,
        "fields": [
          {
            "name": "jobNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadLabel",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LeadCreatedEvent",
        "description": "Lead",
        "isOneOf": null,
        "fields": [
          {
            "name": "clientName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LeadDetailsUpdatedEvent",
        "description": "Lead",
        "isOneOf": null,
        "fields": [
          {
            "name": "clientName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LeadFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "address",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "LeadFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedDate",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedTo",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PersonBusinessRoleFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branch",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BranchFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "builderName",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "builderType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "city",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "client",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "correspondence",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CorrespondenceFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createdAt",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "email",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "hasAssociatedJob",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "joineryTypes",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lostReason",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LostReasonFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lostReasonNotes",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notes",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "LeadFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "phone",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "priceRangeBottom",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "priceRangeTop",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "priority",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "projectType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "requiredBy",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "source",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LeadSourceFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LeadStatusFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "suburb",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LeadOverrideStatusEvent",
        "description": "Lead",
        "isOneOf": null,
        "fields": [
          {
            "name": "clientName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "newStatus",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "oldStatus",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LeadProjectType",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LeadFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "LeadAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LeadReportDimensionValue",
        "description": "A Lead identity or a typed nested report dimension.",
        "isOneOf": null,
        "fields": [
          {
            "name": "assignedDate",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedTo",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "PersonBusinessRoleReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branch",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "BranchReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createdAt",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "JobReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "key",
            "description": "Stable machine-readable Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "Display label for the Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lostReason",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "LostReasonReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "requiredBy",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LeadReportDimensions",
        "description": "Typed Lead report dimension values.",
        "isOneOf": null,
        "fields": [
          {
            "name": "assignedDate",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedTo",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "PersonBusinessRoleReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branch",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "BranchReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createdAt",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "JobReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lostReason",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "LostReasonReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "requiredBy",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LeadReportGroupByInput",
        "description": "Select exactly one typed Lead report dimension.",
        "isOneOf": true,
        "fields": null,
        "inputFields": [
          {
            "name": "assignedDate",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeReportDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedTo",
            "description": "Group by Person Business Role or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PersonBusinessRoleReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branch",
            "description": "Group by Branch or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BranchReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createdAt",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeReportDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": "Group by Job or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lostReason",
            "description": "Group by Lost Reason or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LostReasonReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "requiredBy",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeReportDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LeadReportRelationDimensionInput",
        "description": "Groups by Lead identity, or traverses to one of its typed dimensions.",
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "filter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LeadFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groupBy",
            "description": "Traverse through this relation and group by a field or relation on the related Resource.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LeadReportGroupByInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeEmpty",
            "description": "Include filtered related records that have no contributing resource rows.",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LeadReportRow",
        "description": "One grouped Lead report row.",
        "isOneOf": null,
        "fields": [
          {
            "name": "aggregate",
            "description": "The generated Lead aggregate, constrained to this dimension row.",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LeadFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "LeadAggregate",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "dimensions",
            "description": "Typed values for every selected report dimension.",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "LeadReportDimensions",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "key",
            "description": "The first dimension key, retained for single-dimension report compatibility.",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "The first dimension label, retained for single-dimension report compatibility.",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LeadSource",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LeadFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "LeadAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LeadSourceFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leads",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LeadFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LeadStatus",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "LeadStatusEnum",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "intent",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LeadFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "LeadAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LeadStatusChangedEvent",
        "description": "Lead",
        "isOneOf": null,
        "fields": [
          {
            "name": "clientName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "newStatus",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "oldStatus",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "LeadStatusEnum",
        "description": null,
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "assigned",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "converted",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lost",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "new",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LeadStatusFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leads",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LeadFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LineItem",
        "description": "description=A manufactured or supplied part, unit, or work item within a job.\ndisplayName=Work Order\nmodule=Manufacturing\ndefaultQuery=lineItems\niconName=wrench\ncolour=#A96500\naggregateQuery=lineItemsAggregate\nreportQuery=lineItemReport\ngrouping=true\nqueryPermission=Query_Job_Parts",
        "isOneOf": null,
        "fields": [
          {
            "name": "batch",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Batch",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "batchId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "confirmed",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "confirmedDate",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "confirmedSale",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Job",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "masterWorkflow",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "LineItemMasterWorkflow",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "oldSpecification",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Specification",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "partNumber",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "partType",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "PartType",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salePrice",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LineItemAggregate",
        "description": "description=A manufactured or supplied part, unit, or work item within a job.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "totalConfirmedSale",
            "description": "description=Total confirmed sale value.\npermission=Report_Confirmed_Sales\nsortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LineItemFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "LineItemFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "batch",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BatchFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "batchId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "confirmed",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "confirmedDate",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "confirmedSale",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "masterWorkflow",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LineItemMasterWorkflowFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "LineItemFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "partNumber",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "partType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PartTypeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salePrice",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LineItemMasterWorkflow",
        "description": "description=The workflow subject that tracks manufacturing process instances for a line item.\ndisplayName=Line Item Master Workflow\nmodule=Manufacturing\ndefaultQuery=lineItemMasterWorkflows\niconName=git-branch\ncolour=#A96500\naggregateQuery=lineItemMasterWorkflowsAggregate\ngrouping=true\nqueryPermission=Query_Line_Item_Master_Workflows",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groupInstances",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "GroupInstanceFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "GroupInstance",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "items",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "WorkflowNodeFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "WorkflowNode",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItem",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "LineItem",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderedItems",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "WorkflowNode",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderedProcessInstances",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProcessInstance",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processAssets",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessAssetFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProcessAsset",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processInstanceAggregate",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessInstanceFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessInstanceAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processInstances",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessInstanceFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProcessInstance",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LineItemMasterWorkflowAggregate",
        "description": "description=The workflow subject that tracks manufacturing process instances for a line item.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LineItemMasterWorkflowCompletedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "lineItemMasterWorkflowId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LineItemMasterWorkflowFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "LineItemMasterWorkflowFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groupInstances",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GroupInstanceFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "items",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "WorkflowNodeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItem",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LineItemFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "LineItemMasterWorkflowFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processAssets",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessAssetFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processInstances",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessInstanceFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LineItemMasterWorkflowReportDimensionValue",
        "description": "A Line Item Master Workflow identity or a typed nested report dimension.",
        "isOneOf": null,
        "fields": [
          {
            "name": "key",
            "description": "Stable machine-readable Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "Display label for the Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItem",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "LineItemReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LineItemMasterWorkflowReportGroupByInput",
        "description": "Select exactly one typed Line Item Master Workflow report dimension.",
        "isOneOf": true,
        "fields": null,
        "inputFields": [
          {
            "name": "lineItem",
            "description": "Group by Work Order or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LineItemReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LineItemMasterWorkflowReportRelationDimensionInput",
        "description": "Groups by Line Item Master Workflow identity, or traverses to one of its typed dimensions.",
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "filter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LineItemMasterWorkflowFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groupBy",
            "description": "Traverse through this relation and group by a field or relation on the related Resource.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LineItemMasterWorkflowReportGroupByInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeEmpty",
            "description": "Include filtered related records that have no contributing resource rows.",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LineItemReportDimensionValue",
        "description": "A Work Order identity or a typed nested report dimension.",
        "isOneOf": null,
        "fields": [
          {
            "name": "batch",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "BatchReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "confirmedDate",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "JobReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "key",
            "description": "Stable machine-readable Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "Display label for the Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "masterWorkflow",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "LineItemMasterWorkflowReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "partType",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "PartTypeReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LineItemReportDimensions",
        "description": "Typed Work Order report dimension values.",
        "isOneOf": null,
        "fields": [
          {
            "name": "batch",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "BatchReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "confirmedDate",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "JobReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "masterWorkflow",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "LineItemMasterWorkflowReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "partType",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "PartTypeReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LineItemReportGroupByInput",
        "description": "Select exactly one typed Work Order report dimension.",
        "isOneOf": true,
        "fields": null,
        "inputFields": [
          {
            "name": "batch",
            "description": "Group by Batch or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BatchReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "confirmedDate",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeReportDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": "Group by Job or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "masterWorkflow",
            "description": "Group by Line Item Master Workflow or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LineItemMasterWorkflowReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "partType",
            "description": "Group by Part Type or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PartTypeReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LineItemReportRelationDimensionInput",
        "description": "Groups by Work Order identity, or traverses to one of its typed dimensions.",
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "filter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LineItemFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groupBy",
            "description": "Traverse through this relation and group by a field or relation on the related Resource.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LineItemReportGroupByInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeEmpty",
            "description": "Include filtered related records that have no contributing resource rows.",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LineItemReportRow",
        "description": "One grouped Work Order report row.",
        "isOneOf": null,
        "fields": [
          {
            "name": "aggregate",
            "description": "The generated LineItem aggregate, constrained to this dimension row.",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LineItemFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "LineItemAggregate",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "dimensions",
            "description": "Typed values for every selected report dimension.",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "LineItemReportDimensions",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "key",
            "description": "The first dimension key, retained for single-dimension report compatibility.",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "The first dimension label, retained for single-dimension report compatibility.",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LineItemWorkflowPlaceholderInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "workflowTemplateId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowTypeId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LinkedAction",
        "description": "description=A global or role/user-assigned configured action, or current-user favourite, with bindings from its source record.\ndisplayName=Shortcut\ndefaultQuery=linkedActions\naggregateQuery=linkedActionsAggregate\ngrouping=true\nqueryPermission=Query_Linked_Actions",
        "isOneOf": null,
        "fields": [
          {
            "name": "actionId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "bindings",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "displayOrder",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "enabled",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ownerUserId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordPath",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LinkedActionAggregate",
        "description": "description=A global or role/user-assigned configured action, or current-user favourite, with bindings from its source record.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LinkedActionFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "actionId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "LinkedActionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "bindings",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "displayOrder",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "enabled",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "LinkedActionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ownerUserId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordPath",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LostReason",
        "description": "description=A list of reasons to choose from for lost jobs or leads.\ndisplayName=Lost Reason\nmodule=Admin\ndefaultQuery=lostReasons\ncolour=#5D35A6\naggregateQuery=lostReasonsAggregate\ngrouping=true\nqueryPermission=Query_Lost_Reasons",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LostReasonAggregate",
        "description": "description=A list of reasons to choose from for lost jobs or leads.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LostReasonFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "LostReasonFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "LostReasonFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "LostReasonReportDimensionValue",
        "description": "A Lost Reason identity or a typed nested report dimension.",
        "isOneOf": null,
        "fields": [
          {
            "name": "key",
            "description": "Stable machine-readable Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "Display label for the Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LostReasonReportRelationDimensionInput",
        "description": "Groups by Lost Reason identity, or traverses to one of its typed dimensions.",
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "filter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LostReasonFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeEmpty",
            "description": "Include filtered related records that have no contributing resource rows.",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Machine",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "machineTypeId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "MachineFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "machineType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "MachineTypeFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "MachineType",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "machines",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "MachineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Machine",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "MachineTypeFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "MarkJobLostInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "additionalNotes",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lostReasonId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "MarkLeadLostInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "additionalNotes",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lostReasonId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Money",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "amount",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currency",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Month",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "createdLeadAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LeadFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "LeadAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createdPurchaseOrderAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createdPurchaseOrderLineAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderLineAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "monthNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "monthNumberAndYear",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteLineAggregateByJobEstDue",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteLineAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "year",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Mutation",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "acceptQuote",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AcceptQuoteInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "activatePerson",
            "description": null,
            "args": [
              {
                "name": "personId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "amendPurchaseOrder",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AmendPurchaseOrderInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignBusinessRolesToBatchSchedule",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AssignBusinessRolesToBatchScheduleInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignBusinessRolesToPerson",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AssignBusinessRolesToPersonInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignInheritanceToRole",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AssignInheritanceToRoleInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignLeadsToSalesperson",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AssignLeadsToSalespersonInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignPermissionsToRole",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AssignPermissionsToRoleInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignPermissionsToUser",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AssignPermissionsToUserInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignRolesToUser",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AssignRolesToUserInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignScreensToRole",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AssignScreensToRoleInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignScreensToUser",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AssignScreensToUserInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignUsersToProcessInstance",
            "description": null,
            "args": [
              {
                "name": "processInstanceId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "userRoles",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "LIST",
                    "name": null,
                    "ofType": {
                      "kind": "NON_NULL",
                      "name": null,
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "ID",
                        "ofType": null
                      }
                    }
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignUsersToRole",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AssignUsersToRoleInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "bulkCreatePurchaseOrder",
            "description": null,
            "args": [
              {
                "name": "orders",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "LIST",
                    "name": null,
                    "ofType": {
                      "kind": "NON_NULL",
                      "name": null,
                      "ofType": {
                        "kind": "INPUT_OBJECT",
                        "name": "CreatePurchaseOrderInput",
                        "ofType": null
                      }
                    }
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "place",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Boolean",
                  "ofType": null
                },
                "defaultValue": "false",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "bulkProductImport",
            "description": null,
            "args": [
              {
                "name": "productsToImport",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "LIST",
                    "name": null,
                    "ofType": {
                      "kind": "NON_NULL",
                      "name": null,
                      "ofType": {
                        "kind": "INPUT_OBJECT",
                        "name": "ProductImportInput",
                        "ofType": null
                      }
                    }
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "updateFields",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "LIST",
                    "name": null,
                    "ofType": {
                      "kind": "NON_NULL",
                      "name": null,
                      "ofType": {
                        "kind": "ENUM",
                        "name": "ProductImportUpdateField",
                        "ofType": null
                      }
                    }
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "bulkProductPriceAdjustment",
            "description": null,
            "args": [
              {
                "name": "productIds",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "LIST",
                    "name": null,
                    "ofType": {
                      "kind": "NON_NULL",
                      "name": null,
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "ID",
                        "ofType": null
                      }
                    }
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "cancelPurchaseOrders",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CancelPurchaseOrdersInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "cancelSalesOrder",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CancelSalesOrderInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "cancelSupplierQuoteRequest",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CancelSupplierQuoteRequestInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "cleanupFiles",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Void",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "clearPermissionCache",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "commitPendingFiles",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CommitPendingFilesInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "completeTimers",
            "description": null,
            "args": [
              {
                "name": "timerIds",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "LIST",
                    "name": null,
                    "ofType": {
                      "kind": "NON_NULL",
                      "name": null,
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "ID",
                        "ofType": null
                      }
                    }
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "confirmSalesOrder",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ConfirmSalesOrderInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "convertCandidate",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "convertLeadToJob",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ConvertLeadToJobInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createAuthToken",
            "description": null,
            "args": [
              {
                "name": "userId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createBatch",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateBatchInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createBranch",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateBranchInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createBuilder",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateBuilderInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createBusinessRole",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateBusinessRoleInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createCandidate",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateCandidateInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "AsyncTask",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createClient",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateClientInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createCorrespondence",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateCorrespondenceInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createCosting",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateCostingInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createCostingTemplate",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateCostingTemplateInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createCostingTemplateRevision",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateCostingTemplateRevisionInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createDocumentTemplate",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateDocumentTemplateInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createFiles",
            "description": null,
            "args": [
              {
                "name": "files",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "LIST",
                    "name": null,
                    "ofType": {
                      "kind": "NON_NULL",
                      "name": null,
                      "ofType": {
                        "kind": "INPUT_OBJECT",
                        "name": "CreateFileInput",
                        "ofType": null
                      }
                    }
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createFirebaseAuthToken",
            "description": null,
            "args": [
              {
                "name": "userId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createFolder",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateFolderInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createHousingCompany",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateHousingCompanyInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createHousingCompanyImage",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateHousingCompanyImageInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createIssue",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateIssueInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createJob",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateJobInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createJobComponent",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateJobComponentInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createJobEmail",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateJobEmailInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createJobFileUrl",
            "description": null,
            "args": [
              {
                "name": "jobId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createLead",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateLeadInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createLineItem",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateLineItemInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createLostReason",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateLostReasonInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createPanel",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreatePanelInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createPartType",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreatePartTypeInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createPerson",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreatePersonInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createProcessAsset",
            "description": null,
            "args": [
              {
                "name": "assetId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "processInstanceId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createProcessTimer",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateProcessTimerInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createProcessType",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateProcessTypeInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createProcessTypeNote",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateProcessTypeNoteInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createProcessTypeRole",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateProcessTypeRoleInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createProduct",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateProductInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createProductCategory",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateProductCategoryInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createProductPrice",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateProductPriceInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createProject",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateProjectInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createPurchaseOrder",
            "description": null,
            "args": [
              {
                "name": "place",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Boolean",
                  "ofType": null
                },
                "defaultValue": "false",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "purchaseOrder",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreatePurchaseOrderInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderSavePayload",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createPurchaseOrderFromSupplierQuote",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreatePurchaseOrderFromSupplierQuoteInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createPurchaseOrderReceipt",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreatePurchaseOrderReceiptInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createQuote",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateQuoteInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createQuoteApprovalRequest",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateQuoteApprovalRequestInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createQuoteTemplate",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateQuoteTemplateInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createQuoteTemplateRevision",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateQuoteTemplateRevisionInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createRecordFile",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateRecordFileInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createRole",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateRoleInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createSalesOrder",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateSalesOrderInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createSchema",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateSchemaInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createSchemaVersion",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchemaVersionInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createScreen",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateScreenInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createSignedUploadUrl",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateSignedUploadUrlInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "SignedUploadUrlPayload",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createSpecification",
            "description": null,
            "args": [
              {
                "name": "lineItemId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createStorageConnection",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateStorageConnectionInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createStorageResourceMapping",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateStorageResourceMappingInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createSubscription",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateSubscriptionInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createSupplier",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateSupplierInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createSupplierImage",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateSupplierImageInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createSupplierQuote",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateSupplierQuoteInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createSupplierQuoteRequest",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateSupplierQuoteRequestInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createTag",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateTagInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createUser",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateUserInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createUserIdentity",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateUserIdentityInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createWarehouse",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateWarehouseInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createWebhook",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateWebhookInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createWorkflowType",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateWorkflowTypeInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deactivatePerson",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeactivatePersonInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteBatches",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteBatchesInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteBranches",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteBranchesInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteBuilders",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteBuildersInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteBusinessRole",
            "description": null,
            "args": [
              {
                "name": "businessRoleId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteCandidate",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteClients",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteClientsInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteConfiguredLinkedActions",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteConfiguredLinkedActionsInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteCorrespondence",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteCorrespondenceInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteCosting",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteCostingInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteCustomData",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteDocumentTemplate",
            "description": null,
            "args": [
              {
                "name": "documentTemplateId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteDraftPurchaseOrders",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteDraftPurchaseOrdersInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteExternalStorageItems",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteExternalStorageItemsInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteFavouriteLinkedAction",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteHousingCompanies",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteHousingCompaniesInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteHousingCompanyImage",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteHousingCompanyImageInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteJobComponent",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteJobComponentInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteLeads",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteLeadsInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteLineItems",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteLineItemsInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteLostReasons",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteLostReasonsInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deletePanels",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeletePanelsInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deletePartTypes",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeletePartTypesInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteProcessTypeNote",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteProcessTypeNoteInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteProcessTypeRoles",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteProcessTypeRolesInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteProcessTypes",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteProcessTypesInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteProductCategories",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteProductCategoriesInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteProductPrices",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteProductPricesInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteQuote",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteRecordFiles",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteRecordFilesInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "Void",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteRole",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteSalesOrder",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteSalesOrderInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteSchema",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteSchemaVersion",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteScreens",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteScreensInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteStorageConnection",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteStorageResourceMapping",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteSubscription",
            "description": null,
            "args": [
              {
                "name": "subscriptionId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteSupplierImage",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteSupplierImageInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteSupplierQuote",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteSupplierQuoteInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteSupplierQuoteRequest",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteSupplierQuoteRequestInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteSuppliers",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteSuppliersInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteTag",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteUser",
            "description": null,
            "args": [
              {
                "name": "userId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteUserIdentities",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteUserIdentitiesInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteWarehouse",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteWebhooks",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteWebhooksInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleteWorkflowTypes",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteWorkflowTypesInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "disableUser",
            "description": null,
            "args": [
              {
                "name": "userId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "enableUser",
            "description": null,
            "args": [
              {
                "name": "userId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "generateCurrentProductPricing",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "issueQuote",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "IssueQuoteInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markJobLost",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "MarkJobLostInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markLeadLost",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "MarkLeadLostInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markPurchaseOrderInvoiceAsChecked",
            "description": null,
            "args": [
              {
                "name": "purchaseOrderId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markPurchaseOrderInvoiceAsUnchecked",
            "description": null,
            "args": [
              {
                "name": "purchaseOrderId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notifyJobPhotoRecipients",
            "description": null,
            "args": [
              {
                "name": "area",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "jobNumber",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "notes",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "overrideLeadStatus",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "OverrideLeadStatusInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "overridePurchaseOrderStatus",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "OverridePurchaseOrderStatusInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "pauseTimers",
            "description": null,
            "args": [
              {
                "name": "timerIds",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "LIST",
                    "name": null,
                    "ofType": {
                      "kind": "NON_NULL",
                      "name": null,
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "ID",
                        "ofType": null
                      }
                    }
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "promoteSchemaVersion",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "PromoteSchemaVersionInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "publishDraftCostingRevision",
            "description": null,
            "args": [
              {
                "name": "costingId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "publishDraftCostingTemplate",
            "description": null,
            "args": [
              {
                "name": "costingTemplateId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "publishDraftQuoteTemplate",
            "description": null,
            "args": [
              {
                "name": "quoteTemplateId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "receiveWarehouseStock",
            "description": "Supported for ONLY receiving product stock to a warehouse,\nif you want to bulk update (e.g adding/removing) then use the transferstock or\nstocktake endpoints.",
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ReceiveWarehouseStockInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "releasePurchaseOrders",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ReleasePurchaseOrdersInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "removeProcessAsset",
            "description": null,
            "args": [
              {
                "name": "assetId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "processInstanceId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "rescheduleBatches",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "RescheduleBatchesInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "rescheduleProcessTypeNote",
            "description": null,
            "args": [
              {
                "name": "date",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "processTypeNoteId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resendPurchaseOrderSupplierNotification",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "AsyncTask",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resetUserPassword",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResetUserPasswordInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "restorePartTypes",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "RestorePartTypesInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "restoreProcessTypes",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "RestoreProcessTypesInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "restoreWorkflowTypes",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "RestoreWorkflowTypesInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resumeTimers",
            "description": null,
            "args": [
              {
                "name": "timerIds",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "LIST",
                    "name": null,
                    "ofType": {
                      "kind": "NON_NULL",
                      "name": null,
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "ID",
                        "ofType": null
                      }
                    }
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reviseQuote",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ReviseQuoteInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screenAssignment",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ScreenAssignmentInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screenUnassignment",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ScreenUnassignmentInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "setCandidateIngestionPolicy",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SetCandidateIngestionPolicyInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "setConfiguredLinkedAction",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SetConfiguredLinkedActionInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "setCustomData",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SetCustomDataInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "setDefaultCostingTemplate",
            "description": null,
            "args": [
              {
                "name": "costingTemplateId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "setDefaultDocumentTemplate",
            "description": null,
            "args": [
              {
                "name": "documentTemplateId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "setDefaultFolder",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SetDefaultFolderInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "setDefaultQuoteTemplate",
            "description": null,
            "args": [
              {
                "name": "quoteTemplateId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "setFavouriteLinkedAction",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SetFavouriteLinkedActionInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "setLinkedActionRecipient",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SetLinkedActionRecipientInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "setUserPin",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SetUserPinInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "submitPurchaseOrderReview",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SubmitPurchaseOrderReviewInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "submitQuoteForApproval",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "transferWarehouseStock",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "TransferWarehouseStockInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "triggerWebhook",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "TriggerWebhookInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unassignBusinessRolesFromPerson",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UnassignBusinessRolesFromPersonInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unassignInheritanceFromRole",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UnassignInheritanceFromRoleInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unassignLeadsFromSalesperson",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UnassignLeadsFromSalespersonInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unassignPermissionsFromRole",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UnassignPermissionsFromRoleInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unassignPermissionsFromUser",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UnassignPermissionsFromUserInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unassignRolesFromUser",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UnassignRolesFromUserInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unassignScreensFromRole",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UnassignScreensFromRoleInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unassignScreensFromUser",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UnassignScreensFromUserInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unassignUsersFromRole",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UnassignUsersFromRoleInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unmarkJobLost",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UnmarkJobLostInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unmarkLeadLost",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UnmarkLeadLostInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unsetUserPin",
            "description": null,
            "args": [
              {
                "name": "userId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateBatchDetails",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateBatchDetailsInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateBranch",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateBranchInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateBuilder",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateBuilderInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateBusinessRole",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateBusinessRoleInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateClient",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateClientInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateCorrespondence",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateCorrespondenceInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateCosting",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateCostingInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateCurrentUserNotifications",
            "description": null,
            "args": [
              {
                "name": "action",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "ENUM",
                    "name": "NotificationAction",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "ids",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "LIST",
                    "name": null,
                    "ofType": {
                      "kind": "NON_NULL",
                      "name": null,
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "ID",
                        "ofType": null
                      }
                    }
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateDocumentTemplate",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateDocumentTemplateInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateDraftCostingTemplateRevision",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateCostingTemplateRevisionInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateDraftPurchaseOrder",
            "description": null,
            "args": [
              {
                "name": "place",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Boolean",
                  "ofType": null
                },
                "defaultValue": "false",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "purchaseOrder",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateDraftPurchaseOrderInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "purchaseOrderId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderSavePayload",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateDraftQuoteTemplateRevision",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateQuoteTemplateRevisionInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateDraftSchemaVersion",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateDraftSchemaVersionInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateHousingCompany",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateHousingCompanyInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateIssue",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateIssueInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateJobBuilder",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateJobBuilderInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateJobClient",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateJobClientInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateJobComponent",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateJobComponentInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateJobDetails",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateJobDetailsInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateJobNote",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateJobNoteInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateJobSite",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateJobSiteInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateLead",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateLeadInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateLineItem",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateLineItemInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateLineItemWorkflow",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateLineItemWorkflowInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateLostReason",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateLostReasonInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updatePanelConfig",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdatePanelConfigInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updatePanelDetails",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdatePanelDetailsInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updatePartType",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdatePartTypeInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updatePermissionForRole",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdatePermissionForRoleInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updatePermissionForUser",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdatePermissionForUserInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updatePerson",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdatePersonInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateProcessInstanceDetails",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateProcessInstanceDetailsInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateProcessInstanceStatus",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateProcessInstanceStatusInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateProcessTypeDetails",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateProcessTypeDetailsInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateProcessTypeNote",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateProcessTypeNoteInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateProcessTypeRole",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateProcessTypeRoleInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateProductCategory",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateProductCategoryInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateProductDetails",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateProductDetailsInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updatePurchaseOrderInternalComment",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdatePurchaseOrderInternalCommentInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateQuote",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateQuoteInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateRoleDetails",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateRoleDetailsInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateSalesOrder",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateSalesOrderInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateSchemaDetails",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateSchemaDetailsInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateScreenConfig",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateScreenConfigInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateScreenDetails",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateScreenDetailsInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateSettings",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateSettingsInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateStorageConnection",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateStorageConnectionInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateStorageResourceMapping",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateStorageResourceMappingInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateSubscription",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateSubscriptionInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateSupplierDetails",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateSupplierDetailsInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateSupplierQuote",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateSupplierQuoteInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateSupplierQuoteRequest",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateSupplierQuoteRequestInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateSupplierReviewers",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateSupplierReviewersInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateTag",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateTagInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateUserDetails",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateUserDetailsInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateUserSubscriptions",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateUserSubscriptionsInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateWarehouse",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateWarehouseInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateWebhook",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateWebhookInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "updateWorkflowTypeDetails",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateWorkflowTypeDetailsInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouseStockTake",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "WarehouseStockTakeInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "withdrawWarehouseStock",
            "description": "Supported for withdrawing product stock from a warehouse,\nif you want to bulk update then use the transferstock or\nstocktake endpoints.",
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "WithdrawWarehouseStockInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "NZRegion",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "JobFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "JobAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "NotificationAction",
        "description": null,
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "ACKNOWLEDGE",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "CLEAR",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "MARK_UNREAD",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "NotificationAttachmentInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "bodyTemplateId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "filename",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "NotificationInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "attachments",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "NotificationAttachmentInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "bodyTemplateId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "NotificationTemplate",
        "description": "description=A subscription notification channel with its body and attachment templates.\ndisplayName=Notification Template\nmodule=Admin\ndefaultQuery=notificationTemplates\niconName=notifications\ncolour=#5D35A6\naggregateQuery=notificationTemplatesAggregate\ngrouping=true\nqueryPermission=Query_Notification_Templates",
        "isOneOf": null,
        "fields": [
          {
            "name": "attachmentTemplates",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "AttachmentTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AttachmentTemplate",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "bodyTemplateId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "subscription",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "SubscriptionReal",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "NotificationTemplateAggregate",
        "description": "description=A subscription notification channel with its body and attachment templates.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "NotificationTemplateFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "NotificationTemplateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "attachmentTemplates",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "AttachmentTemplateFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "bodyTemplateId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "NotificationTemplateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "subscription",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SubscriptionRealFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "NumberFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "eq",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "gt",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "gte",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "in",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lt",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lte",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "OptionsInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "groupBy",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "limit",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "offset",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sort",
            "description": "TODO: implement frontend ui support for array inputs",
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SortInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "OrderCategory",
        "description": null,
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "FACTORY",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "JOB",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "OFFICE",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "STOCK",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "VEHICLE",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "OrderEmailStatusUpdatedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "orderEmail",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "OrderOverrideStatusEvent",
        "description": "PurchaseOrder",
        "isOneOf": null,
        "fields": [
          {
            "name": "newStatus",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "oldStatus",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "OrderReceiptCreatedEvent",
        "description": "PurchaseOrderReceipt",
        "isOneOf": null,
        "fields": [
          {
            "name": "lineData",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "receiptId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouseId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "OrderReviewStatus",
        "description": null,
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "APPROVED",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "NOT_APPLICABLE",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PENDING",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "REJECTED",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "OrderRevisionCreatedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "orderRevision",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "OrderShippingMethods",
        "description": null,
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "SeaFreight",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "OrderShippingTerms",
        "description": null,
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "CFR",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "CIF",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "CIP",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "CPT",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "DAP",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "DAT",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "DDP",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "EXW",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "FAS",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "FCA",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "FOB",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "OrderStatus",
        "description": null,
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "APPROVED",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "CANCELLED",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "DRAFT",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "INCOMPLETE",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ON_HOLD",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ORDERED",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PENDING_REVIEW",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "RECEIVED",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "REJECTED",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "RELEASED",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "OverrideLeadStatusInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "leadId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "OverridePurchaseOrderStatusInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "purchaseOrderId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "OrderStatus",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PageInfo",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "limit",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "offset",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "totalCount",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PagedJobs",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "items",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Job",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "pageInfo",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "PaginatedResultInterface",
            "ofType": null
          }
        ],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedResult",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "pageInfo",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "PaginatedResultInterface",
            "ofType": null
          }
        ],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INTERFACE",
        "name": "PaginatedResultInterface",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "pageInfo",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PagedJobs",
            "ofType": null
          },
          {
            "kind": "OBJECT",
            "name": "PaginatedResult",
            "ofType": null
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Panel",
        "description": "description=A reusable dashboard panel configuration.\ndisplayName=Panel\nmodule=Admin\ndefaultQuery=panels\niconName=panel\ncolour=#5D35A6\naggregateQuery=panelsAggregate\ngrouping=true\nqueryPermission=Query_Panels",
        "isOneOf": null,
        "fields": [
          {
            "name": "compatibleRecordTypes",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "config",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordTags",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RecordTagFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "RecordTag",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "source",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PanelAggregate",
        "description": "description=A reusable dashboard panel configuration.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PanelFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "PanelFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "config",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "PanelFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordTags",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RecordTagFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PartType",
        "description": "description=A sales classification used to group job components and work-order parts.\ndisplayName=Part Type\nmodule=Sales\ndefaultQuery=partTypes\niconName=wrench\ncolour=#A91F54\naggregateQuery=partTypesAggregate\ngrouping=true\nqueryPermission=Query_Part_Types",
        "isOneOf": null,
        "fields": [
          {
            "name": "code",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "colour",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PartTypeAggregate",
        "description": "description=A sales classification used to group job components and work-order parts.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PartTypeCreatedEvent",
        "description": "PartType",
        "isOneOf": null,
        "fields": [
          {
            "name": "partTypeId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "partTypeName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PartTypeDeletedEvent",
        "description": "PartType",
        "isOneOf": null,
        "fields": [
          {
            "name": "partTypeId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "partTypeName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PartTypeFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "PartTypeFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "colour",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "PartTypeFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PartTypeReportDimensionValue",
        "description": "A Part Type identity or a typed nested report dimension.",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "key",
            "description": "Stable machine-readable Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "Display label for the Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PartTypeReportGroupByInput",
        "description": "Select exactly one typed Part Type report dimension.",
        "isOneOf": true,
        "fields": null,
        "inputFields": [
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeReportDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeReportDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PartTypeReportRelationDimensionInput",
        "description": "Groups by Part Type identity, or traverses to one of its typed dimensions.",
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "filter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PartTypeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groupBy",
            "description": "Traverse through this relation and group by a field or relation on the related Resource.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PartTypeReportGroupByInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeEmpty",
            "description": "Include filtered related records that have no contributing resource rows.",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PartTypeRestoredEvent",
        "description": "PartType",
        "isOneOf": null,
        "fields": [
          {
            "name": "partTypeId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "partTypeName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PartTypeUpdatedEvent",
        "description": "PartType",
        "isOneOf": null,
        "fields": [
          {
            "name": "partTypeId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "partTypeName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Permission",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "category",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "categoryGroup",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "conditionalPolicyInputType",
            "description": "The GraphQL input type to use for conditional policies",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PermissionCheckInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "conditions",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "permission",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PermissionFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PermissionInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "conditions",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "permissionId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "policy",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "Policy",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PermissionPolicy",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "conditions",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "permission",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Permission",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "policy",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "Policy",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "role",
            "description": "The Role this permission came from, if any",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Role",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PermissionScope",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "description",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Person",
        "description": "description=An individual person who can be assigned to work in the system.\ndisplayName=Person\nmodule=Admin\ndefaultQuery=people\niconName=person\ncolour=#5D35A6\naggregateQuery=peopleAggregate\ngrouping=true\nqueryPermission=Query_People",
        "isOneOf": null,
        "fields": [
          {
            "name": "assignedDesignerLeadCount",
            "description": "description=The number of currently assigned leads attached to this person as a designer.\nsortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedWork",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PersonAssignedWorkFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "PersonAssignedWork",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branch",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Branch",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "businessRoleLabels",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "confirmedDesignerJobCount",
            "description": "description=The number of confirmed jobs assigned to this person as a designer.\nsortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "connectedUser",
            "description": "description=The system user account connected to this person.\nsortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "designerPreviousYtdSales",
            "description": "description=Confirmed sales for the equivalent completed-month YTD period in the previous year.\npermission=Report_Confirmed_Sales\nsortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "designerSalesYtd",
            "description": "description=Completed-month YTD confirmed sales for jobs assigned to this person as a designer.\npermission=Report_Confirmed_Sales\nsortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isActive",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "outstandingDesignerQuoteCount",
            "description": "description=The number of issued quotes awaiting a customer outcome for jobs assigned to this person as a designer.\nsortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "personBusinessRoles",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PersonBusinessRoleFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "PersonBusinessRole",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTimeTodaySeconds",
            "description": "description=Seconds on process timers since midnight in the application database timezone (New Zealand), including running intervals and excluding pauses. Refreshed when queried.\nsortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unconfirmedDesignerJobCount",
            "description": "description=The number of unconfirmed jobs assigned to this person as a designer.\nsortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PersonAggregate",
        "description": "description=An individual person who can be assigned to work in the system.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PersonAssignedWork",
        "description": "description=A normalized read model of work assigned to a person across role-specific assignment sources.\ndisplayName=Person Assigned Work\nmodule=Admin\ndefaultQuery=personAssignedWork\niconName=briefcase\ncolour=#5D35A6\naggregateQuery=personAssignedWorkAggregate\ngrouping=true\nqueryPermission=Query_Person_Assigned_Work",
        "isOneOf": null,
        "fields": [
          {
            "name": "assignmentType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "businessRole",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "BusinessRole",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "person",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Person",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "personBusinessRole",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "PersonBusinessRole",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "record",
            "description": "description=Identity metadata for the assigned record, without loading the destination record.\nsortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "PersonAssignedWorkRecordReference",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordLabel",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "statusLabel",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PersonAssignedWorkAggregate",
        "description": "description=A normalized read model of work assigned to a person across role-specific assignment sources.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PersonAssignedWorkFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "PersonAssignedWorkFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignmentType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "businessRole",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BusinessRoleFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "PersonAssignedWorkFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "person",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PersonFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "personBusinessRole",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PersonBusinessRoleFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordLabel",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "statusLabel",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PersonAssignedWorkRecordReference",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "recordId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PersonBusinessRole",
        "description": "description=A role assignment that makes a person available for a type of business work.\ndisplayName=Person Business Role\nmodule=Admin\ndefaultQuery=personBusinessRoles\niconName=person\ncolour=#5D35A6\naggregateQuery=personBusinessRolesAggregate\ngrouping=true\nqueryPermission=Query_Person_Business_Roles",
        "isOneOf": null,
        "fields": [
          {
            "name": "assignedWork",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PersonAssignedWorkFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "PersonAssignedWork",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "businessRole",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "BusinessRole",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isActive",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobs",
            "description": "description=Jobs assigned to this person in this business role through legacy assignment columns.\nsortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "JobFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Job",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "person",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Person",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processAssignments",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessAssignmentFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProcessAssignment",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PersonBusinessRoleAggregate",
        "description": "description=A role assignment that makes a person available for a type of business work.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PersonBusinessRoleFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "PersonBusinessRoleFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedWork",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PersonAssignedWorkFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "businessRole",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BusinessRoleFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isActive",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "PersonBusinessRoleFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "person",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PersonFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processAssignments",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessAssignmentFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PersonBusinessRoleReportDimensionValue",
        "description": "A Person Business Role identity or a typed nested report dimension.",
        "isOneOf": null,
        "fields": [
          {
            "name": "businessRole",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "BusinessRoleReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "key",
            "description": "Stable machine-readable Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "Display label for the Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "person",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "PersonReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PersonBusinessRoleReportGroupByInput",
        "description": "Select exactly one typed Person Business Role report dimension.",
        "isOneOf": true,
        "fields": null,
        "inputFields": [
          {
            "name": "businessRole",
            "description": "Group by Business Role or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BusinessRoleReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "person",
            "description": "Group by Person or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PersonReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PersonBusinessRoleReportRelationDimensionInput",
        "description": "Groups by Person Business Role identity, or traverses to one of its typed dimensions.",
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "filter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PersonBusinessRoleFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groupBy",
            "description": "Traverse through this relation and group by a field or relation on the related Resource.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PersonBusinessRoleReportGroupByInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeEmpty",
            "description": "Include filtered related records that have no contributing resource rows.",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PersonFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "PersonFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedWork",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PersonAssignedWorkFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branch",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BranchFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "businessRoleLabels",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "connectedUser",
            "description": "The system user account connected to this person.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "hasActiveSystemAccess",
            "description": "Filter People by whether they have active system access.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeInactive",
            "description": "Include inactive people in query results.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isActive",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isCurrentUser",
            "description": "Filter People by whether they are connected to the current user.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "PersonFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "personBusinessRoles",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PersonBusinessRoleFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "projectManagedJobs",
            "description": "People assigned as Project Manager to matching jobs.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PersonReportDimensionValue",
        "description": "A Person identity or a typed nested report dimension.",
        "isOneOf": null,
        "fields": [
          {
            "name": "branch",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "BranchReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "connectedUser",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "UserReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "key",
            "description": "Stable machine-readable Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "Display label for the Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PersonReportGroupByInput",
        "description": "Select exactly one typed Person report dimension.",
        "isOneOf": true,
        "fields": null,
        "inputFields": [
          {
            "name": "branch",
            "description": "Group by Branch or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BranchReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "connectedUser",
            "description": "Group by User or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeReportDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PersonReportRelationDimensionInput",
        "description": "Groups by Person identity, or traverses to one of its typed dimensions.",
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "filter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PersonFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groupBy",
            "description": "Traverse through this relation and group by a field or relation on the related Resource.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PersonReportGroupByInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeEmpty",
            "description": "Include filtered related records that have no contributing resource rows.",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PersonStatus",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "peopleAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PersonFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PersonAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "Policy",
        "description": null,
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "Allow",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Conditional",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Deny",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProcessAsset",
        "description": "description=An asset assigned to a process type for a workflow subject.\ndisplayName=Process Asset\nmodule=Manufacturing\ndefaultQuery=processAssets\niconName=cog\ncolour=#A96500\naggregateQuery=processAssetsAggregate\ngrouping=true\nqueryPermission=Query_Process_Assets",
        "isOneOf": null,
        "fields": [
          {
            "name": "asset",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Asset",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assetId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemMasterWorkflow",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "LineItemMasterWorkflow",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processType",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessType",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTypeId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowSubjectId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProcessAssetAggregate",
        "description": "description=An asset assigned to a process type for a workflow subject.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ProcessAssetFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessAssetFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "asset",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "AssetFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assetId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemMasterWorkflow",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LineItemMasterWorkflowFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessAssetFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessTypeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTypeId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowSubjectId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProcessAssignment",
        "description": "description=A user role assigned to a process type for a workflow subject.\ndisplayName=Process Assignment\nmodule=Manufacturing\ndefaultQuery=processAssignments\niconName=people\ncolour=#A96500\naggregateQuery=processAssignmentsAggregate\ngrouping=true\nqueryPermission=Query_Process_Assignments",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "personBusinessRoleId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processType",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ProcessType",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTypeId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userRole",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "UserRole",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userRoleId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowSubject",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "LineItemMasterWorkflow",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowSubjectId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProcessAssignmentAggregate",
        "description": "description=A user role assigned to a process type for a workflow subject.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ProcessAssignmentFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessAssignmentFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemMasterWorkflow",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LineItemMasterWorkflowFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessAssignmentFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "personBusinessRoleId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessTypeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTypeId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userRole",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserRoleFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userRoleId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowSubject",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LineItemMasterWorkflowFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowSubjectId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProcessInstance",
        "description": "description=A running manufacturing workflow process for a specific item or job.\ndisplayName=Process Instance\nmodule=Manufacturing\ndefaultQuery=processInstances\ncolour=#A96500\naggregateQuery=processInstancesAggregate\ngrouping=true\nqueryPermission=Query_Process_Instances",
        "isOneOf": null,
        "fields": [
          {
            "name": "assignableUserRoles",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UserRole",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedHours",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "dueDate",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "elapsedTime",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadDays",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemMasterWorkflow",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "LineItemMasterWorkflow",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processAssets",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProcessAsset",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processAssignments",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProcessAssignment",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processType",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessType",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "scheduled",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "startBy",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflow",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Workflow",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProcessInstanceAggregate",
        "description": "description=A running manufacturing workflow process for a specific item or job.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ProcessInstanceFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessInstanceFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedHours",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedUsers",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "dueDate",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "elapsedTime",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadDays",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemMasterWorkflow",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LineItemMasterWorkflowFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessInstanceFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ordered",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processAssignments",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessAssignmentFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessTypeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "scheduled",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "startBy",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflow",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "WorkflowFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProcessTemplate",
        "description": "description=A reusable process step inside a workflow template.\ndisplayName=Process Template\nmodule=Manufacturing\ndefaultQuery=processTemplates\niconName=data-lineage\ncolour=#A96500\naggregateQuery=processTemplatesAggregate\ngrouping=true\nqueryPermission=Query_Process_Templates",
        "isOneOf": null,
        "fields": [
          {
            "name": "assignedHours",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadDays",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processType",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessType",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProcessTemplateAggregate",
        "description": "description=A reusable process step inside a workflow template.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ProcessTemplateFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTemplateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedHours",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadDays",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTemplateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessTypeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProcessTimer",
        "description": "description=A user timer with process items and elapsed time across its transactions.\ndisplayName=Process Timer\nmodule=Manufacturing\ndefaultQuery=timers\niconName=time\ncolour=#A96500\naggregateQuery=timersAggregate\ngrouping=true\nqueryPermission=Query_Process_Timers",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "elapsedTime",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "itemAggregate",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTimerItemFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessTimerItemAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "items",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTimerItemFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProcessTimerItem",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "transactions",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "TimerTransactionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "TimerTransaction",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProcessTimerAggregate",
        "description": "description=A user timer with process items and elapsed time across its transactions.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ProcessTimerFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTimerFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "elapsedTime",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "items",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessTimerItemFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTimerFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "transactions",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "TimerTransactionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProcessTimerItem",
        "description": "description=A process type and workflow subject assigned to a process timer.\ndisplayName=Process Timer Item\nmodule=Manufacturing\ndefaultQuery=processTimerItems\niconName=timer\ncolour=#A96500\naggregateQuery=processTimerItemsAggregate\ngrouping=true\nqueryPermission=Query_Process_Timer_Items",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemMasterWorkflow",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "LineItemMasterWorkflow",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processType",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ProcessType",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTypeId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "timer",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ProcessTimer",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "timerId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowSubjectId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProcessTimerItemAggregate",
        "description": "description=A process type and workflow subject assigned to a process timer.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ProcessTimerItemFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTimerItemFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemMasterWorkflow",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LineItemMasterWorkflowFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTimerItemFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessTypeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTypeId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "timer",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessTimerFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "timerId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowSubjectId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProcessType",
        "description": "description=A reusable manufacturing process definition used by workflow types.\ndisplayName=Process Type\nmodule=Manufacturing\ndefaultQuery=processTypes\niconName=data-lineage\ncolour=#A96500\naggregateQuery=processTypesAggregate\ngrouping=true\nqueryPermission=Query_Process_Types",
        "isOneOf": null,
        "fields": [
          {
            "name": "assignments",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessAssignmentFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProcessAssignment",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roles",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTypeRoleFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProcessTypeRole",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProcessTypeAggregate",
        "description": "description=A reusable manufacturing process definition used by workflow types.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProcessTypeCreatedEvent",
        "description": "ProcessType",
        "isOneOf": null,
        "fields": [
          {
            "name": "processTypeId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTypeName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProcessTypeDeletedEvent",
        "description": "ProcessType",
        "isOneOf": null,
        "fields": [
          {
            "name": "processTypeId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTypeName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ProcessTypeFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTypeFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignments",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessAssignmentFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTypeFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processInstances",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessInstanceFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roles",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessTypeRoleFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProcessTypeNote",
        "description": "description=A schedule note assigned to one or more manufacturing process types.\ndisplayName=Process Type Note\nmodule=Manufacturing\ndefaultQuery=processTypeNotes\niconName=message-square-text\ncolour=#A96500\naggregateQuery=processTypeNotesAggregate\ngrouping=true\nqueryPermission=Query_Process_Type_Notes",
        "isOneOf": null,
        "fields": [
          {
            "name": "assignedProcessTypes",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProcessType",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "date",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "note",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProcessTypeNoteAggregate",
        "description": "description=A schedule note assigned to one or more manufacturing process types.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ProcessTypeNoteFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTypeNoteFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "date",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "note",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTypeNoteFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessTypeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProcessTypeReportDimensionValue",
        "description": "A Process Type identity or a typed nested report dimension.",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "key",
            "description": "Stable machine-readable Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "Display label for the Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ProcessTypeReportGroupByInput",
        "description": "Select exactly one typed Process Type report dimension.",
        "isOneOf": true,
        "fields": null,
        "inputFields": [
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeReportDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeReportDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ProcessTypeReportRelationDimensionInput",
        "description": "Groups by Process Type identity, or traverses to one of its typed dimensions.",
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "filter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessTypeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groupBy",
            "description": "Traverse through this relation and group by a field or relation on the related Resource.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessTypeReportGroupByInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeEmpty",
            "description": "Include filtered related records that have no contributing resource rows.",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProcessTypeRestoredEvent",
        "description": "ProcessType",
        "isOneOf": null,
        "fields": [
          {
            "name": "processTypeId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTypeName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProcessTypeRole",
        "description": "description=A role type that may be assigned to users working on a manufacturing process type.\ndisplayName=Process Type Role\nmodule=Manufacturing\ndefaultQuery=processTypeRoles\niconName=people\ncolour=#A96500\naggregateQuery=processTypeRolesAggregate\ngrouping=true\nqueryPermission=Query_Process_Type_Roles",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processType",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ProcessType",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProcessTypeRoleAggregate",
        "description": "description=A role type that may be assigned to users working on a manufacturing process type.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ProcessTypeRoleFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTypeRoleFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTypeRoleFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessTypeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProcessTypeUpdatedEvent",
        "description": "ProcessType",
        "isOneOf": null,
        "fields": [
          {
            "name": "processTypeId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTypeName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Product",
        "description": "description=An inventory product that can be stocked, purchased, priced, and used on jobs.\ndisplayName=Product\nmodule=Inventory\ndefaultQuery=products\niconName=box\ncolour=#596600\naggregateQuery=productsAggregate\ngrouping=true\nqueryPermission=Query_Products",
        "isOneOf": null,
        "fields": [
          {
            "name": "availableStock",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "category",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ProductCategory",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currentBuyPrice",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currentSellPrice",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "daysStockLeft",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "forecastedDemandQty",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "forecastedReorderUrgencyQty",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "forecastedStockRemainingQty",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "image",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ExternalStorageItem",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "indent",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isStockItem",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadTime",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrderLineAggregate",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderLineAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "qtyReviewThreshold",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteLineAggregate",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteLineAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordTags",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RecordTagFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "RecordTag",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reorderLevel",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "safetyStockDays",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "safetyStockQty",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "starred",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stock",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "StockFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Stock",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stockByWarehouse",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "StockFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Stock",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stockGapDays",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stockedQty",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplier",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Supplier",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "template",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitOfMeasure",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "url",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProductAggregate",
        "description": "description=An inventory product that can be stocked, purchased, priced, and used on jobs.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProductCategory",
        "description": "description=An inventory category used to group and filter products.\ndisplayName=Product Category\nmodule=Inventory\ndefaultQuery=productCategories\niconName=group-item\ncolour=#596600\naggregateQuery=productCategoriesAggregate\ngrouping=true\nqueryPermission=Query_Product_Categories",
        "isOneOf": null,
        "fields": [
          {
            "name": "childProductCategoriesAggregate",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProductCategoryFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProductCategoryAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "children",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProductCategoryFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProductCategory",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "group",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ProductCategoryGroup",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "parent",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ProductCategory",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "products",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProductFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Product",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProductCategoryAggregate",
        "description": "description=An inventory category used to group and filter products.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ProductCategoryFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProductCategoryFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "children",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProductCategoryFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "group",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProductCategoryGroupFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeSubCategories",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProductCategoryFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "parent",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProductCategoryFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "products",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProductFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProductCategoryGroup",
        "description": "description=A grouping used to organise related inventory product categories.\ndisplayName=Product Category Group\nmodule=Inventory\ndefaultQuery=productCategoryGroups\ncolour=#596600\naggregateQuery=productCategoryGroupsAggregate\ngrouping=true\nqueryPermission=Query_Product_Category_Groups",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProductCategoryGroupAggregate",
        "description": "description=A grouping used to organise related inventory product categories.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ProductCategoryGroupFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProductCategoryGroupFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProductCategoryGroupFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProductCreatedEvent",
        "description": "Product",
        "isOneOf": null,
        "fields": [
          {
            "name": "productId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "productName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProductDetailsUpdatedEvent",
        "description": "Product",
        "isOneOf": null,
        "fields": [
          {
            "name": "productId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "productName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ProductFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProductFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "category",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProductCategoryFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currentBuyPrice",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currentSellPrice",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "indent",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isStockItem",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadTime",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProductFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "qtyReviewThreshold",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordTags",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RecordTagFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "safetyStockDays",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "starred",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stock",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StockFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stockByWarehouse",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StockFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stockedQty",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplier",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SupplierFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "template",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitOfMeasure",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "url",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ProductImportInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "buyPrice",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "buyPriceEffectiveDate",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "category",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "operation",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "productId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplier",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "ProductImportUpdateField",
        "description": null,
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "BuyPrice",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Description",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProductPrice",
        "description": "description=A dated buy or sell price for an inventory product.\ndisplayName=Product Price\nmodule=Inventory\ndefaultQuery=productPrices\niconName=dollar\ncolour=#596600\naggregateQuery=productPricesAggregate\ngrouping=true\nqueryPermission=Query_Product_Prices",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "effectiveDate",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "product",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Product",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitPrice",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProductPriceAggregate",
        "description": "description=A dated buy or sell price for an inventory product.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProductPriceCreatedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "entity",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProductPriceDeletedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "entity",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ProductPriceFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProductPriceFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "effectiveDate",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProductPriceFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "product",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProductFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitPrice",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Project",
        "description": "description=A sales project used to group related work.\ndisplayName=Project\nmodule=Sales\ndefaultQuery=projects\niconName=projects\ncolour=#A91F54\naggregateQuery=projectsAggregate\ngrouping=true\nqueryPermission=Query_Projects",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ProjectAggregate",
        "description": "description=A sales project used to group related work.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ProjectFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProjectFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProjectFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PromoteSchemaVersionInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "schemaVersionId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrder",
        "description": "description=An order for products or services placed with a supplier.\ndisplayName=Purchase Order\nmodule=Inventory\ndefaultQuery=purchaseOrders\niconName=cargo-ship\ncolour=#596600\naggregateQuery=purchaseOrdersAggregate\ngrouping=true\nqueryPermission=Query_Purchase_Orders",
        "isOneOf": null,
        "fields": [
          {
            "name": "acknowledgedBy",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "amended",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "approved",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "category",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deliveryAddress",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deliveryAddressEntity",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "DeliveryAddress",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "documents",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "DocumentTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Document",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "emails",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "EmailFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Email",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "incomplete",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "internalComment",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "invoiceChecked",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Job",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "PurchaseOrderLine",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notificationStatus",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notifySupplierWhenPlaced",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "placedBy",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "poNumber",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrderLineAggregate",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderLineAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "required",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reviews",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderReviewFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "PurchaseOrderReview",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "shippingMethod",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "shippingTerms",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "siteVisitRequired",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ssspCompleted",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "statusWhenPlaced",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplier",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Supplier",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierComment",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierStatus",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "template",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "DocumentTemplate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "urgent",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouse",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Warehouse",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderAggregate",
        "description": "description=An order for products or services placed with a supplier.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "incompleteSupplierSssp",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderAmendedEvent",
        "description": "PurchaseOrder",
        "isOneOf": null,
        "fields": [
          {
            "name": "orderId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderApprovedEvent",
        "description": "PurchaseOrder",
        "isOneOf": null,
        "fields": [
          {
            "name": "comment",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "placedByUserId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderCancelledEvent",
        "description": "PurchaseOrder",
        "isOneOf": null,
        "fields": [
          {
            "name": "orderId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "payload",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrder",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrder",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PurchaseOrderEventFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrder",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PurchaseOrderFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PurchaseOrderFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "acknowledgedBy",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "amended",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "approved",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "category",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deliveryAddress",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deliveryAddressEntity",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DeliveryAddressFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "emails",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "EmailFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "incomplete",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "internalComment",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "invoiceChecked",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PurchaseOrderLineFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notificationStatus",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notifySupplierWhenPlaced",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "placedBy",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "poNumber",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "required",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reviews",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PurchaseOrderReviewFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "shippingMethod",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "shippingTerms",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "siteVisitRequired",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ssspCompleted",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PurchaseOrderStatusFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "statusWhenPlaced",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplier",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SupplierFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierComment",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierStatus",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "template",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DocumentTemplateFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "urgent",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouse",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "WarehouseFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderIncompleteEvent",
        "description": "PurchaseOrder",
        "isOneOf": null,
        "fields": [
          {
            "name": "orderId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderLine",
        "description": "description=A product or service line ordered from a supplier on a purchase order.\ndisplayName=Purchase Order Line\nmodule=Inventory\ndefaultQuery=purchaseOrderLines\ncolour=#596600\naggregateQuery=purchaseOrderLinesAggregate\ngrouping=true\nqueryPermission=Query_Purchase_Order_Lines",
        "isOneOf": null,
        "fields": [
          {
            "name": "buyPrice",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "line",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderedQty",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "product",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Product",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrder",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrder",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "receivedQty",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "totalPrice",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unit",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderLineAggregate",
        "description": "description=A product or service line ordered from a supplier on a purchase order.",
        "isOneOf": null,
        "fields": [
          {
            "name": "averageDailyQuantity",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "count",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PurchaseOrderLineFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderLineFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "buyPrice",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "line",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderLineFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderedQty",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "product",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProductFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrder",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PurchaseOrderFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "receivedQty",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unit",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PurchaseOrderLineInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "buyPrice",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "product",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unit",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderPendingReviewEvent",
        "description": "PurchaseOrder",
        "isOneOf": null,
        "fields": [
          {
            "name": "orderId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderPlacedEvent",
        "description": "PurchaseOrder",
        "isOneOf": null,
        "fields": [
          {
            "name": "orderId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderPreview",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "html",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderReceipt",
        "description": "description=A receipt recording goods received against a purchase order.\ndisplayName=Purchase Order Receipt\nmodule=Inventory\ndefaultQuery=purchaseOrderReceipts\niconName=receipt\ncolour=#596600\naggregateQuery=purchaseOrderReceiptsAggregate\ngrouping=true\nqueryPermission=Query_Purchase_Order_Receipts",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderReceiptLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "PurchaseOrderReceiptLine",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notes",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrder",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrder",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderReceiptAggregate",
        "description": "description=A receipt recording goods received against a purchase order.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PurchaseOrderReceiptFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderReceiptFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PurchaseOrderReceiptLineFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notes",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderReceiptFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrder",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PurchaseOrderFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderReceiptLine",
        "description": "description=The quantity received for one purchase order line on a receipt.\ndisplayName=Purchase Order Receipt Line\nmodule=Inventory\ndefaultQuery=purchaseOrderReceiptLines\niconName=list\ncolour=#596600\naggregateQuery=purchaseOrderReceiptLinesAggregate\ngrouping=true\nqueryPermission=Query_Purchase_Order_Receipt_Lines",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "line",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderLine",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "receipt",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderReceipt",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderReceiptLineAggregate",
        "description": "description=The quantity received for one purchase order line on a receipt.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PurchaseOrderReceiptLineFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderReceiptLineFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "line",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PurchaseOrderLineFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderReceiptLineFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "receipt",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PurchaseOrderReceiptFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PurchaseOrderReceiptLineInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "orderLineId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderReceivedEvent",
        "description": "PurchaseOrder",
        "isOneOf": null,
        "fields": [
          {
            "name": "orderId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderRejectedEvent",
        "description": "PurchaseOrder",
        "isOneOf": null,
        "fields": [
          {
            "name": "comment",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "placedByUserId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderReleasedEvent",
        "description": "PurchaseOrder",
        "isOneOf": null,
        "fields": [
          {
            "name": "orderId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderReview",
        "description": "description=A reviewer decision on a purchase order.\ndisplayName=Purchase Order Review\nmodule=Inventory\ndefaultQuery=purchaseOrderReviews\niconName=endorsed\ncolour=#596600\naggregateQuery=purchaseOrderReviewsAggregate\ngrouping=true\nqueryPermission=Query_Purchase_Order_Reviews",
        "isOneOf": null,
        "fields": [
          {
            "name": "comment",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "completedAt",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrder",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrder",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderReviewAggregate",
        "description": "description=A reviewer decision on a purchase order.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PurchaseOrderReviewFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderReviewFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "comment",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "completedAt",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderReviewFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrder",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PurchaseOrderFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderSavePayload",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "purchaseOrderId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "OrderStatus",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderStatus",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrderAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PurchaseOrderStatusFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrders",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PurchaseOrderFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderSupplierNotificationManuallySentEvent",
        "description": "PurchaseOrder",
        "isOneOf": null,
        "fields": [
          {
            "name": "orderId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderReference",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseOrderSupplierNotificationSentEvent",
        "description": "PurchaseOrder",
        "isOneOf": null,
        "fields": [
          {
            "name": "orderId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderReference",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Query",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "actAsUser",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ActAsUser",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "actAsUsers",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ActAsUserFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ActAsUser",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "actAsUsersAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ActAsUserFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ActAsUserAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "asset",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Asset",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assets",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "AssetFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Asset",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assetsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "AssetFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "AssetAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedPermissions",
            "description": null,
            "args": [
              {
                "name": "assignedId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "assignedType",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "AssignedPermissionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "AssignedPermission",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "asyncTask",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "AsyncTask",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "asyncTasks",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "AsyncTaskFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "AsyncTask",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "asyncTasksAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "AsyncTaskFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "AsyncTaskAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "attachmentTemplate",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "AttachmentTemplate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "attachmentTemplates",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "AttachmentTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "AttachmentTemplate",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "attachmentTemplatesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "AttachmentTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "AttachmentTemplateAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "auditLog",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "AuditLog",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "auditLogs",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "AuditLogFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "AuditLog",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "auditLogsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "AuditLogFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ResourceAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "batch",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Batch",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "batchSchedule",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "BatchSchedule",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "batchScheduleReport",
            "description": null,
            "args": [
              {
                "name": "groupBy",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "LIST",
                    "name": null,
                    "ofType": {
                      "kind": "NON_NULL",
                      "name": null,
                      "ofType": {
                        "kind": "INPUT_OBJECT",
                        "name": "BatchScheduleReportGroupByInput",
                        "ofType": null
                      }
                    }
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "BatchScheduleReportRow",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "batchSchedules",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "BatchScheduleFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "BatchSchedule",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "batchSchedulesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "BatchScheduleFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "BatchScheduleAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "batches",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "BatchFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Batch",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "batchesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "BatchFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "BatchAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "billOfMaterialsImport",
            "description": null,
            "args": [
              {
                "name": "jobId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "loader",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "path",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "BillOfMaterialsImport",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branch",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Branch",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branches",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "BranchFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Branch",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branchesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "BranchFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "BranchAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "buildType",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "BuildType",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "buildTypes",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "BuildTypeFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "BuildType",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "buildTypesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "BuildTypeFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "BuildTypeAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "builder",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Builder",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "builders",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "BuilderFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Builder",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "buildersAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "BuilderFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "BuilderAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "businessRole",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "BusinessRole",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "businessRoles",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "BusinessRoleFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "BusinessRole",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "businessRolesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "BusinessRoleFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "BusinessRoleAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "calculateQuote",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CalculateQuoteInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Quote",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "candidate",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Candidate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "candidateIngestionPolicies",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CandidateIngestionPolicyFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "CandidateIngestionPolicy",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "candidateIngestionPoliciesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CandidateIngestionPolicyFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CandidateIngestionPolicyAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "candidateIngestionPolicy",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CandidateIngestionPolicy",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "candidates",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CandidateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Candidate",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "candidatesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CandidateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CandidateAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "client",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Client",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "clients",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ClientFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Client",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "clientsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ClientFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ClientAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "configuredLinkedAction",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ConfiguredLinkedAction",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "configuredLinkedActions",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ConfiguredLinkedActionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ConfiguredLinkedAction",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "configuredLinkedActionsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ConfiguredLinkedActionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ConfiguredLinkedActionAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "correspondence",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CorrespondenceFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Correspondence",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "correspondenceAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CorrespondenceFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CorrespondenceAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "correspondenceRecord",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Correspondence",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costing",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Costing",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingLine",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CostingLine",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingLineTemplate",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CostingLineTemplate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingLineTemplates",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingLineTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "CostingLineTemplate",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingLineTemplatesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingLineTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CostingLineTemplateAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingLines",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "CostingLine",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingLinesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CostingLineAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingRevision",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CostingRevision",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingRevisions",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingRevisionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "CostingRevision",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingRevisionsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingRevisionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CostingRevisionAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingTemplate",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CostingTemplate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingTemplateExpression",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CostingTemplateExpression",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingTemplateExpressions",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingTemplateExpressionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "CostingTemplateExpression",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingTemplateExpressionsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingTemplateExpressionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CostingTemplateExpressionAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingTemplateRevision",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CostingTemplateRevision",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingTemplateRevisions",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingTemplateRevisionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "CostingTemplateRevision",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingTemplateRevisionsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingTemplateRevisionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CostingTemplateRevisionAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingTemplates",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "CostingTemplate",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingTemplatesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CostingTemplateAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costings",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Costing",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CostingAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currentUser",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currentUserNotifications",
            "description": null,
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "UserNotification",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "CustomData",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataById",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomData",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customTemplate",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomTemplate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customTemplates",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "CustomTemplate",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customTemplatesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomTemplateAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "days",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "DateTimeFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Day",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "defaultFolder",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "DefaultFolder",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "defaultFolders",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "DefaultFolderFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultFolder",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "defaultFoldersAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "DefaultFolderFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "DefaultFolderAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deliveryAddress",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "DeliveryAddress",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deliveryAddresses",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "DeliveryAddressFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DeliveryAddress",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deliveryAddressesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "DeliveryAddressFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "DeliveryAddressAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "documentNavigationRecords",
            "description": null,
            "args": [
              {
                "name": "recordId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "recordType",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "RecordNavigationRecord",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "documentPreview",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetDocumentPreviewInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "DocumentPreview",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "documentTemplate",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "DocumentTemplate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "documentTemplates",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "DocumentTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DocumentTemplate",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "documentTemplatesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "DocumentTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "DocumentTemplateAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "domainEventTypes",
            "description": null,
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "ENUM",
                  "name": "DomainEventType",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "effectiveUserPermissions",
            "description": null,
            "args": [
              {
                "name": "userId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "EffectivePermission",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "email",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Email",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "emails",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "EmailFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Email",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "emailsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "EmailFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "EmailAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "eventDescriptionPreview",
            "description": null,
            "args": [
              {
                "name": "eventName",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "externalStorageConnection",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ExternalStorageConnection",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "externalStorageConnections",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ExternalStorageConnectionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ExternalStorageConnection",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "externalStorageConnectionsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ExternalStorageConnectionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ExternalStorageConnectionAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "externalStorageItem",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ExternalStorageItem",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "externalStorageItems",
            "description": "aggregateQuery=externalStorageItemsAggregate\ngrouping=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ExternalStorageItemFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ExternalStorageItem",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "externalStorageItemsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ExternalStorageItemFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ResourceAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "externalStorageResourceMapping",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ExternalStorageResourceMapping",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "externalStorageResourceMappings",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ExternalStorageResourceMappingFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ExternalStorageResourceMapping",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "externalStorageResourceMappingsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ExternalStorageResourceMappingFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ExternalStorageResourceMappingAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "file",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "File",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "fileAggregates",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "FileFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "FileAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "fileChangeset",
            "description": "TODO: Return an operation along with the file info eg \"NEW\" or \"DELETED\"\n so that our frontend can show pending changes to the user.\nWould therefore need to return a slightly modified ExternalStorageItem.\nReturns a list of files in targetPath as if changeset was applied.\nOnly supports native (Google Cloud) storage, no resource mappings.\n$path must be of format {resourceType}/{resourceId}/{restOfPath...}",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ExternalStorageItemFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "targetPath",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ExternalStorageItem",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "files",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "FileFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "File",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "formNavigationRecords",
            "description": null,
            "args": [
              {
                "name": "recordId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "recordType",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "RecordNavigationRecord",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "googleDownloadFilesRequestUrl",
            "description": null,
            "args": [
              {
                "name": "fileHashes",
                "description": "Array of file hash strings.",
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "LIST",
                    "name": null,
                    "ofType": {
                      "kind": "NON_NULL",
                      "name": null,
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "String",
                        "ofType": null
                      }
                    }
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "firebaseTenantId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "firebaseUserId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "googleUploadRequestUrl",
            "description": null,
            "args": [
              {
                "name": "object",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "graphqlQueryGen",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AIGenInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groupTemplate",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "GroupTemplate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groupTemplates",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "GroupTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "GroupTemplate",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groupTemplatesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "GroupTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "GroupTemplateAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "housingCompanies",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "HousingCompanyFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "HousingCompany",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "housingCompaniesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "HousingCompanyFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "HousingCompanyAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "housingCompany",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "HousingCompany",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isPermitted",
            "description": null,
            "args": [
              {
                "name": "permissions",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "LIST",
                    "name": null,
                    "ofType": {
                      "kind": "NON_NULL",
                      "name": null,
                      "ofType": {
                        "kind": "INPUT_OBJECT",
                        "name": "PermissionCheckInput",
                        "ofType": null
                      }
                    }
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "userId",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "issue",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Issue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "issueCompletionStatuses",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "IssueFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "IssueCompletionStatus",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "issues",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "IssueFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Issue",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "issuesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "IssueFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "IssueAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Job",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobComponent",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "JobComponent",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobComponents",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "JobComponentFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "JobComponent",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobComponentsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "JobComponentFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "JobComponentAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobReport",
            "description": null,
            "args": [
              {
                "name": "groupBy",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "LIST",
                    "name": null,
                    "ofType": {
                      "kind": "NON_NULL",
                      "name": null,
                      "ofType": {
                        "kind": "INPUT_OBJECT",
                        "name": "JobReportGroupByInput",
                        "ofType": null
                      }
                    }
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "JobReportRow",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobStatuses",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "JobStatusFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "JobStatus",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobs",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "JobFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Job",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "JobFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "JobAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lead",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Lead",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadCandidateGen",
            "description": null,
            "args": [
              {
                "name": "input",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AIGenInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadProjectTypes",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LeadFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "LeadProjectType",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadReport",
            "description": null,
            "args": [
              {
                "name": "groupBy",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "LIST",
                    "name": null,
                    "ofType": {
                      "kind": "NON_NULL",
                      "name": null,
                      "ofType": {
                        "kind": "INPUT_OBJECT",
                        "name": "LeadReportGroupByInput",
                        "ofType": null
                      }
                    }
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "LeadReportRow",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadSources",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LeadSourceFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "LeadSource",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadStatuses",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LeadStatusFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "LeadStatus",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leads",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LeadFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Lead",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LeadFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "LeadAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "legacyUserRole",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "UserRole",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "legacyUserRoles",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "UserRoleFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "UserRole",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "legacyUserRolesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "UserRoleFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "UserRoleAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItem",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "LineItem",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemMasterWorkflow",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "LineItemMasterWorkflow",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemMasterWorkflows",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LineItemMasterWorkflowFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "LineItemMasterWorkflow",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemMasterWorkflowsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LineItemMasterWorkflowFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "LineItemMasterWorkflowAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemReport",
            "description": null,
            "args": [
              {
                "name": "groupBy",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "LIST",
                    "name": null,
                    "ofType": {
                      "kind": "NON_NULL",
                      "name": null,
                      "ofType": {
                        "kind": "INPUT_OBJECT",
                        "name": "LineItemReportGroupByInput",
                        "ofType": null
                      }
                    }
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "LineItemReportRow",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItems",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LineItemFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "LineItem",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LineItemFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "LineItemAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "linkedAction",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "LinkedAction",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "linkedActions",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LinkedActionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "LinkedAction",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "linkedActionsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LinkedActionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "LinkedActionAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lostReason",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "LostReason",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lostReasons",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LostReasonFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "LostReason",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lostReasonsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LostReasonFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "LostReasonAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "months",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "DateTimeFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Month",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notificationTemplate",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "NotificationTemplate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notificationTemplates",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "NotificationTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "NotificationTemplate",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notificationTemplatesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "NotificationTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "NotificationTemplateAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "nzRegions",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "DateTimeFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "NZRegion",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "panel",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Panel",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "panels",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PanelFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Panel",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "panelsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PanelFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PanelAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "partType",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PartType",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "partTypes",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PartTypeFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "PartType",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "partTypesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PartTypeFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PartTypeAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "people",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PersonFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Person",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "peopleAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PersonFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PersonAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "permissions",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PermissionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Permission",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "permitted",
            "description": null,
            "args": [
              {
                "name": "permission",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "person",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Person",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "personAssignedWork",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PersonAssignedWorkFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "PersonAssignedWork",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "personAssignedWorkAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PersonAssignedWorkFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PersonAssignedWorkAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "personAssignedWorkById",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PersonAssignedWork",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "personBusinessRole",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PersonBusinessRole",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "personBusinessRoles",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PersonBusinessRoleFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "PersonBusinessRole",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "personBusinessRolesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PersonBusinessRoleFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PersonBusinessRoleAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "personStatuses",
            "description": null,
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "PersonStatus",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processAsset",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessAsset",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processAssets",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessAssetFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ProcessAsset",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processAssetsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessAssetFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessAssetAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processAssignment",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessAssignment",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processAssignments",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessAssignmentFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ProcessAssignment",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processAssignmentsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessAssignmentFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessAssignmentAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processInstance",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessInstance",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processInstances",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessInstanceFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ProcessInstance",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processInstancesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessInstanceFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessInstanceAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTemplate",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessTemplate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTemplates",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ProcessTemplate",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTemplatesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessTemplateAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTimer",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessTimer",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTimerItem",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessTimerItem",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTimerItems",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTimerItemFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ProcessTimerItem",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTimerItemsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTimerItemFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessTimerItemAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processType",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessType",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTypeNote",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessTypeNote",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTypeNotes",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTypeNoteFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ProcessTypeNote",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTypeNotesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTypeNoteFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessTypeNoteAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTypeRole",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessTypeRole",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTypeRoles",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTypeRoleFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ProcessTypeRole",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTypeRolesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTypeRoleFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessTypeRoleAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTypes",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTypeFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ProcessType",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTypesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTypeFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessTypeAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "product",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Product",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "productCategories",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProductCategoryFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ProductCategory",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "productCategoriesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProductCategoryFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProductCategoryAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "productCategory",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProductCategory",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "productCategoryGroup",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProductCategoryGroup",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "productCategoryGroups",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProductCategoryGroupFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ProductCategoryGroup",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "productCategoryGroupsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProductCategoryGroupFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProductCategoryGroupAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "productPrice",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProductPrice",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "productPrices",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProductPriceFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ProductPrice",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "productPricesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProductPriceFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProductPriceAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "products",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProductFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Product",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "productsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProductFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProductAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "project",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Project",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "projects",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProjectFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Project",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "projectsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProjectFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProjectAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrder",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrder",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrderEvents",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderEventFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "PurchaseOrderEvent",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrderLine",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderLine",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrderLines",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "PurchaseOrderLine",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrderLinesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderLineAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrderPreview",
            "description": null,
            "args": [
              {
                "name": "purchaseOrderId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderPreview",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrderReceipt",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderReceipt",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrderReceiptLine",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderReceiptLine",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrderReceiptLines",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderReceiptLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "PurchaseOrderReceiptLine",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrderReceiptLinesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderReceiptLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderReceiptLineAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrderReceipts",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderReceiptFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "PurchaseOrderReceipt",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrderReceiptsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderReceiptFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderReceiptAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrderReview",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderReview",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrderReviews",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderReviewFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "PurchaseOrderReview",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrderReviewsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderReviewFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderReviewAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrderStatuses",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderStatusFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "PurchaseOrderStatus",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrders",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "PurchaseOrder",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrdersAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quote",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Quote",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteLine",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteLine",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteLineTemplate",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteLineTemplate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteLineTemplates",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteLineTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "QuoteLineTemplate",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteLineTemplatesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteLineTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteLineTemplateAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteLines",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "QuoteLine",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteLinesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteLineAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quotePreview",
            "description": null,
            "args": [
              {
                "name": "quote",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateQuoteInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "QuotePreview",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteRevision",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteRevision",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteRevisions",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteRevisionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "QuoteRevision",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteRevisionsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteRevisionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteRevisionAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteStatuses",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "QuoteStatus",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplate",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteTemplate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplateExpression",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteTemplateExpression",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplateExpressions",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteTemplateExpressionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "QuoteTemplateExpression",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplateExpressionsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteTemplateExpressionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteTemplateExpressionAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplatePreview",
            "description": null,
            "args": [
              {
                "name": "costings",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "twigTemplate",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteTemplatePreview",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplateRevision",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteTemplateRevision",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplateRevisions",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteTemplateRevisionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "QuoteTemplateRevision",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplateRevisionsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteTemplateRevisionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteTemplateRevisionAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplates",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "QuoteTemplate",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplatesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteTemplateAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quotes",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Quote",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quotesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordDocuments",
            "description": null,
            "args": [
              {
                "name": "documentTemplateId",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "recordId",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "recordType",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Document",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordFile",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "RecordFile",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordFileAggregates",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RecordFileFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "RecordFileAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordFiles",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RecordFileFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "RecordFile",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordFolder",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "RecordFolder",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordFolders",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RecordFolderFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "RecordFolder",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordFoldersAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RecordFolderFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "RecordFolderAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordScreen",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "RecordScreen",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordScreens",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RecordScreenFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "RecordScreen",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordScreensAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RecordScreenFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "RecordScreenAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordTag",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "RecordTag",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordTags",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RecordTagFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "RecordTag",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordTagsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RecordTagFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "RecordTagAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordTypes",
            "description": null,
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "ENUM",
                  "name": "RecordType",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "region",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Region",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "regions",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RegionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Region",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "regionsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RegionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "RegionAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resolvedRecordScreen",
            "description": null,
            "args": [
              {
                "name": "recordType",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Screen",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "role",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Role",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleInheritance",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "RoleInheritance",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleInheritances",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RoleInheritanceFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "RoleInheritance",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleInheritancesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RoleInheritanceFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "RoleInheritanceAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "rolePermission",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "RolePermission",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "rolePermissions",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RolePermissionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "RolePermission",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "rolePermissionsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RolePermissionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "RolePermissionAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleUser",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "RoleUser",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleUsers",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RoleUserFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "RoleUser",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleUsersAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RoleUserFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "RoleUserAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roles",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RoleFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Role",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "rolesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RoleFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "RoleAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "saleType",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "SaleType",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "saleTypes",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SaleTypeFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SaleType",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "saleTypesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SaleTypeFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "SaleTypeAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesOrder",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "SalesOrder",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesOrderLine",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "SalesOrderLine",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesOrderLines",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SalesOrderLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SalesOrderLine",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesOrderLinesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SalesOrderLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ResourceAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesOrders",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SalesOrderFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SalesOrder",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesOrdersAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SalesOrderFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "SalesOrderAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "schema",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Schema",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "schemaTypes",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SchemaTypeFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SchemaType",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "schemaVersion",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "SchemaVersion",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "schemaVersions",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SchemaVersionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SchemaVersion",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "schemaVersionsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SchemaVersionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "SchemaVersionAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "schemas",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SchemaFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Schema",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "schemasAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SchemaFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "SchemaAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screen",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Screen",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screenAssignments",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RecordScreenFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "RecordScreen",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screens",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ScreenFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Screen",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screensAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ScreenFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ScreenAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "specification",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Specification",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "specificationLookupOptions",
            "description": null,
            "args": [
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "search",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "type",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SpecificationLookupOption",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stock",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "StockFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Stock",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stockAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "StockFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "StockAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stockRecord",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Stock",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stockTransaction",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "StockTransaction",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stockTransactionLine",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "StockTransactionLine",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stockTransactionLines",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "StockTransactionLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "StockTransactionLine",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stockTransactionLinesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "StockTransactionLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "StockTransactionLineAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stockTransactions",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "StockTransactionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "StockTransaction",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stockTransactionsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "StockTransactionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "StockTransactionAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "subscriptionReal",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "SubscriptionReal",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "subscriptions",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SubscriptionRealFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SubscriptionReal",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "subscriptionsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SubscriptionRealFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "SubscriptionRealAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplier",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Supplier",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierCategories",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierCategoryFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SupplierCategory",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierCategoriesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierCategoryFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "SupplierCategoryAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierCategory",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "SupplierCategory",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuote",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "SupplierQuote",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuoteLine",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "SupplierQuoteLine",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuoteLines",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierQuoteLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SupplierQuoteLine",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuoteLinesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierQuoteLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ResourceAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuoteRequest",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "SupplierQuoteRequest",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuoteRequestLine",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "SupplierQuoteRequestLine",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuoteRequestLines",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierQuoteRequestLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SupplierQuoteRequestLine",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuoteRequestLinesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierQuoteRequestLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "SupplierQuoteRequestLineAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuoteRequests",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierQuoteRequestFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SupplierQuoteRequest",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuoteRequestsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierQuoteRequestFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "SupplierQuoteRequestAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuotes",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierQuoteFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SupplierQuote",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuotesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierQuoteFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "SupplierQuoteAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "suppliers",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Supplier",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "suppliersAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "SupplierAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "systemSettings",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "DataStoreRecord",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "tag",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Tag",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "tags",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "TagFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Tag",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "tagsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "TagFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "TagAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "timerTransaction",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "TimerTransaction",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "timerTransactions",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "TimerTransactionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "TimerTransaction",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "timerTransactionsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "TimerTransactionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "TimerTransactionAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "timers",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTimerFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ProcessTimer",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "timersAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTimerFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessTimerAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "uploadRequestUrl",
            "description": null,
            "args": [
              {
                "name": "area",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "fileName",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "jobNumber",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "notes",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "UploadRequestUrl",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userIdentities",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "UserIdentityFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "UserIdentity",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userIdentitiesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "UserIdentityFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "UserIdentityAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userIdentity",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "UserIdentity",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userPermission",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "UserPermission",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userPermissions",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "UserPermissionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "UserPermission",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userPermissionsAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "UserPermissionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "UserPermissionAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "users",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "UserFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "User",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "usersAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "UserFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "UserAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouse",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Warehouse",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouses",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "WarehouseFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Warehouse",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehousesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "WarehouseFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "WarehouseAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "webhook",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "Webhook",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "webhooks",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "WebhookFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Webhook",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "webhooksAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "WebhookFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "WebhookAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "weeks",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "WeekFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Week",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowNote",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "WorkflowNote",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowNotes",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "WorkflowNoteFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "WorkflowNote",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowNotesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "WorkflowNoteFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "WorkflowNoteAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowTemplate",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "WorkflowTemplate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowTemplates",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "WorkflowTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "WorkflowTemplate",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowTemplatesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "WorkflowTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "WorkflowTemplateAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowType",
            "description": null,
            "args": [
              {
                "name": "id",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "WorkflowType",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowTypes",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "WorkflowTypeFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "options",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "OptionsInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "WorkflowType",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowTypesAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "WorkflowTypeFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "group",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ResourceGroupInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "WorkflowTypeAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Quote",
        "description": "description=A sales quote containing priced work offered to a client.\ndisplayName=Quote\nmodule=Sales\ndefaultQuery=quotes\niconName=th\ncolour=#A91F54\naggregateQuery=quotesAggregate\ngrouping=true\nqueryPermission=Query_Quotes",
        "isOneOf": null,
        "fields": [
          {
            "name": "acceptedAt",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "clientAddress",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "clientName",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "contactName",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currentRevision",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteRevision",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "issuedAt",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Job",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItem",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "LineItem",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "QuoteLine",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteNumber",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplateRevision",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteTemplateRevision",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesTax",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "subTotal",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "total",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "version",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "QuoteAggregate",
        "description": "description=A sales quote containing priced work offered to a client.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "total",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "QuoteApprovalRequestedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "quote",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "QuoteFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "acceptedAt",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "clientAddress",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "clientName",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "contactName",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currentRevision",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "QuoteRevisionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "issuedAt",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteNumber",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplateRevision",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "QuoteTemplateRevisionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesTax",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "subTotal",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "total",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "version",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "QuoteLine",
        "description": "description=A costed line item within a sales quote.\ndisplayName=Quote Line\nmodule=Sales\ndefaultQuery=quoteLines\ncolour=#A91F54\naggregateQuery=quoteLinesAggregate\ngrouping=true\nqueryPermission=Query_Quote_Lines",
        "isOneOf": null,
        "fields": [
          {
            "name": "code",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingRevision",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "CostingRevision",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingRevisionId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobComponent",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "JobComponent",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "line",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineTemplateId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "QuoteLine",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupAmount",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupExpression",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "parentLine",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteLine",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "product",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Product",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "productId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quote",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Quote",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteRevision",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteRevision",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplateRevision",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteTemplateRevision",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "total",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitCostPrice",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitSellPrice",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "QuoteLineAggregate",
        "description": "description=A costed line item within a sales quote.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "QuoteLineFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteLineFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingRevision",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CostingRevisionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingRevisionId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobComponent",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobComponentFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "line",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineTemplateId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupAmount",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupExpression",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteLineFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "parentLine",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "QuoteLineFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "product",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProductFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "productId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quote",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "QuoteFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteRevision",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "QuoteRevisionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplateRevision",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "QuoteTemplateRevisionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "total",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitCostPrice",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitSellPrice",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "QuoteLineInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "costPrice",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costing",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingRevisionId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobComponentId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineTemplateId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteLineInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupExpression",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "product",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "QuoteLineType",
                "ofType": null
              }
            },
            "defaultValue": "NORMAL",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "QuoteLineTemplate",
        "description": "description=A reusable quote line definition used when building quote templates.\ndisplayName=Quote Line Template\nmodule=Sales\ndefaultQuery=quoteLineTemplates\ncolour=#A91F54\naggregateQuery=quoteLineTemplatesAggregate\ngrouping=true\nqueryPermission=Query_Quote_Line_Templates",
        "isOneOf": null,
        "fields": [
          {
            "name": "category",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "descriptionEditable",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupEditable",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupExpression",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantityEditable",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplateRevision",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteTemplateRevision",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitCostPrice",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitCostPriceEditable",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "QuoteLineTemplateAggregate",
        "description": "description=A reusable quote line definition used when building quote templates.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "QuoteLineTemplateFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteLineTemplateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "category",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "descriptionEditable",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupEditable",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupExpression",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteLineTemplateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantityEditable",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplateRevision",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "QuoteTemplateRevisionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitCostPrice",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitCostPriceEditable",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "QuoteLineTemplateInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "category",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": "\"\"",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costPriceEditable",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "descriptionEditable",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupEditable",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "markupExpression",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": "\"\"",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantityEditable",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "QuoteLineType",
                "ofType": null
              }
            },
            "defaultValue": "NORMAL",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitCostPrice",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": "\"0\"",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitCostPriceEditable",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "QuoteLineType",
        "description": null,
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "COMPOSITE",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "NORMAL",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "QuotePreview",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "html",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "QuoteRequestAcceptedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "quoteRequest",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "QuoteRequestPlacedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "quoteRequest",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "QuoteRequestQuotedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "quoteRequest",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "QuoteRevision",
        "description": "description=A saved revision of a quote at a particular point in its lifecycle.\ndisplayName=Quote Revision\nmodule=Sales\ndefaultQuery=quoteRevisions\ncolour=#A91F54\naggregateQuery=quoteRevisionsAggregate\ngrouping=true\nqueryPermission=Query_Quote_Revisions",
        "isOneOf": null,
        "fields": [
          {
            "name": "clientAddress",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "clientName",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "contactName",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "QuoteLine",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quote",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Quote",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesTax",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "subTotal",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "total",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "version",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "QuoteRevisionAggregate",
        "description": "description=A saved revision of a quote at a particular point in its lifecycle.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "QuoteRevisionFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteRevisionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "clientAddress",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "clientName",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "contactName",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "QuoteLineFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteRevisionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quote",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "QuoteFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesTax",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "subTotal",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "total",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "version",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "QuoteStatus",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "QuoteTemplate",
        "description": "description=A reusable sales quoting template for generating quote lines and pricing.\ndisplayName=Quote Template\nmodule=Sales\ndefaultQuery=quoteTemplates\niconName=document\ncolour=#A91F54\naggregateQuery=quoteTemplatesAggregate\ngrouping=true\nqueryPermission=Query_Quote_Templates",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currentRevision",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteTemplateRevision",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "draftRevision",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteTemplateRevision",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isDefault",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "version",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "QuoteTemplateAggregate",
        "description": "description=A reusable sales quoting template for generating quote lines and pricing.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "QuoteTemplateExpression",
        "description": "description=A formula or expression used by quote templates to calculate quote content.\ndisplayName=Quote Template Expression\nmodule=Sales\ndefaultQuery=quoteTemplateExpressions\ncolour=#A91F54\naggregateQuery=quoteTemplateExpressionsAggregate\ngrouping=true\nqueryPermission=Query_Quote_Template_Expressions",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplateRevision",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteTemplateRevision",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplateRevisionId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "value",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "QuoteTemplateExpressionAggregate",
        "description": "description=A formula or expression used by quote templates to calculate quote content.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "QuoteTemplateExpressionFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteTemplateExpressionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteTemplateExpressionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplateRevision",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "QuoteTemplateRevisionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplateRevisionId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "value",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "QuoteTemplateFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteTemplateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currentRevision",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "QuoteTemplateRevisionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isDefault",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteTemplateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "version",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "QuoteTemplatePreview",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "html",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "QuoteTemplateRevision",
        "description": "description=A saved revision of a quote template used to preserve template history.\ndisplayName=Quote Template Revision\nmodule=Sales\ndefaultQuery=quoteTemplateRevisions\ncolour=#A91F54\naggregateQuery=quoteTemplateRevisionsAggregate\ngrouping=true\nqueryPermission=Query_Quote_Template_Revisions",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "defaultLines",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "QuoteLine",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "expressions",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteTemplateExpressionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "QuoteTemplateExpression",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineTemplates",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteLineTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "QuoteLineTemplate",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplate",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "QuoteTemplate",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "QuoteTemplateRevisionStatus",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "version",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "QuoteTemplateRevisionAggregate",
        "description": "description=A saved revision of a quote template used to preserve template history.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "QuoteTemplateRevisionFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteTemplateRevisionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "expressions",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "QuoteTemplateExpressionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineTemplates",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "QuoteLineTemplateFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "QuoteTemplateRevisionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteTemplate",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "QuoteTemplateFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "version",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "QuoteTemplateRevisionStatus",
        "description": "Quote template revision status.",
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "DRAFT",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PUBLISHED",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ReceiveWarehouseStockInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "stock",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "WarehouseStockInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouseId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RecordFile",
        "description": "description=A file attached to a record, including its folder and metadata.\ndisplayName=Record File\nmodule=Admin\ndefaultQuery=recordFiles\niconName=document\ncolour=#5D35A6\naggregateQuery=recordFileAggregates\ngrouping=true\nqueryPermission=Query_Record_Files",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "file",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "File",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "fileId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "folder",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "RecordFolder",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "folderId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isPrimaryImage",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "metadata",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "path",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resourceId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resourceType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RecordFileAggregate",
        "description": "description=A file attached to a record, including its folder and metadata.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RecordFileDeletedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "fileId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RecordFileFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "RecordFileFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "file",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "FileFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "fileId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "folder",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RecordFolderFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "folderId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isPrimaryImage",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "metadata",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JsonFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "RecordFileFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "path",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "primaryImage",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resourceId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resourceType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RecordFilesUploadedEvent",
        "description": "RecordFile",
        "isOneOf": null,
        "fields": [
          {
            "name": "fileCount",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "folderId",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "folderName",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordFileIds",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RecordFolder",
        "description": "description=A native folder belonging to a record; file contents remain in UUID-based storage.\ndisplayName=Record Folder\ndefaultQuery=recordFolders\niconName=folder-close\naggregateQuery=recordFoldersAggregate\ngrouping=true\nqueryPermission=Query_Record_Folders",
        "isOneOf": null,
        "fields": [
          {
            "name": "children",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RecordFolderFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "RecordFolder",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "defaultFolderId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "parentFolder",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "RecordFolder",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "parentFolderId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resourceId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resourceType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RecordFolderAggregate",
        "description": "description=A native folder belonging to a record; file contents remain in UUID-based storage.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RecordFolderFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "RecordFolderFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "children",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RecordFolderFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "defaultFolderId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "RecordFolderFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "parentFolder",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RecordFolderFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "parentFolderId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resourceId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resourceType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RecordNavigationRecord",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "groupLabel",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "RecordType",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "relation",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RecordScreen",
        "description": "description=An application screen assigned directly to a user or role.\ndisplayName=Record Screen\nmodule=Admin\ndefaultQuery=recordScreens\niconName=dashboard\ncolour=#5D35A6\naggregateQuery=recordScreensAggregate\ngrouping=true\nqueryPermission=Query_Record_Screens",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "inheritedFrom",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "record",
            "description": "description=Identity of the user or role assigned to this screen, without loading the destination record.\nsortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "RecordScreenRecordReference",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "RecordScreenType",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "role",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Role",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screen",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Screen",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "source",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "ENUM",
              "name": "RecordSource",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RecordScreenAggregate",
        "description": "description=An application screen assigned directly to a user or role.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RecordScreenFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "RecordScreenFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "RecordScreenFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "role",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RoleFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screen",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ScreenFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RecordScreenRecordReference",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "recordId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "RecordScreenType",
        "description": null,
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "ROLE",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "USER",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "RecordSource",
        "description": null,
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "SYSTEM",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "USER",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RecordTag",
        "description": "description=A tag assignment linking a reusable tag to another record.\ndisplayName=Record Tag\nmodule=Admin\ndefaultQuery=recordTags\niconName=tag\ncolour=#5D35A6\naggregateQuery=recordTagsAggregate\ngrouping=true\nqueryPermission=Query_Record_Tags",
        "isOneOf": null,
        "fields": [
          {
            "name": "colour",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resourceType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "tag",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Tag",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RecordTagAggregate",
        "description": "description=A tag assignment linking a reusable tag to another record.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RecordTagFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "RecordTagFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "colour",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "RecordTagFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resourceType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "tag",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "TagFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "RecordType",
        "description": "All discoverable record type names.",
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "ActAsUser",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Asset",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "AssignedPermission",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "AsyncTask",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "AttachmentTemplate",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "AuditLog",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Batch",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "BatchSchedule",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "BillOfMaterialsImport",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "BillOfMaterialsLine",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Branch",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "BuildType",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Builder",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "BusinessRole",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Candidate",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "CandidateIngestionPolicy",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Client",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ComponentAction",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ComponentGridColumn",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ConfiguredLinkedAction",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Correspondence",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Costing",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "CostingLine",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "CostingLineTemplate",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "CostingRevision",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "CostingTemplate",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "CostingTemplateExpression",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "CostingTemplateRevision",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "CustomData",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "CustomTemplate",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "DataStore",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "DataStoreRecord",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Day",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "DefaultFolder",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "DeliveryAddress",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Designer",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Document",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "DocumentPreview",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "DocumentTemplate",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "EffectivePermission",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Email",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ExternalStorageConnection",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ExternalStorageItem",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ExternalStorageResourceMapping",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "File",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "GroupInstance",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "GroupTemplate",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "HousingCompany",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Issue",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "IssueCompletionStatus",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Job",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "JobComponent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "JobStatus",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "JobStatusEnum",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Lead",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "LeadProjectType",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "LeadProjectTypeEnum",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "LeadSource",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "LeadStatus",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "LeadStatusEnum",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "LineItem",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "LineItemMasterWorkflow",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "LinkedAction",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "LostReason",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Machine",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "MachineType",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Money",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Month",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "NZRegion",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "NotificationAction",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "NotificationTemplate",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PageInfo",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PagedJobs",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PaginatedResult",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Panel",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PartType",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Permission",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PermissionPolicy",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PermissionScope",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Person",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PersonAssignedWork",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PersonBusinessRole",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PersonStatus",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ProcessAsset",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ProcessAssignment",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ProcessInstance",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ProcessTemplate",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ProcessTimer",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ProcessTimerItem",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ProcessType",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ProcessTypeNote",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ProcessTypeRole",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Product",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ProductCategory",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ProductCategoryGroup",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ProductImportUpdateField",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ProductPrice",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Project",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ProjectManager",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PurchaseOrder",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PurchaseOrderEvent",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PurchaseOrderLine",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PurchaseOrderPreview",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PurchaseOrderReceipt",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PurchaseOrderReceiptLine",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PurchaseOrderReview",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PurchaseOrderSavePayload",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "PurchaseOrderStatus",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Quote",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "QuoteLine",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "QuoteLineTemplate",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "QuotePreview",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "QuoteRevision",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "QuoteStatus",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "QuoteTemplate",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "QuoteTemplateExpression",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "QuoteTemplatePreview",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "QuoteTemplateRevision",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "RecordFile",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "RecordFolder",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "RecordNavigationRecord",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "RecordScreen",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "RecordTag",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Region",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Role",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "RoleInheritance",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "RolePermission",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "RoleUser",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SaleType",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SalesOrder",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SalesOrderLine",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Schema",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SchemaType",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SchemaVersion",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Screen",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SignedUploadUrlPayload",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Specification",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SpecificationLookupOption",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Stock",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "StockTransaction",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "StockTransactionLine",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SubscriptionReal",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Supplier",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SupplierCategory",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SupplierQuote",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SupplierQuoteLine",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SupplierQuoteRequest",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SupplierQuoteRequestLine",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Tag",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "TimerTransaction",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Unknown",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "UploadRequestUrl",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "User",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "UserIdentity",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "UserNotification",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "UserPermission",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "UserRole",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Warehouse",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Webhook",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Week",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Workflow",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "WorkflowNode",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "WorkflowNote",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "WorkflowTemplate",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "WorkflowType",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Region",
        "description": "description=A geographic region used for grouping sales and operational records.\ndisplayName=Region\nmodule=Admin\ndefaultQuery=regions\niconName=map\ncolour=#5D35A6\naggregateQuery=regionsAggregate\ngrouping=true\nqueryPermission=Query_Regions",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "nzRegion",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RegionAggregate",
        "description": "description=A geographic region used for grouping sales and operational records.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RegionFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "RegionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "nzRegion",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "RegionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RegionReportDimensionValue",
        "description": "A Region identity or a typed nested report dimension.",
        "isOneOf": null,
        "fields": [
          {
            "name": "key",
            "description": "Stable machine-readable Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "Display label for the Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RegionReportRelationDimensionInput",
        "description": "Groups by Region identity, or traverses to one of its typed dimensions.",
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "filter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RegionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeEmpty",
            "description": "Include filtered related records that have no contributing resource rows.",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ReleasePurchaseOrdersInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "purchaseOrderIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "ReportDateInterval",
        "description": "Calendar interval used by a DateTime report dimension.",
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "DAY",
            "description": "One row per calendar day.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "MONTH",
            "description": "One row per calendar month.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "QUARTER",
            "description": "One row per calendar quarter.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "WEEK",
            "description": "One row per ISO week, starting on Monday.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "YEAR",
            "description": "One row per calendar year.",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ReportDimensionValue",
        "description": "A stable machine-readable dimension key and its display label.",
        "isOneOf": null,
        "fields": [
          {
            "name": "key",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RescheduleBatchesInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "batchScheduleIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ignoreRestrictions",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "scheduled",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ResetUserPasswordInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "password",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ResourceAggregate",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ResourceGroup",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "key",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ResourceGroupByInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "dir",
            "description": null,
            "type": {
              "kind": "ENUM",
              "name": "ResourceGroupDirection",
              "ofType": null
            },
            "defaultValue": "ASC",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "field",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "ResourceGroupDirection",
        "description": null,
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "ASC",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "DESC",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ResourceGroupInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "field",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "key",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ResourceGroupPage",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "items",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ResourceGroup",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "totalCount",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RestorePartTypesInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "partTypeIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RestoreProcessTypesInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "processTypeIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RestoreWorkflowTypesInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "workflowTypeIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ReviseQuoteInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "clientAddress",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "clientName",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "contactName",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "files",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "QuoteLineInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Role",
        "description": "description=An application authorization role assigned to users and inherited by other roles.\ndisplayName=Role\nmodule=Admin\ndefaultQuery=roles\niconName=people\ncolour=#5D35A6\naggregateQuery=rolesAggregate\ngrouping=true\nqueryPermission=Query_Roles",
        "isOneOf": null,
        "fields": [
          {
            "name": "allPermissions",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "AssignedPermissionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AssignedPermission",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "allScreens",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Screen",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedUsers",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RoleUserFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "RoleUser",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "childRoles",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Role",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "inheritFrom",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Role",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "inheritances",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RoleInheritanceFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "RoleInheritance",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "inheritedBy",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RoleInheritanceFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "RoleInheritance",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "inheritedFromName",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "inheritedPermissions",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "AssignedPermissionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AssignedPermission",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "inheritedScreens",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Screen",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ownPermissions",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "AssignedPermissionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AssignedPermission",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ownScreens",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Screen",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "parentRoles",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Role",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screenAggregate",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RecordScreenFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "RecordScreenAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "source",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "RecordSource",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userAggregate",
            "description": "description=The number of users directly assigned to this role.\nsortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RoleUserFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "RoleUserAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "users",
            "description": "description=Users directly assigned to this role or to a child role that inherits it.\nsortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "User",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RoleAggregate",
        "description": "description=An application authorization role assigned to users and inherited by other roles.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RoleCreatedEvent",
        "description": "Role",
        "isOneOf": null,
        "fields": [
          {
            "name": "description",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "inheritedFrom",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RoleDeletedEvent",
        "description": "Role",
        "isOneOf": null,
        "fields": [
          {
            "name": "roleId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RoleDetailsUpdatedEvent",
        "description": "Role",
        "isOneOf": null,
        "fields": [
          {
            "name": "description",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RoleFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "RoleFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedUsers",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RoleUserFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "childRoles",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RoleInheritanceFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "inheritances",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RoleInheritanceFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "inheritedBy",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RoleInheritanceFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "RoleFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "parentRoles",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RoleInheritanceFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleScreens",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RecordScreenFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleUsers",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RoleUserFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "source",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SourceFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RoleInheritance",
        "description": "description=An inheritance edge from a child application role to a parent role.\ndisplayName=Role Inheritance\nmodule=Admin\ndefaultQuery=roleInheritances\niconName=diagram-tree\ncolour=#5D35A6\naggregateQuery=roleInheritancesAggregate\ngrouping=true\nqueryPermission=Query_Role_Inheritances",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "parentId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "parentRole",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Role",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "role",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Role",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RoleInheritanceAggregate",
        "description": "description=An inheritance edge from a child application role to a parent role.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RoleInheritanceAssignmentUpdatedEvent",
        "description": "Role",
        "isOneOf": null,
        "fields": [
          {
            "name": "assignedInheritance",
            "description": null,
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unassignedInheritance",
            "description": null,
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RoleInheritanceFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "RoleInheritanceFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "RoleInheritanceFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "parent",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RoleFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "parentId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "parentRole",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RoleFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "role",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RoleFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RolePermission",
        "description": "description=A permission assigned directly to an application role.\ndisplayName=Role Permission\nmodule=Admin\ndefaultQuery=rolePermissions\niconName=key\ncolour=#5D35A6\naggregateQuery=rolePermissionsAggregate\ngrouping=true\nqueryPermission=Query_Role_Permissions",
        "isOneOf": null,
        "fields": [
          {
            "name": "conditions",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "permission",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Permission",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "policy",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "Policy",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "role",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Role",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RolePermissionAggregate",
        "description": "description=A permission assigned directly to an application role.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RolePermissionFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "RolePermissionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "conditions",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "RolePermissionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "role",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RoleFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RolePermissionsAssignmentUpdatedEvent",
        "description": "Role",
        "isOneOf": null,
        "fields": [
          {
            "name": "assignedPermissions",
            "description": null,
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unassignedPermissions",
            "description": null,
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RoleScreensAssignmentUpdatedEvent",
        "description": "Role",
        "isOneOf": null,
        "fields": [
          {
            "name": "assignedScreens",
            "description": null,
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unassignedScreens",
            "description": null,
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RoleUser",
        "description": "description=A direct assignment of an application role to a user.\ndisplayName=Role User\nmodule=Admin\ndefaultQuery=roleUsers\niconName=people\ncolour=#5D35A6\naggregateQuery=roleUsersAggregate\ngrouping=true\nqueryPermission=Query_Role_Users",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "role",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Role",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RoleUserAggregate",
        "description": "description=A direct assignment of an application role to a user.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RoleUserFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "RoleUserFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "RoleUserFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "role",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RoleFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "RoleUsersAssignmentUpdatedEvent",
        "description": "Role",
        "isOneOf": null,
        "fields": [
          {
            "name": "assignedUserIds",
            "description": null,
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unassignedUserIds",
            "description": null,
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SaleType",
        "description": "description=A sales classification describing how a job or quote was sold.\ndisplayName=Sale Type\nmodule=Sales\ndefaultQuery=saleTypes\ncolour=#A91F54\naggregateQuery=saleTypesAggregate\ngrouping=true\nqueryPermission=Query_Sale_Types",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SaleTypeAggregate",
        "description": "description=A sales classification describing how a job or quote was sold.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SaleTypeFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SaleTypeFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SaleTypeFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SaleTypeReportDimensionValue",
        "description": "A Sale Type identity or a typed nested report dimension.",
        "isOneOf": null,
        "fields": [
          {
            "name": "key",
            "description": "Stable machine-readable Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "Display label for the Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SaleTypeReportRelationDimensionInput",
        "description": "Groups by Sale Type identity, or traverses to one of its typed dimensions.",
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "filter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SaleTypeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeEmpty",
            "description": "Include filtered related records that have no contributing resource rows.",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SalesOrder",
        "description": "description=A sales order accepted for client work.\ndisplayName=Sales Order\nmodule=Sales\ndefaultQuery=salesOrders\niconName=shopping-cart\ncolour=#A91F54\naggregateQuery=salesOrdersAggregate\ngrouping=true\nqueryPermission=Query_Sales_Orders",
        "isOneOf": null,
        "fields": [
          {
            "name": "client",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Client",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "clientAddress",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "clientName",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "confirmedAt",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "contactName",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currency",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Job",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SalesOrderLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SalesOrderLine",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesOrderNumber",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesTax",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "subTotal",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "total",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SalesOrderAggregate",
        "description": "description=A sales order accepted for client work.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SalesOrderFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SalesOrderFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "client",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ClientFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "clientAddress",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "clientName",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "confirmedAt",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "contactName",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currency",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SalesOrderLineFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SalesOrderFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesOrderNumber",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesTax",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "subTotal",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "total",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SalesOrderLine",
        "description": "description=A product or service line on a sales order.\ndisplayName=Sales Order Line\nmodule=Sales\ndefaultQuery=salesOrderLines\ncolour=#A91F54\naggregateQuery=salesOrderLinesAggregate\ngrouping=true\nqueryPermission=Query_Sales_Order_Lines",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobComponent",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "JobComponent",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "line",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineTotal",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesOrder",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "SalesOrder",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sourceQuote",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Quote",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sourceQuoteLine",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteLine",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sourceQuoteRevision",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "QuoteRevision",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unit",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitSellPrice",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SalesOrderLineFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SalesOrderLineFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobComponent",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobComponentFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "line",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineTotal",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SalesOrderLineFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesOrder",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SalesOrderFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sourceQuote",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "QuoteFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sourceQuoteLine",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "QuoteLineFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sourceQuoteRevision",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "QuoteRevisionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unit",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitSellPrice",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SalesOrderLineInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobComponentId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sourceQuoteId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sourceQuoteLineId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sourceQuoteRevisionId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unit",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitSellPrice",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Schema",
        "description": "description=A custom form schema and its published and draft versions.\ndisplayName=Schema\nmodule=Admin\ndefaultQuery=schemas\niconName=form\ncolour=#5D35A6\naggregateQuery=schemasAggregate\ngrouping=true\nqueryPermission=Query_Schemas",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "latestVersion",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "SchemaVersion",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "versions",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SchemaVersionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SchemaVersion",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SchemaAggregate",
        "description": "description=A custom form schema and its published and draft versions.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SchemaCreatedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "schema",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SchemaDeletedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "schema",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchemaFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SchemaFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "latestVersion",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SchemaVersionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SchemaFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "versions",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SchemaVersionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SchemaType",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchemaTypeFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SchemaUpdatedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "schema",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SchemaVersion",
        "description": "description=A version of a custom form and its data definition.\ndisplayName=Schema Version\nmodule=Admin\ndefaultQuery=schemaVersions\niconName=form\ncolour=#5D35A6\naggregateQuery=schemaVersionsAggregate\ngrouping=true\nqueryPermission=Query_Schema_Versions",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "dataDefinition",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "extra",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "formDefinition",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "latestActive",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "schema",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Schema",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "schemaId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "version",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "versionNo",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SchemaVersionActiveEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "schemaVersion",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SchemaVersionAggregate",
        "description": "description=A version of a custom form and its data definition.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SchemaVersionCreatedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "schemaVersion",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SchemaVersionDeletedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "schemaVersion",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchemaVersionFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SchemaVersionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "dataDefinition",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "extra",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "formDefinition",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "latestActive",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SchemaVersionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "schema",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SchemaFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "schemaId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "version",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "versionNo",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchemaVersionInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "dataSchema",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "formSchema",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "schemaId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SchemaVersionUpdatedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "schemaVersion",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Screen",
        "description": "description=An application screen definition made from one or more panels.\ndisplayName=Screen\nmodule=Admin\ndefaultQuery=screens\niconName=dashboard\ncolour=#5D35A6\naggregateQuery=screensAggregate\ngrouping=true\nqueryPermission=Query_Screens",
        "isOneOf": null,
        "fields": [
          {
            "name": "assignmentAggregate",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RecordScreenFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "RecordScreenAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "group",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "icon",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resolvedScreenCfg",
            "description": "sortable=true\ngroupable=false",
            "args": [
              {
                "name": "recordId",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "recordType",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roles",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Role",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screenCfg",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "source",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ScreenAggregate",
        "description": "description=An application screen definition made from one or more panels.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ScreenAssignmentInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "roleIds",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screenId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userIds",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ScreenCreatedEvent",
        "description": "Screen",
        "isOneOf": null,
        "fields": [
          {
            "name": "screenCfg",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screenId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screenName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ScreenDeletedEvent",
        "description": "Screen",
        "isOneOf": null,
        "fields": [
          {
            "name": "screenId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screenName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ScreenFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ScreenFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "icon",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ScreenFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screenCfg",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "ScreenGroup",
        "description": null,
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "ACCOUNTS",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ADMIN",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "INSTALLATION",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "INVENTORY",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "MAINTENANCE",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "MANUFACTURING",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SALES",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ScreenUnassignmentInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "recordScreenIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screenId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "ScreenUpdatedEvent",
        "description": "Screen",
        "isOneOf": null,
        "fields": [
          {
            "name": "screenCfg",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screenGroup",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screenId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screenName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SetCandidateIngestionPolicyInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "candidateType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "emailAddresses",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "mode",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "CandidateIngestionMode",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "senderRecordId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "senderRecordType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SetConfiguredLinkedActionInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "actionId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "bindings",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "displayOrder",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "enabled",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isGlobal",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordPath",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SetCustomDataInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "data",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "schemaId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "upgradeSchema",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SetDefaultFolderInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "allowedMimeTypes",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "enabled",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "true",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SetFavouriteLinkedActionInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "actionId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordPath",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SetLinkedActionRecipientInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "assigned",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "linkedActionId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SetUserPinInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "pin",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SignedUploadUrlPayload",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "fileId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "uploadToken",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "uploadUrl",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SortInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "dir",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "field",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SourceFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "eq",
            "description": null,
            "type": {
              "kind": "ENUM",
              "name": "RecordSource",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notEq",
            "description": null,
            "type": {
              "kind": "ENUM",
              "name": "RecordSource",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Specification",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SpecificationLookupOption",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "value",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "StatusChangedEvent",
        "description": "PurchaseOrderReview",
        "isOneOf": null,
        "fields": [
          {
            "name": "comment",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderReviewId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "review",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reviewerUserName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "StatusUpdatedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "quoteRequestEmail",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Stock",
        "description": "description=Current inventory quantities and values for products in warehouses.\ndisplayName=Stock\nmodule=Inventory\ndefaultQuery=stock\niconName=package\ncolour=#596600\naggregateQuery=stockAggregate\ngrouping=true\nqueryPermission=Query_Stock",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "product",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Product",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "totalCostPrice",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Money",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouse",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Warehouse",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "StockAggregate",
        "description": "description=Current inventory quantities and values for products in warehouses.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "totalCostPrice",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "totalQuantity",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "StockFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "StockFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "StockFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "product",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProductFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouse",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "WarehouseFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "StockTakeCreatedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "stockTakeId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "StockTransaction",
        "description": "description=An inventory movement that receives, transfers, adjusts, or withdraws stock.\ndisplayName=Stock Transaction\nmodule=Inventory\ndefaultQuery=stockTransactions\ncolour=#596600\naggregateQuery=stockTransactionsAggregate\ngrouping=true\nqueryPermission=Query_Stock_Transactions",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "StockTransactionLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "StockTransactionLine",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "StockTransactionType",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouse",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Warehouse",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "StockTransactionAggregate",
        "description": "description=An inventory movement that receives, transfers, adjusts, or withdraws stock.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "totalCostPrice",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "totalQuantity",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "StockTransactionCreatedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "stockTransactionId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "StockTransactionFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "StockTransactionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StockTransactionLineFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "StockTransactionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouse",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "WarehouseFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "StockTransactionLine",
        "description": "description=A product quantity movement within an inventory stock transaction.\ndisplayName=Stock Transaction Line\nmodule=Inventory\ndefaultQuery=stockTransactionLines\ncolour=#596600\naggregateQuery=stockTransactionLinesAggregate\ngrouping=true\nqueryPermission=Query_Stock_Transaction_Lines",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "product",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Product",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stockTransaction",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "StockTransaction",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "StockTransactionLineAggregate",
        "description": "description=A product quantity movement within an inventory stock transaction.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "StockTransactionLineFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "StockTransactionLineFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "StockTransactionLineFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "product",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProductFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stockTransaction",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StockTransactionFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "StockTransactionType",
        "description": "Inventory stock transaction type.",
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "Receive",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "StockTake",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Transfer",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "Withdraw",
            "description": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "SCALAR",
        "name": "String",
        "description": "The `String` scalar type represents textual data, represented as UTF-8 character sequences. The String type is most often used by GraphQL to represent free-form human-readable text.",
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "StringFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "endsWith",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "eq",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "in",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "like",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "likeAll",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "neq",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notIn",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "startsWith",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SubmitPurchaseOrderReviewInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "comment",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrderId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "review",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "OrderReviewStatus",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Subscription",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "dummySubscription",
            "description": "A placeholder query used by thecodingmachine/graphqlite when there are no declared subscriptions.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SubscriptionReal",
        "description": "description=An event subscription defining notification recipients and templates.\ndisplayName=Subscription\nmodule=Admin\ndefaultQuery=subscriptions\niconName=notifications\ncolour=#5D35A6\naggregateQuery=subscriptionsAggregate\ngrouping=true\nqueryPermission=Query_Subscriptions",
        "isOneOf": null,
        "fields": [
          {
            "name": "channels",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "enabled",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "event",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "maxRecipients",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notificationTemplates",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "NotificationTemplateFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "NotificationTemplate",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sourceFilter",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "targetFilter",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SubscriptionRealAggregate",
        "description": "description=An event subscription defining notification recipients and templates.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SubscriptionRealFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SubscriptionRealFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "channels",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "enabled",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "event",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "maxRecipients",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notificationTemplates",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NotificationTemplateFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SubscriptionRealFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sourceFilter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "targetFilter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Supplier",
        "description": "description=A supplier that provides products or services for purchasing and inventory.\ndisplayName=Supplier\nmodule=Inventory\ndefaultQuery=suppliers\niconName=shop\ncolour=#596600\naggregateQuery=suppliersAggregate\ngrouping=true\nqueryPermission=Query_Suppliers",
        "isOneOf": null,
        "fields": [
          {
            "name": "address",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "category",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "SupplierCategory",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "cell",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currency",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "email",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "image",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "File",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "numberOfReviews",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderEmails",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "productAggregate",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProductFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "ProductAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "products",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProductFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Product",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantityThreshold",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteEmails",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reviewType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reviewers",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "User",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "url",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SupplierAggregate",
        "description": "description=A supplier that provides products or services for purchasing and inventory.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SupplierCategory",
        "description": "description=An inventory category used to group suppliers.\ndisplayName=Supplier Category\nmodule=Inventory\ndefaultQuery=supplierCategories\niconName=tag\ncolour=#596600\naggregateQuery=supplierCategoriesAggregate\ngrouping=true\nqueryPermission=Query_Supplier_Categories",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SupplierCategoryAggregate",
        "description": "description=An inventory category used to group suppliers.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SupplierCategoryFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierCategoryFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierCategoryFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SupplierCreatedEvent",
        "description": "Supplier",
        "isOneOf": null,
        "fields": [
          {
            "name": "supplierId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SupplierDeletedEvent",
        "description": "Supplier",
        "isOneOf": null,
        "fields": [
          {
            "name": "supplierId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SupplierDetailsUpdatedEvent",
        "description": "Supplier",
        "isOneOf": null,
        "fields": [
          {
            "name": "address",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "category",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "cell",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currency",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "email",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderEmails",
            "description": null,
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteEmails",
            "description": null,
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "url",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SupplierFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "address",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "category",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SupplierCategoryFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "cell",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currency",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "email",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "image",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "FileFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "numberOfReviews",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "products",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProductFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantityThreshold",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reviewType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "url",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SupplierQuote",
        "description": "description=A priced offer received from a supplier.\ndisplayName=Supplier Quote\nmodule=Inventory\ndefaultQuery=supplierQuotes\niconName=document\ncolour=#596600\naggregateQuery=supplierQuotesAggregate\ngrouping=true\nqueryPermission=Query_Supplier_Quotes",
        "isOneOf": null,
        "fields": [
          {
            "name": "costingLines",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CostingLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "CostingLine",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currency",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Job",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierQuoteLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SupplierQuoteLine",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteRequest",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "SupplierQuoteRequest",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesTax",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "subTotal",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplier",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Supplier",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierAddress",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierName",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuoteNumber",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "total",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SupplierQuoteAggregate",
        "description": "description=A priced offer received from a supplier.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SupplierQuoteFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierQuoteFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "costingLines",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CostingLineFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currency",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SupplierQuoteLineFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierQuoteFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteRequest",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SupplierQuoteRequestFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesTax",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "subTotal",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplier",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SupplierFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierAddress",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierName",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuoteNumber",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "total",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SupplierQuoteLine",
        "description": "description=A product or service line offered on a supplier quote.\ndisplayName=Supplier Quote Line\nmodule=Inventory\ndefaultQuery=supplierQuoteLines\ncolour=#596600\naggregateQuery=supplierQuoteLinesAggregate\ngrouping=true\nqueryPermission=Query_Supplier_Quote_Lines",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "line",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "product",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Product",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuote",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "SupplierQuote",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "total",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitPrice",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SupplierQuoteLineFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierQuoteLineFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "line",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierQuoteLineFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "product",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProductFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuote",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SupplierQuoteFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "total",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitPrice",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SupplierQuoteLineInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "productId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitPrice",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SupplierQuoteRequest",
        "description": "description=A request sent to a supplier for pricing on products or services.\ndisplayName=Supplier Quote Request\nmodule=Inventory\ndefaultQuery=supplierQuoteRequests\niconName=send-message\ncolour=#596600\naggregateQuery=supplierQuoteRequestsAggregate\ngrouping=true\nqueryPermission=Query_Quote_Requests",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Job",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierQuoteRequestLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SupplierQuoteRequestLine",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "noteForSupplier",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplier",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Supplier",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SupplierQuoteRequestAggregate",
        "description": "description=A request sent to a supplier for pricing on products or services.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SupplierQuoteRequestFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierQuoteRequestFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "job",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "JobFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SupplierQuoteRequestLineFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "noteForSupplier",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierQuoteRequestFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplier",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SupplierFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SupplierQuoteRequestLine",
        "description": "description=A product or service line included in a supplier quote request.\ndisplayName=Supplier Quote Request Line\nmodule=Inventory\ndefaultQuery=supplierQuoteRequestLines\ncolour=#596600\naggregateQuery=supplierQuoteRequestLinesAggregate\ngrouping=true\nqueryPermission=Query_Quote_Request_Lines",
        "isOneOf": null,
        "fields": [
          {
            "name": "code",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "line",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "product",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Product",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteRequest",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "SupplierQuoteRequest",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unit",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SupplierQuoteRequestLineAggregate",
        "description": "description=A product or service line included in a supplier quote request.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SupplierQuoteRequestLineFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierQuoteRequestLineFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "line",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SupplierQuoteRequestLineFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "product",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProductFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteRequest",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SupplierQuoteRequestFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unit",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SupplierQuoteRequestLineInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "line",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SupplierReviewersUpdatedEvent",
        "description": "Supplier",
        "isOneOf": null,
        "fields": [
          {
            "name": "numberOfReviews",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantityThreshold",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reviewType",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "SupplierStatusUpdatedEvent",
        "description": "PurchaseOrder",
        "isOneOf": null,
        "fields": [
          {
            "name": "orderId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Tag",
        "description": "description=A reusable label that can be attached to supported records.\ndisplayName=Tag\nmodule=Admin\ndefaultQuery=tags\niconName=tag\ncolour=#5D35A6\naggregateQuery=tagsAggregate\ngrouping=true\nqueryPermission=Query_Tags",
        "isOneOf": null,
        "fields": [
          {
            "name": "colour",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resourceType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "TagAggregate",
        "description": "description=A reusable label that can be attached to supported records.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "TagFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "TagFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "colour",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "TagFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resourceType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "TemplateCreatedEvent",
        "description": "DocumentTemplate",
        "isOneOf": null,
        "fields": [
          {
            "name": "templateId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "templateName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "TemplateDeletedEvent",
        "description": "DocumentTemplate",
        "isOneOf": null,
        "fields": [
          {
            "name": "templateId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "templateName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "TemplateUpdatedEvent",
        "description": "DocumentTemplate",
        "isOneOf": null,
        "fields": [
          {
            "name": "templateId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "templateName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "TimerTransaction",
        "description": "description=A start and stop interval recorded against a process timer.\ndisplayName=Timer Transaction\nmodule=Manufacturing\ndefaultQuery=timerTransactions\niconName=timer\ncolour=#A96500\naggregateQuery=timerTransactionsAggregate\ngrouping=true\nqueryPermission=Query_Timer_Transactions",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "start",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stop",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "timer",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessTimer",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "TimerTransactionAggregate",
        "description": "description=A start and stop interval recorded against a process timer.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "TimerTransactionFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "TimerTransactionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "TimerTransactionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "start",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stop",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "timer",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessTimerFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "TransferWarehouseStockInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "destinationWarehouseId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sourceWarehouseId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stock",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "WarehouseStockInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "TriggerWebhookInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "recordId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "webhookId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UnassignBusinessRolesFromPersonInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "personBusinessRoleIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UnassignInheritanceFromRoleInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "roleId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleInheritanceIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UnassignLeadsFromSalespersonInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "leadIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UnassignPermissionsFromRoleInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "roleId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "rolePermissionIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UnassignPermissionsFromUserInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "userId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userPermissionIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UnassignRolesFromUserInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "roleIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UnassignScreensFromRoleInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "recordScreenIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UnassignScreensFromUserInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "recordScreenIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UnassignUsersFromRoleInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "roleId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UnmarkJobLostInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "jobId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UnmarkLeadLostInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "leadId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateBatchDetailsInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "batchId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "cubicMetres",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sheets",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateBranchInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "branchId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "colour",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "darkColour",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateBuilderInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "address",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateBusinessRoleInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "businessRoleId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateClientInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "address",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "email",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "faxHome",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "faxWork",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "firstName",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lastName",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notes",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "phoneCell",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "phoneHome",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "phoneWork",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "title",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateCorrespondenceInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "date",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "details",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateCostingInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "costingId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobComponentId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CostingLineInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": "[]",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateDocumentTemplateInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "query",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sampleDataOverride",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "template",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "templateId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateDraftPurchaseOrderInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "category",
            "description": null,
            "type": {
              "kind": "ENUM",
              "name": "OrderCategory",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deliveryAddress",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deliveryAddressId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "internalComment",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderLineInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notifySupplierWhenPlaced",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "required",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "shippingMethod",
            "description": null,
            "type": {
              "kind": "ENUM",
              "name": "OrderShippingMethods",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "shippingTerms",
            "description": null,
            "type": {
              "kind": "ENUM",
              "name": "OrderShippingTerms",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "siteVisitRequired",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "statusWhenPlaced",
            "description": null,
            "type": {
              "kind": "ENUM",
              "name": "OrderStatus",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierComment",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "templateId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "urgent",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouseId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateDraftSchemaVersionInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "dataSchema",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "formSchema",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateHousingCompanyInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateIssueInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "completed",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "requiredDate",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateJobBuilderInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "builderId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "builderPhone",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "hcJobNumber",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "hcPmPhone",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "hcProjectManager",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "housingCompanyId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateJobClientInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "client",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateJobComponentInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobComponentId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "partTypeId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateJobDetailsInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "benchtopOnly",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branch",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "buildType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "designer",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "estimatedDueDate",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobName",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notes",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "projectManager",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "saleType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "showHome",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sssp",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "tristoneJoin",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "tristoneSpecified",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateJobNoteInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "jobId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notes",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateJobSiteInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "address",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "difficultAccess",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "region",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "siteNotes",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unit",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateLeadInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "address",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedTo",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branchId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "builderName",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "builderType",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "city",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "client",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "email",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "joineryTypes",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notes",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "phone",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "priceRangeBottom",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "priceRangeTop",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "priority",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "defaultValue": "0",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "projectType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "requiredBy",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "source",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "suburb",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateLineItemInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "lineItemId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateLineItemWorkflowInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "lineItemId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "placeholders",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "LineItemWorkflowPlaceholderInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": "[]",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowTemplateId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateLostReasonInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lostReasonId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdatePanelConfigInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "config",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "panelId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdatePanelDetailsInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "panelId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "tags",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdatePartTypeInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "colour",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "partTypeId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdatePermissionForRoleInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "permission",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "PermissionInput",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "rolePermissionId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdatePermissionForUserInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "permission",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "PermissionInput",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userPermissionId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdatePersonInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "isActive",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "personId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateProcessInstanceDetailsInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "assignedHours",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadDays",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processInstanceId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateProcessInstanceStatusInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "processInstanceId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateProcessTypeDetailsInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTypeId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateProcessTypeNoteInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "assignedProcessIds",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "date",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "note",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTypeNoteId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateProcessTypeRoleInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "processTypeId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTypeRoleId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateProductCategoryInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "group",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "parentId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateProductDetailsInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "category",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "indent",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "leadTime",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "productIds",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "qtyReviewThreshold",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "safetyStockDays",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "starred",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stockItem",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplier",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "tags",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "template",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unitOfMeasure",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "url",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdatePurchaseOrderInternalCommentInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "internalComment",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "purchaseOrderId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateQuoteInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "clientAddress",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "clientName",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "contactName",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customer",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "files",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "QuoteLineInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateRoleDetailsInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roleId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateSalesOrderInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "clientAddress",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "clientId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "clientName",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "contactName",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currency",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": "\"NZD\"",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SalesOrderLineInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesOrderId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateSchemaDetailsInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateScreenConfigInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screenCfg",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screenId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateScreenDetailsInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "icon",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screenGroup",
            "description": null,
            "type": {
              "kind": "ENUM",
              "name": "ScreenGroup",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "screenId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateSettingsInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "settings",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateStorageConnectionInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deviceAccessEnabled",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "dropboxAuthToken",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "dropboxNamespaceId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "enabled",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "localRoot",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "root",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateStorageResourceMappingInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "enabled",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "externalStorageConnectionId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "path",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resourceFilter",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resourceMappingId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "resourceType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateSubscriptionInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "enabled",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "event",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "maxRecipients",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "notifications",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "NotificationInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": "[]",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sourceFilter",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "subscriptionId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "targetFilter",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateSupplierDetailsInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "address",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "categoryId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "cell",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "currency",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "email",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "orderEmails",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteEmails",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "url",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateSupplierQuoteInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "files",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": "[]",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "jobId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SupplierQuoteLineInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": "[]",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quoteRequestId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "salesTax",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": "\"\"",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "saveAsDraft",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuoteId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuoteNumber",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateSupplierQuoteRequestInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "files",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": "[]",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lines",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SupplierQuoteRequestLineInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "noteForSupplier",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "place",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reference",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "supplierQuoteRequestId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateSupplierReviewersInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "numberOfReviews",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantityThreshold",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reviewType",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reviewers",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateTagInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "colour",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "context",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateUserDetailsInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "authProvider",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "AuthProviderType",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branchId",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "fullName",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "username",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateUserSubscriptionsInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "subscriptions",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateWarehouseInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "address",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "color",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateWebhookInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "authType",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "enabled",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "event",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sourceFilter",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "url",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateWorkflowTypeDetailsInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "master",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowTypeId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "UploadRequestUrl",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "headers",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "method",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "url",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "User",
        "description": "description=A system user account with application roles, identities, permissions, and screen access.\ndisplayName=User\nmodule=Admin\ndefaultQuery=users\niconName=user\ncolour=#5D35A6\naggregateQuery=usersAggregate\ngrouping=true\nqueryPermission=Query_Users",
        "isOneOf": null,
        "fields": [
          {
            "name": "allPermissions",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "AssignedPermissionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AssignedPermission",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "allScreens",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Screen",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedRoles",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "RoleUserFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "RoleUser",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "authProvider",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "authProviderUid",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branch",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Branch",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "email",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "firebaseAuthId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "fullName",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "hasPin",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "identities",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "UserIdentityFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UserIdentity",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "inheritedPermissions",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "AssignedPermissionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AssignedPermission",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "inheritedScreens",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Screen",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "initials",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isActive",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ownPermissions",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "AssignedPermissionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AssignedPermission",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ownScreens",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Screen",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "roles",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Role",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "timers",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessTimerFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProcessTimer",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "username",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "UserAggregate",
        "description": "description=A system user account with application roles, identities, permissions, and screen access.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "UserCreatedEvent",
        "description": "User",
        "isOneOf": null,
        "fields": [
          {
            "name": "userId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "UserDeletedEvent",
        "description": "User",
        "isOneOf": null,
        "fields": [
          {
            "name": "userId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "UserDisabledEvent",
        "description": "User",
        "isOneOf": null,
        "fields": [
          {
            "name": "userId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "UserEnabledEvent",
        "description": "User",
        "isOneOf": null,
        "fields": [
          {
            "name": "userId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UserFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "UserFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "assignedRoles",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RoleUserFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "authProvider",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "authProviderUid",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branch",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BranchFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "email",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "fullName",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "hasPersonIdentity",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "hasPin",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "identities",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserIdentityFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeSystem",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isActive",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isCurrent",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "oldRoles",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserRoleFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "UserFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "reviewedSuppliers",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SupplierFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "timers",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessTimerFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "username",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "UserIdentity",
        "description": "description=A link between a system user and the domain record that user represents.\ndisplayName=User Identity\nmodule=Admin\ndefaultQuery=userIdentities\niconName=id-number\ncolour=#5D35A6\naggregateQuery=userIdentitiesAggregate\ngrouping=true\nqueryPermission=Query_User_Identities",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "entity",
            "description": "description=The schema type of the represented record.\nsortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "person",
            "description": "description=The person represented by a Person identity.\nsortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "Person",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordLabel",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "UserIdentityAggregate",
        "description": "description=A link between a system user and the domain record that user represents.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UserIdentityFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "UserIdentityFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "entity",
            "description": "The schema type of the represented record.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "UserIdentityFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "person",
            "description": "The person represented by a Person identity.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PersonFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordLabel",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "UserNotification",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "initialPath",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "initialTab",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordId",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "text",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "timestamp",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "title",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unread",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "UserPermission",
        "description": "description=A permission assigned directly to an application user.\ndisplayName=User Permission\nmodule=Admin\ndefaultQuery=userPermissions\niconName=key\ncolour=#5D35A6\naggregateQuery=userPermissionsAggregate\ngrouping=true\nqueryPermission=Query_User_Permissions",
        "isOneOf": null,
        "fields": [
          {
            "name": "conditions",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "permission",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "Permission",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "policy",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "Policy",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "UserPermissionAggregate",
        "description": "description=A permission assigned directly to an application user.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UserPermissionFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "UserPermissionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "conditions",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "UserPermissionFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "UserPermissionsUpdatedEvent",
        "description": "User",
        "isOneOf": null,
        "fields": [
          {
            "name": "assignedPermissions",
            "description": null,
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unassignedPermissions",
            "description": null,
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "UserReportDimensionValue",
        "description": "A User identity or a typed nested report dimension.",
        "isOneOf": null,
        "fields": [
          {
            "name": "branch",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "BranchReportDimensionValue",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "key",
            "description": "Stable machine-readable Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "Display label for the Resource identity.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UserReportGroupByInput",
        "description": "Select exactly one typed User report dimension.",
        "isOneOf": true,
        "fields": null,
        "inputFields": [
          {
            "name": "branch",
            "description": "Group by Branch or one of its dimensions.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BranchReportRelationDimensionInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UserReportRelationDimensionInput",
        "description": "Groups by User identity, or traverses to one of its typed dimensions.",
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "filter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groupBy",
            "description": "Traverse through this relation and group by a field or relation on the related Resource.",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserReportGroupByInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "includeEmpty",
            "description": "Include filtered related records that have no contributing resource rows.",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "UserRestoredEvent",
        "description": "User",
        "isOneOf": null,
        "fields": [
          {
            "name": "userId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "UserRole",
        "description": "description=A legacy operational role type attached to a user for workflow assignments.\ndisplayName=Legacy User Role\nmodule=Admin\ndefaultQuery=legacyUserRoles\niconName=person\ncolour=#5D35A6\naggregateQuery=legacyUserRolesAggregate\ngrouping=true\nqueryPermission=Query_Legacy_User_Roles",
        "isOneOf": null,
        "fields": [
          {
            "name": "businessRole",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "BusinessRole",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processAssignments",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ProcessAssignmentFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProcessAssignment",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "UserRoleAggregate",
        "description": "description=A legacy operational role type attached to a user for workflow assignments.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UserRoleFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "UserRoleFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "businessRole",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BusinessRoleFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "UserRoleFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processAssignments",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessAssignmentFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "user",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "UserRolesUpdatedEvent",
        "description": "User",
        "isOneOf": null,
        "fields": [
          {
            "name": "assignedRoles",
            "description": null,
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unassignedRoles",
            "description": null,
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "UserScreensUpdatedEvent",
        "description": "User",
        "isOneOf": null,
        "fields": [
          {
            "name": "assignedScreens",
            "description": null,
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "unassignedScreens",
            "description": null,
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "UserUpdatedEvent",
        "description": "User",
        "isOneOf": null,
        "fields": [
          {
            "name": "authProvider",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "branch",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "fullName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "userName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "SCALAR",
        "name": "Void",
        "description": "The `Void` scalar type represents no value being returned.",
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Warehouse",
        "description": "description=A warehouse or stock location used to hold inventory products.\ndisplayName=Warehouse\nmodule=Inventory\ndefaultQuery=warehouses\niconName=office\ncolour=#596600\naggregateQuery=warehousesAggregate\ngrouping=true\nqueryPermission=Query_Warehouses",
        "isOneOf": null,
        "fields": [
          {
            "name": "address",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "color",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stock",
            "description": "sortable=false\ngroupable=true",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "StockFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Stock",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stockAggregate",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "StockFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "StockAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WarehouseAggregate",
        "description": "description=A warehouse or stock location used to hold inventory products.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WarehouseCreatedEvent",
        "description": "Warehouse",
        "isOneOf": null,
        "fields": [
          {
            "name": "warehouseId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouseName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WarehouseDeletedEvent",
        "description": "Warehouse",
        "isOneOf": null,
        "fields": [
          {
            "name": "warehouseId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouseName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "WarehouseFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "address",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "WarehouseFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "code",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "color",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "WarehouseFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stock",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StockFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "WarehouseStockInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "productId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "quantity",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WarehouseStockReceivedEvent",
        "description": "Warehouse",
        "isOneOf": null,
        "fields": [
          {
            "name": "stock",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouseId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouseName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WarehouseStockTakeEvent",
        "description": "Warehouse",
        "isOneOf": null,
        "fields": [
          {
            "name": "countedStock",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stockDelta",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouseId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouseName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "WarehouseStockTakeInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "stock",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "WarehouseStockInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouseId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WarehouseStockTransferReceivedEvent",
        "description": "Warehouse",
        "isOneOf": null,
        "fields": [
          {
            "name": "receivedWarehouseId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "receivedWarehouseName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stock",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "withdrawnWarehouseId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "withdrawnWarehouseName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WarehouseStockTransferWithdrawnEvent",
        "description": "Warehouse",
        "isOneOf": null,
        "fields": [
          {
            "name": "receivedWarehouseId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "receivedWarehouseName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stock",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "withdrawnWarehouseId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "withdrawnWarehouseName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WarehouseStockWithdrawnEvent",
        "description": "Warehouse",
        "isOneOf": null,
        "fields": [
          {
            "name": "stock",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouseId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouseName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WarehouseUpdatedEvent",
        "description": "Warehouse",
        "isOneOf": null,
        "fields": [
          {
            "name": "warehouseId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouseName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Webhook",
        "description": "description=An outbound webhook configured for an event and source filter.\ndisplayName=Webhook\nmodule=Admin\ndefaultQuery=webhooks\niconName=data-connection\ncolour=#5D35A6\naggregateQuery=webhooksAggregate\ngrouping=true\nqueryPermission=Query_Webhooks",
        "isOneOf": null,
        "fields": [
          {
            "name": "authType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "enabled",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "event",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "recordType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sourceFilter",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "url",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WebhookAggregate",
        "description": "description=An outbound webhook configured for an event and source filter.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WebhookCallFailedEvent",
        "description": "Webhook",
        "isOneOf": null,
        "fields": [
          {
            "name": "error",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "statusCode",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "url",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "webhookId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WebhookCalledEvent",
        "description": "Webhook",
        "isOneOf": null,
        "fields": [
          {
            "name": "response",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "url",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "webhookId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WebhookCreatedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "webhook",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WebhookDeletedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "webhook",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "WebhookFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "WebhookFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "authType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "enabled",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "event",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "WebhookFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "sourceFilter",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "url",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WebhookUpdatedEvent",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "webhook",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Week",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "createdLeadAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "LeadFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "LeadAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createdPurchaseOrderAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createdPurchaseOrderLineAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PurchaseOrderLineFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "PurchaseOrderLineAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "stockTransactionAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "StockTransactionFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "StockTransactionAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "weekNumber",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "weekNumberAndYear",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "year",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "WeekFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "date",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": "null",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "WithdrawWarehouseStockInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "stock",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "WarehouseStockInput",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "warehouseId",
            "description": null,
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "Workflow",
        "description": "description=A workflow containing the process and group nodes for manufacturing work.\ndisplayName=Workflow\nmodule=Manufacturing\niconName=data-lineage\ncolour=#A96500\ngrouping=true\nqueryPermission=Query_Line_Item_Master_Workflows",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "WorkflowType",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "WorkflowFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "WorkflowFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "WorkflowFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "WorkflowTypeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WorkflowNode",
        "description": "description=A process, group, or workflow node and its dependencies.\ndisplayName=Workflow Node\nmodule=Manufacturing\niconName=data-lineage\ncolour=#A96500\ngrouping=true\nqueryPermission=Query_Line_Item_Master_Workflows",
        "isOneOf": null,
        "fields": [
          {
            "name": "children",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemMasterWorkflow",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "LineItemMasterWorkflow",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "nodeType",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "owner",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "parents",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "WorkflowNodeFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "WorkflowNodeFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "lineItemMasterWorkflow",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LineItemMasterWorkflowFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "nodeType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "WorkflowNodeFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "owner",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LineItemMasterWorkflowFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NumberFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WorkflowNote",
        "description": "description=A note assigned directly to a workflow node.\ndisplayName=Workflow Note\nmodule=Manufacturing\ndefaultQuery=workflowNotes\niconName=message-square-text\ncolour=#A96500\naggregateQuery=workflowNotesAggregate\ngrouping=true\nqueryPermission=Query_Workflow_Notes",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createdBy",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "nodeId",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processInstance",
            "description": "sortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "ProcessInstance",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processType",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ProcessType",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WorkflowNoteAggregate",
        "description": "description=A note assigned directly to a workflow node.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "WorkflowNoteFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "WorkflowNoteFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "createdBy",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "nodeId",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "WorkflowNoteFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processInstance",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessInstanceFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ProcessTypeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WorkflowTemplate",
        "description": "description=A reusable workflow definition that can be assigned to workflow subjects.\ndisplayName=Workflow Template\nmodule=Manufacturing\ndefaultQuery=workflowTemplates\niconName=data-lineage\ncolour=#A96500\naggregateQuery=workflowTemplatesAggregate\ngrouping=true\nqueryPermission=Query_Workflow_Templates",
        "isOneOf": null,
        "fields": [
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "display",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "placeHolder",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "placeholders",
            "description": "description=Placeholder workflow selections required by this template.\nsortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "WorkflowTemplatePlaceholder",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "previewGroupInstances",
            "description": "description=Workflow diagram group label data for previewing this template.\nsortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "WorkflowTemplatePreviewGroupInstance",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "previewItems",
            "description": "description=Workflow diagram item data for previewing this template.\nsortable=false\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "WorkflowTemplatePreviewItem",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "valid",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowType",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "WorkflowType",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WorkflowTemplateAggregate",
        "description": "description=A reusable workflow definition that can be assigned to workflow subjects.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "WorkflowTemplateFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "WorkflowTemplateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "display",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "WorkflowTemplateFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "placeHolder",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "valid",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowType",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "WorkflowTypeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WorkflowTemplatePlaceholder",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "description",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "display",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "options",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "WorkflowTemplatePlaceholderOption",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WorkflowTemplatePlaceholderOption",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "description",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "display",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "placeholders",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "WorkflowTemplatePlaceholder",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "previewGroupInstances",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "WorkflowTemplatePreviewGroupInstance",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "previewItems",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "WorkflowTemplatePreviewItem",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WorkflowTemplatePreviewGroupInstance",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflow",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "WorkflowTemplatePreviewGroupWorkflow",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WorkflowTemplatePreviewGroupWorkflow",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "WorkflowTemplatePreviewWorkflowType",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WorkflowTemplatePreviewItem",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "children",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "nodeType",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "owner",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "parents",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "processTypeId",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "status",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WorkflowTemplatePreviewWorkflowType",
        "description": null,
        "isOneOf": null,
        "fields": [
          {
            "name": "id",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WorkflowType",
        "description": "description=A manufacturing workflow definition made up of ordered process steps.\ndisplayName=Workflow Type\nmodule=Manufacturing\ndefaultQuery=workflowTypes\niconName=data-lineage\ncolour=#A96500\naggregateQuery=workflowTypesAggregate\ngrouping=true\nqueryPermission=Query_Workflow_Types",
        "isOneOf": null,
        "fields": [
          {
            "name": "created",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": "sortable=false\ngroupable=false",
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomData",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "master",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": "sortable=true\ngroupable=true",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": "sortable=true\ngroupable=false",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WorkflowTypeAggregate",
        "description": "description=A manufacturing workflow definition made up of ordered process steps.",
        "isOneOf": null,
        "fields": [
          {
            "name": "count",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customDataAggregate",
            "description": null,
            "args": [
              {
                "name": "filter",
                "description": null,
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CustomDataFilterInput",
                  "ofType": null
                },
                "defaultValue": "null",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "OBJECT",
              "name": "CustomDataAggregate",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "groups",
            "description": null,
            "args": [
              {
                "name": "by",
                "description": null,
                "type": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResourceGroupByInput",
                    "ofType": null
                  }
                },
                "defaultValue": null,
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "limit",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "100",
                "isDeprecated": false,
                "deprecationReason": null
              },
              {
                "name": "offset",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                },
                "defaultValue": "0",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceGroupPage",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WorkflowTypeCreatedEvent",
        "description": "WorkflowType",
        "isOneOf": null,
        "fields": [
          {
            "name": "workflowTypeId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowTypeName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WorkflowTypeDeletedEvent",
        "description": "WorkflowType",
        "isOneOf": null,
        "fields": [
          {
            "name": "workflowTypeId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowTypeName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "WorkflowTypeFilterInput",
        "description": null,
        "isOneOf": false,
        "fields": null,
        "inputFields": [
          {
            "name": "and",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "WorkflowTypeFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "created",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "customData",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CustomDataFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deleted",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "id",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IDFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isNull",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "label",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "master",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BooleanFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "modified",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DateTimeFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "StringFilterInput",
              "ofType": null
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "or",
            "description": null,
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "WorkflowTypeFilterInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "interfaces": null,
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WorkflowTypeRestoredEvent",
        "description": "WorkflowType",
        "isOneOf": null,
        "fields": [
          {
            "name": "workflowTypeId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowTypeName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "WorkflowTypeUpdatedEvent",
        "description": "WorkflowType",
        "isOneOf": null,
        "fields": [
          {
            "name": "workflowTypeId",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "workflowTypeName",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "__Directive",
        "description": "A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.\n\nIn some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.",
        "isOneOf": null,
        "fields": [
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isRepeatable",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "locations",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "ENUM",
                    "name": "__DirectiveLocation",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "args",
            "description": null,
            "args": [
              {
                "name": "includeDeprecated",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Boolean",
                  "ofType": null
                },
                "defaultValue": "false",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "__InputValue",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "__DirectiveLocation",
        "description": "A Directive can be adjacent to many parts of the GraphQL language, a __DirectiveLocation describes one such possible adjacencies.",
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "QUERY",
            "description": "Location adjacent to a query operation.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "MUTATION",
            "description": "Location adjacent to a mutation operation.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SUBSCRIPTION",
            "description": "Location adjacent to a subscription operation.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "FIELD",
            "description": "Location adjacent to a field.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "FRAGMENT_DEFINITION",
            "description": "Location adjacent to a fragment definition.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "FRAGMENT_SPREAD",
            "description": "Location adjacent to a fragment spread.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "INLINE_FRAGMENT",
            "description": "Location adjacent to an inline fragment.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "VARIABLE_DEFINITION",
            "description": "Location adjacent to a variable definition.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SCHEMA",
            "description": "Location adjacent to a schema definition.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "SCALAR",
            "description": "Location adjacent to a scalar definition.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "OBJECT",
            "description": "Location adjacent to an object type definition.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "FIELD_DEFINITION",
            "description": "Location adjacent to a field definition.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ARGUMENT_DEFINITION",
            "description": "Location adjacent to an argument definition.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "INTERFACE",
            "description": "Location adjacent to an interface definition.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "UNION",
            "description": "Location adjacent to a union definition.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ENUM",
            "description": "Location adjacent to an enum definition.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ENUM_VALUE",
            "description": "Location adjacent to an enum value definition.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "INPUT_OBJECT",
            "description": "Location adjacent to an input object type definition.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "INPUT_FIELD_DEFINITION",
            "description": "Location adjacent to an input object field definition.",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "__EnumValue",
        "description": "One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string.",
        "isOneOf": null,
        "fields": [
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isDeprecated",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deprecationReason",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "__Field",
        "description": "Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type.",
        "isOneOf": null,
        "fields": [
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "args",
            "description": null,
            "args": [
              {
                "name": "includeDeprecated",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Boolean",
                  "ofType": null
                },
                "defaultValue": "false",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "__InputValue",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "__Type",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isDeprecated",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deprecationReason",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "__InputValue",
        "description": "Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value.",
        "isOneOf": null,
        "fields": [
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "type",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "__Type",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "defaultValue",
            "description": "A GraphQL-formatted string representing the default value for this input value.",
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isDeprecated",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "deprecationReason",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "__Schema",
        "description": "A GraphQL Schema defines the capabilities of a GraphQL server. It exposes all available types and directives on the server, as well as the entry points for query, mutation, and subscription operations.",
        "isOneOf": null,
        "fields": [
          {
            "name": "description",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "types",
            "description": "A list of all types supported by this server.",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "__Type",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "queryType",
            "description": "The type that query operations will be rooted at.",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "OBJECT",
                "name": "__Type",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "mutationType",
            "description": "If this server supports mutation, the type that mutation operations will be rooted at.",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "__Type",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "subscriptionType",
            "description": "If this server support subscription, the type that subscription operations will be rooted at.",
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "__Type",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "directives",
            "description": "A list of all directives supported by this server.",
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "LIST",
                "name": null,
                "ofType": {
                  "kind": "NON_NULL",
                  "name": null,
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "__Directive",
                    "ofType": null
                  }
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "OBJECT",
        "name": "__Type",
        "description": "The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.\n\nDepending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.",
        "isOneOf": null,
        "fields": [
          {
            "name": "kind",
            "description": null,
            "args": [],
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "ENUM",
                "name": "__TypeKind",
                "ofType": null
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "name",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "description",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "specifiedByURL",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "fields",
            "description": null,
            "args": [
              {
                "name": "includeDeprecated",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Boolean",
                  "ofType": null
                },
                "defaultValue": "false",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "__Field",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "interfaces",
            "description": null,
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "__Type",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "possibleTypes",
            "description": null,
            "args": [],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "__Type",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "enumValues",
            "description": null,
            "args": [
              {
                "name": "includeDeprecated",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Boolean",
                  "ofType": null
                },
                "defaultValue": "false",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "__EnumValue",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "inputFields",
            "description": null,
            "args": [
              {
                "name": "includeDeprecated",
                "description": null,
                "type": {
                  "kind": "SCALAR",
                  "name": "Boolean",
                  "ofType": null
                },
                "defaultValue": "false",
                "isDeprecated": false,
                "deprecationReason": null
              }
            ],
            "type": {
              "kind": "LIST",
              "name": null,
              "ofType": {
                "kind": "NON_NULL",
                "name": null,
                "ofType": {
                  "kind": "OBJECT",
                  "name": "__InputValue",
                  "ofType": null
                }
              }
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ofType",
            "description": null,
            "args": [],
            "type": {
              "kind": "OBJECT",
              "name": "__Type",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "isOneOf",
            "description": null,
            "args": [],
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "inputFields": null,
        "interfaces": [],
        "enumValues": null,
        "possibleTypes": null
      },
      {
        "kind": "ENUM",
        "name": "__TypeKind",
        "description": "An enum describing what kind of type a given `__Type` is.",
        "isOneOf": null,
        "fields": null,
        "inputFields": null,
        "interfaces": null,
        "enumValues": [
          {
            "name": "SCALAR",
            "description": "Indicates this type is a scalar.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "OBJECT",
            "description": "Indicates this type is an object. `fields` and `interfaces` are valid fields.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "INTERFACE",
            "description": "Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "UNION",
            "description": "Indicates this type is a union. `possibleTypes` is a valid field.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "ENUM",
            "description": "Indicates this type is an enum. `enumValues` is a valid field.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "INPUT_OBJECT",
            "description": "Indicates this type is an input object. `inputFields` is a valid field.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "LIST",
            "description": "Indicates this type is a list. `ofType` is a valid field.",
            "isDeprecated": false,
            "deprecationReason": null
          },
          {
            "name": "NON_NULL",
            "description": "Indicates this type is a non-null. `ofType` is a valid field.",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ],
        "possibleTypes": null
      }
    ],
    "directives": [
      {
        "name": "deprecated",
        "description": "Marks an element of a GraphQL schema as no longer supported.",
        "isRepeatable": false,
        "locations": [
          "ARGUMENT_DEFINITION",
          "ENUM_VALUE",
          "FIELD_DEFINITION",
          "INPUT_FIELD_DEFINITION"
        ],
        "args": [
          {
            "name": "reason",
            "description": "Explains why this element was deprecated, usually also including a suggestion for how to access supported similar data. Formatted using the Markdown syntax, as specified by [CommonMark](https://commonmark.org/).",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "\"No longer supported\"",
            "isDeprecated": false,
            "deprecationReason": null
          }
        ]
      },
      {
        "name": "include",
        "description": "Directs the executor to include this field or fragment only when the `if` argument is true.",
        "isRepeatable": false,
        "locations": [
          "FIELD",
          "FRAGMENT_SPREAD",
          "INLINE_FRAGMENT"
        ],
        "args": [
          {
            "name": "if",
            "description": "Included when true.",
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ]
      },
      {
        "name": "oneOf",
        "description": "Indicates exactly one field must be supplied and this field must not be `null`.",
        "isRepeatable": false,
        "locations": [
          "INPUT_OBJECT"
        ],
        "args": []
      },
      {
        "name": "skip",
        "description": "Directs the executor to skip this field or fragment when the `if` argument is true.",
        "isRepeatable": false,
        "locations": [
          "FIELD",
          "FRAGMENT_SPREAD",
          "INLINE_FRAGMENT"
        ],
        "args": [
          {
            "name": "if",
            "description": "Skipped when true.",
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ]
      },
      {
        "name": "specifiedBy",
        "description": "Exposes a URL that specifies the behavior of this scalar.",
        "isRepeatable": false,
        "locations": [
          "SCALAR"
        ],
        "args": [
          {
            "name": "url",
            "description": "The URL that specifies the behavior of this scalar.",
            "type": {
              "kind": "NON_NULL",
              "name": null,
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "defaultValue": null,
            "isDeprecated": false,
            "deprecationReason": null
          }
        ]
      }
    ]
  }
}